import React, { useEffect, useState,useRef } from 'react';
import './index.css';
import { setOptions, importLibrary } from "@googlemaps/js-api-loader";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import logo1 from '../Images/logo1.jpeg'
import { FaMapPin, FaRegBellSlash, FaRegCalendarAlt, FaRegClock, FaUserCircle } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { FaIdBadge, FaUser, FaPhone, FaEnvelope, FaInstagram, FaTwitter, FaFacebook, FaPlus, FaBuilding, FaBriefcase, FaGlobe, FaBox, FaIndustry } from 'react-icons/fa';
import axios from 'axios';
import { Alert, Button, Col, Container, Form, FormControl, InputGroup, Nav, Navbar, NavDropdown, Row, Spinner, Table } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { FaRegBell } from "react-icons/fa";
import Modal from 'react-modal';
import Select from 'react-select';
import { FiSearch } from 'react-icons/fi';
import { PDFDownloadLink } from '@react-pdf/renderer';
import MeetingAttendancePDF from './MeetingAttendancePDF';
import InvitationStatsPDF from './InvitationStatsPDF'; // adjust path
import ThanksNoteStatsPDF from './ThanksNoteStatsPDF';
import ReferralStatsPDF from './ReferralStatsPDF';
import {  FaBars, FaTimes } from "react-icons/fa";
Modal.setAppElement('#root'); // to bind modal to root element for accessibility


const customIcon = L.icon({
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});


// Recenter map when search coordinates change
// MUST BE OUTSIDE AdminDashboard:

function LeafletMapPicker({ position, onLocationChange }) {
  const mapContainerRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const markerRef = useRef(null);

  // Initialize Map
  useEffect(() => {
    if (!mapContainerRef.current) return;

    // Guard against multiple initializations
    if (!mapInstanceRef.current) {
      const initialLat = Number(position.lat) || 17.385;
      const initialLng = Number(position.lng) || 78.4867;

      const map = L.map(mapContainerRef.current).setView([initialLat, initialLng], 14);

      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      }).addTo(map);

      // Create draggable marker
      const marker = L.marker([initialLat, initialLng], {
        icon: customIcon,
        draggable: true,
      }).addTo(map);

      // Map click event
      map.on("click", (e) => {
        const { lat, lng } = e.latlng;
        marker.setLatLng([lat, lng]);
        onLocationChange(lat, lng);
      });

      // Marker drag event
      marker.on("dragend", (e) => {
        const { lat, lng } = e.target.getLatLng();
        onLocationChange(lat, lng);
      });

      mapInstanceRef.current = map;
      markerRef.current = marker;

      // Fix modal render sizing
      setTimeout(() => {
        map.invalidateSize();
      }, 250);
    }

    return () => {
      if (mapInstanceRef.current) {
        mapInstanceRef.current.remove();
        mapInstanceRef.current = null;
      }
    };
  }, []);

  // Sync position updates (e.g. from search suggestions)
  useEffect(() => {
    if (mapInstanceRef.current && markerRef.current && position.lat && position.lng) {
      const lat = Number(position.lat);
      const lng = Number(position.lng);
      markerRef.current.setLatLng([lat, lng]);
      mapInstanceRef.current.setView([lat, lng], 16);
    }
  }, [position.lat, position.lng]);

  return (
    <div
      ref={mapContainerRef}
      style={{
        height: "280px",
        width: "100%",
        borderRadius: "10px",
        border: "1px solid #cbd5e1",
      }}
    />
  );
}

function GoogleMapPicker({ onLocationSelect, initialPosition }) {
  const mapRef = useRef(null);
  const searchInputRef = useRef(null);
  const markerRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;

    // 1. Configure the API options using the new functional API
    setOptions({
      key: "AIzaSyAmGcPTfePx1WqX-8bqlPno6-5hU_GE9uA", // <-- Paste your Google Maps API key here
      v: "weekly",
    });

    const initMap = async () => {
      try {
        // 2. Import libraries asynchronously
        const { Map } = await importLibrary("maps");
        const { AdvancedMarkerElement } = await importLibrary("marker");
        const { Autocomplete } = await importLibrary("places");
        const { Geocoder } = await importLibrary("geocoding");

        if (!isMountedRef.current || !mapRef.current) return;

        const defaultCenter = initialPosition || {
          lat: 17.385044,
          lng: 78.486671,
        }; // Hyderabad default

        // 3. Initialize Map (mapId is required for AdvancedMarkerElement)
        const map = new Map(mapRef.current, {
          center: defaultCenter,
          zoom: 14,
          mapId: "DEMO_MAP_ID", // Required by Google for modern markers
          mapTypeControl: false,
          streetViewControl: false,
        });
        mapInstanceRef.current = map;

        // 4. Initialize Draggable Marker
        const marker = new AdvancedMarkerElement({
          map: map,
          position: defaultCenter,
          gmpDraggable: true,
        });
        markerRef.current = marker;

        const geocoder = new Geocoder();

        const updateCoordinatesAndAddress = (latLng, customName = null) => {
          const lat = typeof latLng.lat === "function" ? latLng.lat() : latLng.lat;
          const lng = typeof latLng.lng === "function" ? latLng.lng() : latLng.lng;

          if (customName) {
            onLocationSelect({
              venueName: customName,
              latitude: Number(lat).toFixed(6),
              longitude: Number(lng).toFixed(6),
              mapUrl: `https://www.google.com/maps?q=${lat},${lng}`,
            });
          } else {
            geocoder.geocode({ location: { lat, lng } }, (results, status) => {
              const formattedAddress =
                status === "OK" && results?.[0]
                  ? results[0].formatted_address
                  : `Location (${Number(lat).toFixed(4)}, ${Number(lng).toFixed(4)})`;

              onLocationSelect({
                venueName: formattedAddress,
                latitude: Number(lat).toFixed(6),
                longitude: Number(lng).toFixed(6),
                mapUrl: `https://www.google.com/maps?q=${lat},${lng}`,
              });
            });
          }
        };

        // 5. Autocomplete (India biased)
        if (searchInputRef.current) {
          const autocomplete = new Autocomplete(searchInputRef.current, {
            componentRestrictions: { country: "in" },
            fields: ["geometry", "name", "formatted_address"],
          });

          autocomplete.bindTo("bounds", map);

          autocomplete.addListener("place_changed", () => {
            const place = autocomplete.getPlace();

            if (!place.geometry || !place.geometry.location) return;

            const loc = place.geometry.location;
            map.setCenter(loc);
            map.setZoom(16);
            marker.position = loc;

            const venueTitle = place.name
              ? `${place.name}, ${place.formatted_address || ""}`
              : place.formatted_address;

            updateCoordinatesAndAddress(loc, venueTitle);
          });
        }

        // 6. Click on Map -> Move Marker
        map.addListener("click", (e) => {
          marker.position = e.latLng;
          updateCoordinatesAndAddress(e.latLng);
        });

        // 7. Drag Marker -> Update Coordinates
        marker.addListener("dragend", () => {
          const pos = marker.position;
          updateCoordinatesAndAddress(pos);
        });
      } catch (err) {
        console.error("Google Maps load failed:", err);
      }
    };

    initMap();

    return () => {
      isMountedRef.current = false;
    };
  }, []);

  return (
    <div style={{ marginBottom: "15px" }}>
      <label style={{ display: "block", fontWeight: "bold", marginBottom: "6px" }}>
        Search Venue or Click on Map:
      </label>

      <input
        ref={searchInputRef}
        type="text"
        placeholder="Search hotel, banquet hall, or area (e.g. Minerva Grand, Secunderabad)..."
        style={{
          width: "100%",
          padding: "10px",
          borderRadius: "8px",
          border: "1px solid #cbd5e1",
          fontSize: "14px",
          marginBottom: "10px",
          boxSizing: "border-box",
        }}
      />

      <div
        ref={mapRef}
        style={{
          width: "100%",
          height: "280px",
          borderRadius: "10px",
          border: "1px solid #cbd5e1",
        }}
      />
      <small style={{ color: "#64748b", marginTop: "4px", display: "block" }}>
        📍 Click anywhere or drag the pin to set the exact meeting location.
      </small>
    </div>
  );
}



const AdminDashboard = ({ ratings }) => {
  const [showLogout, setShowLogout] = useState(false);
  const navigate = useNavigate()
  const [currentPage, setCurrentPage] = useState(1);
  const usersPerPage = 10

  const [currentPage11, setCurrentPage11] = useState(1);
  const usersPerPage1 = 5

  const [currentPage11Event, setCurrentPage11Event] = useState(1);
  const usersPerPage1Event = 5


  const [currentPage12, setCurrentPage12] = useState(1);
  const usersPerPage12 = 5

  // event 

  const [currentPage12Event, setCurrentPage12Event] = useState(1);
  const usersPerPage12Event = 5

  const [currentPage13, setCurrentPage13] = useState(1);
  const usersPerPage13 = 5

  const [currentPage13Event, setCurrentPage13Event] = useState(1);
  const usersPerPage13Event = 5


  const [users, setUsers] = useState([])
  const [userss, setUserss] = useState([])
  const [loading, setLoading] = useState(true); // To manage loading state
  const [error, setError] = useState(null);



       const [chapter, setChapter] = useState([]);
         const emailchapter = sessionStorage.getItem('email'); 
    console.log('emailchapter',emailchapter)

    const fetchChapter = async () => {
      try {
        const res = await axios.get('https://api.lbnhyderabad.com/admin-dashboard/chapters');
        
        // Filter chapters based on email and then extract only the 'chapter' field
        const filteredChapters = res.data
          .filter(ch => ch.email === emailchapter) // Filter based on email
          .map(ch => ch.chapter); // Extract only the 'chapter' field
  
        if (filteredChapters.length > 0) {
          setChapter(filteredChapters[0]);  // Set the first (and only) chapter as the value
        } else {
          setError('No chapters found for this email.');
        }
      } catch (err) {
        console.error('Error fetching chapters:', err);
        setError('Failed to fetch chapters.');
      }
    };
  
  
    useEffect(() => {
      if (emailchapter) {
        fetchChapter();  // Fetch chapters if email exists in sessionStorage
      } else {
        setError('Email not found in session storage.');
      }
    }, [emailchapter]);  // Dependency array ensures the effect runs when emailchapter changes
  
    console.log('this is chapters', chapter);  

  const fetchUsers = async () => {
    try {
      const response = await axios.get('https://api.lbnhyderabad.com/admin-dashboard'); // Change the URL accordingly
      setUsers(response.data); // Set the users state with the data
    } catch (err) {
      setError('Error fetching users data'); // Set error state
      console.error(err);
    } finally {
      setLoading(false); // Set loading to false after fetching
    }
  };


  useEffect(() => {
    // Function to fetch users data from API

    fetchUsers();
  }, []);

  // Toggle logout button visibility
  const handleIconClick = () => {
    setShowLogout((prevState) => !prevState); // Toggle state
  };

  // Logout function (for demo purposes)
  const handleLogout = () => {
    alert("You have logged out!");
    sessionStorage.clear()
    navigate('/');
    // Add logic to handle logout (e.g., clearing session, redirecting)
  };

  const [filteredUsers, setFilteredUsers] = useState(users);
  const [adminfilteredUsers, setAdminFilteredUsers] = useState(users);
  
  const [adminfilteredUsersEvent, setAdminFilteredUsersEvent] = useState(users);


  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);  // Get current page users

  // const indexOfLastUser1 = currentPage11 * usersPerPage1;
  // const indexOfFirstUser1 = indexOfLastUser1 - usersPerPage1;
  // const currentUsers1 = adminfilteredUsers.slice(indexOfFirstUser1, indexOfLastUser1);  // Get current page users

  const totalPages = Math.ceil(filteredUsers.length / usersPerPage);  // Total pages
  // const totalPages11 = Math.ceil(adminfilteredUsers.length / usersPerPage1);  // Total pages



  const handlePageChange = (page) => {
    setCurrentPage(page);  // Set the current page

  };


  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);  // Go to next page

    }
  };
  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);  // Go to previous page

    }
  };

  // this is from meeting page  

  const handlePageChange11 = (page) => {

    setCurrentPage11(page)
  };


  const handleNextPage11 = () => {
    if (currentPage11 < totalPages11) {

      setCurrentPage11(currentPage11 + 1)
    }
  };

  const handlePrevPage11 = () => {
    if (currentPage11 > 1) {

      setCurrentPage11(currentPage11 - 1)
    }
  };
  // Event Pagination

   const handleNextPage11Event = () => {
    if (currentPage11Event < totalPages11Event) {

      setCurrentPage11Event(currentPage11Event + 1)
    }
  };

  const handlePrevPage11Event = () => {
    if (currentPage11Event > 1) {

      setCurrentPage11Event(currentPage11Event - 1)
    }
  };


  //this is invitation 
  const [invitationsget, setInvitationsget] = useState([]);

  // this state for event 

  
  const [invitationsgetEvent, setInvitationsgetEvent] = useState([]);

  //check in the line 1840
  // const indexOfLastUser12 = currentPage12 * usersPerPage12;
  // const indexOfFirstUser12 = indexOfLastUser12 - usersPerPage12;
  // const currentUsers12 = invitationsget.slice(indexOfFirstUser12, indexOfLastUser12);  // Get current page users


  // const totalPages12 = Math.ceil(invitationsget.length / usersPerPage12);  // Total pages




  const handleNextPage12 = () => {
    if (currentPage12 < totalPages11) {

      setCurrentPage12(currentPage12 + 1)
    }
  };

  const handlePrevPage12 = () => {
    if (currentPage12 > 1) {

      setCurrentPage12(currentPage12 - 1)
    }
  };

  // event pagination

    const handleNextPage12Event = () => {
    if (currentPage12Event < totalPages11Event) {

      setCurrentPage12Event(currentPage12Event + 1)
    }
  };

  const handlePrevPage12Event = () => {
    if (currentPage12Event > 1) {

      setCurrentPage12Event(currentPage12Event - 1)
    }
  };



  const [approvalStatus, setApprovalStatus] = useState('Not Approved');
  const [isApproving, setIsApproving] = useState(false);




  const handleApprove = async ({ userEmail, userName, id }) => {
    try {
      setIsApproving(true);
      setApprovalStatus(`Approved: ${userName} (${userEmail})`);
      //setUserApprovalStatus(userId, 'Approved'); 


      setUsers(prevUsers =>
        prevUsers.map(user =>
          user.id === id ? { ...user, isApprove: 1 } : user  // Update the user's approval status
        )
      );


      const response = await axios.post('https://api.lbnhyderabad.com/admin-dashboard/approve', {
        email: userEmail,
        name: userName
      });

      if (response.status === 200) {
        // Update the approval status on successful response
        alert(`You have approved ${userName} (${userEmail})`);


        fetchUsers();
        setApprovalStatus('Approved');
      } else {
        alert('Error: Something went wrong!');
      }
    } catch (error) {
      console.error('Error approving user:', error);
      alert('Error: Could not approve the user');
    } finally {
      setIsApproving(false); // Hide loading indicator
    }
  };

  // Function to update the approval status of a user in the state
  // const setUserApprovalStatus = (userId, status) => {
  //   setUsers(prevUsers =>
  //     prevUsers.map(user =>
  //       user.id === userId ? { ...user, isApprove: status === 'Approved' ? 1 : 0 } : user
  //     )
  //   );
  // };


  const [productss, setProducts] = useState([]);

  console.log(productss)

  // const handleView = ({ userEmail }) => {
  //   console.log('Fetching data for user:', userEmail); // Log the email to make sure it's being passed properly.

  //   setLoading(true);  // Start loading
  //   setError(null);    // Clear previous errors

  //   fetch(`https://api.lbnhyderabad.com/product/show-product-date?userEmail=${userEmail}`, {
  //     method: 'GET', // Using GET to retrieve data
  //     headers: {
  //       'Content-Type': 'application/json',
  //     },
  //   })
  //     .then(response => {
  //       console.log('Response Status:', response.status);  // Log the response status
  //       if (!response.ok) {
  //         throw new Error('Network response was not ok');
  //       }
  //       return response.json();  // Parse JSON response
  //     })
  //     .then(data => {
  //       console.log('Fetched Data:', data);  // Log the response data
  //       setProducts(data);  // Update the products state with the fetched data
  //       setLoading(false);  // Stop loading
  //     })
  //     .catch(err => {
  //       console.error('Error fetching product data:', err);  // Log errors
  //       setError("Error fetching product data.");  // Handle errors
  //       setLoading(false);  // Stop loading
  //     });
  // };

  // useEffect(() => {
  //   // Make the GET request to the backend API
  //   axios.get('https://api.lbnhyderabad.com/product/showAll')
  //     .then((response) => {
  //       setProducts(response.data); // Update products state
  //       setLoading(false); // Set loading to false
  //     })
  //     .catch((error) => {
  //       console.log(error); // Log any error that occurs during the request
  //       setLoading(false); // Stop loading even if there is an error
  //     });
  // }, []);
  const fetchDataProduct = async () => {
    try {
      const response = await axios.get('https://api.lbnhyderabad.com/product/showAll');
      setProducts(response.data); // Update state with products
    } catch (error) {
      console.log(error); // Log any errors
    } finally {
      setLoading(false); // Set loading to false regardless of success or failure
    }
  };

  useEffect(() => {
    fetchDataProduct(); // Call fetchDataProduct when component mounts
  }, []);

  const [allProducts, setAllProducts] = useState([]);


  const fetchRatings = (productId) => {
    return axios.get(`https://api.lbnhyderabad.com/product/products/${productId}/ratings`)
      .then(response => response.data)
      .catch(error => {
        console.error('Error fetching ratings:', error);
        return []; // Return empty array if error occurs
      });
  };

  // const fetchProducts = () => {
  //   axios
  //     .get("https://api.lbnhyderabad.com/product/show-all-data")
  //     .then((response) => {



  //       setAllProducts(response.data);


  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       setError("Failed to fetch data");
  //       setLoading(false);
  //     });
  // };
  const fetchProducts = async () => {
    try {
      // Fetch products from the API
      const response = await axios.get('https://api.lbnhyderabad.com/product/show-all-data');

      // If data contains products, start processing

      // Fetch ratings for each product in parallel using Promise.all
      const updatedProducts = await Promise.all(
        response.data.map(async (product) => {
          const ratings = await fetchRatings(product.id); // Fetch ratings asynchronously
          return {
            ...product,
            ratings, // Attach fetched ratings to the product
          };
        })
      );

      setAllProducts(updatedProducts); // Set products with ratings




    } catch (error) {
      console.error('Error fetching products:', error);
      setAllProducts([]); // Set empty products on error
    } finally {
      setLoading(false); // Set loading to false after fetching is done
    }
  };



  const renderStars = (rating) => {
    const stars = [];
    for (let i = 0; i < 5; i++) {
      stars.push(i < rating ? '★' : '☆');
    }
    return stars.join(''); // Joins all the stars together, with filled or empty ones
  };

  console.log(ratings)

  const calculateAverageRating = (ratings) => {

    if (!ratings || ratings.length === 0) return 0;
    const total = ratings.reduce((acc, rating) => acc + rating.rating, 0);
    return (total / ratings.length) // Return average rating with 1 decimal place
  };


  const averageRating = calculateAverageRating(ratings);


  useEffect(() => {
    fetchProducts();

  }, []);



  const handleViewUser = ({ userEmail }) => {
    console.log('Fetching data for user:', userEmail);  // Log the email to ensure it's passed

    setLoading(true);  // Set loading to true while fetching
    setError(null);  // Clear previous errors

    // Fetch data from the backend API using the provided userEmail
    fetch(`https://api.lbnhyderabad.com/signup/get/${userEmail}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }
        return response.json();
      })
      .then(data => {
        setUserss(data); // Set the user data in the state (wrap in an array since the backend returns an object)
        setLoading(false);  // Stop loading
      })
      .catch(err => {
        setError("Error fetching user data: " + err.message); // Set error message in case of failure
        setLoading(false);  // Stop loading
      });
  };


  const [modalOpen, setModalOpen] = useState(false); // State to control modal visibility


  // Function to handle the modal close
  const closeModal = () => {
    setModalOpen(false); // Close the modal
  };

  // Function to open the modal
  const openModal = () => {
    setModalOpen(true); // Open the modal
  };


  // const handleApproveProduct = ({ productId }) => {
  //   console.log("Approving product with ID:", productId);

  //   // Making a PUT request to the backend to approve the product
  //   fetch(`https://api.lbnhyderabad.com/product/approve-product/${productId}`, {
  //     method: 'PUT',
  //     headers: {
  //       'Content-Type': 'application/json',
  //     },
  //   })
  //     .then(response => response.json())  // Parse JSON response
  //     .then(data => {
  //       if (data.message === 'Product approved successfully') {
  //         alert('Product approved successfully');
  //         // Optionally update UI (e.g., update product state to reflect approval)
  //       } else {
  //         console.error('Failed to approve product');
  //       }
  //     })
  //     .catch(err => {
  //       console.error("Error approving product:", err);
  //     });
  // };
  const handleApproveProduct = ({ productId, productss }) => {
    console.log(productss)
    console.log("Approving product with ID:", productId);

    // Making a PUT request to the backend to approve the product with additional product details
    fetch(`https://api.lbnhyderabad.com/product/approve-product/${productId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ productss }) // send the additional product details
    })
      .then(response => response.json())  // Parse JSON response
      .then(data => {
        if (data.message === 'Product approved successfully') {
          alert('Product approved successfully');
          // setProducts([]);
          fetchProducts();
          sessionStorage.setItem('activeSection', 'products');  // Save it before reload
          window.location.reload();         // Then reload

          // Optionally update UI (e.g., update product state to reflect approval)
        } else {
          console.error('Failed to approve product');
        }
      })
      .catch(err => {
        console.error("Error approving product:", err);
      });
  };


  const [searchTerm, setSearchTerm] = useState(''); // State to track search term
  // State to store filtered users

  // Update the filtered users whenever the search term changes
  console.log('this is users', users)
  useEffect(() => {
    if (searchTerm.trim() === '') {
      console.log('this is users', users)
      setFilteredUsers(users); // Show all users if no search term
      setAdminFilteredUsers(users)
      setAdminFilteredUsersEvent(users)

    } else {
      const filtered = users.filter(user =>
        user?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user?.email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user?.mobile?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        user?.membershipNo?.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setAdminFilteredUsers(filtered);
      setAdminFilteredUsersEvent(filtered);
      setFilteredUsers(filtered); // Set the filtered list based on the search term
    }
  }, [searchTerm, users]);

  // const [activeSection, setActiveSection] = useState("dashboard"); 
  const [activeSection, setActiveSection] = useState(() => {
    // Check if there's a saved active section in sessionStorage
    const savedSection = sessionStorage.getItem('activeSection');
    return savedSection || 'dashboard';  // Default to 'dashboard' if nothing is saved
  });

  useEffect(() => {
    // Clear sessionStorage after the page reload, so it's not persisted next time
    sessionStorage.removeItem('activeSection');
  }, []);



  const [isNavbarCollapsed, setIsNavbarCollapsed] = useState(true);

  const handleNavClick = (section) => {
    setActiveSection(section);
    setIsNavbarCollapsed(true);
  };



  const [modalIsOpenn, setModalIsOpenn] = useState(false);
  const [date, setDate] = useState(null);
  const [time, setTime] = useState('');
  const [venue, setVenue] = useState('');
  const [events, setEvent] = useState('');







  const openModall = () => setModalIsOpenn(true);
  const closeModall = () => setModalIsOpenn(false);


  const [modalIsOpen, setModalIsOpen] = useState(false);

  const openModallAtt = () => setModalIsOpen(true);


  const [modalIsOpenEvent, setModalIsOpenEvent] = useState(false);

  const openModallEventAtt = () => setModalIsOpenEvent(true);
  // const closeModallAtt = () => setModalIsOpen(false);


  const [modalIsOpennn, setModalIsOpennn] = useState(false);




  const openModalll = () => setModalIsOpennn(true);
  const closeModalll = () => setModalIsOpennn(false);



  const [meetings, setMeetings] = useState([]);
  const [eventss, setEventss] = useState([]);
  const [loadingMeetings, setLoadingMeetings] = useState(true);
  const [loadingEvents, setLoadingEvents] = useState(true);
  const [errorMeetings, setErrorMeetings] = useState(null);
  const [errorEvents, setErrorEvents] = useState(null);


  // selecting dropdown
  const [uniqueDates, setUniqueDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState('');
  const [venuesForSelectedDate, setVenuesForSelectedDate] = useState([]);

  // selected venu
  const [selectedVenue, setSelectedVenue] = useState('');


  // const [venue, setVenue] = useState("");

const [suggestions, setSuggestions] = useState([]);
const [isSearchingLocation, setIsSearchingLocation] = useState(false);
const [position, setPosition] = useState({ lat: 17.385, lng: 78.4867 });

const [latitude, setLatitude] = useState("17.385000");
const [longitude, setLongitude] = useState("78.486700");
const [mapLink, setMapLink] = useState("https://www.google.com/maps?q=17.385,78.4867");

// Reverse geocode when pin is clicked or dragged on the map
const handleMapPointChange = async (lat, lng) => {
  const formattedLat = parseFloat(lat).toFixed(6);
  const formattedLng = parseFloat(lng).toFixed(6);

  setLatitude(formattedLat);
  setLongitude(formattedLng);
  setMapLink(`https://www.google.com/maps?q=${formattedLat},${formattedLng}`);

  try {
    const res = await fetch(
      `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`
    );
    const data = await res.json();
    if (data && data.display_name) {
      setVenue(data.display_name);
    }
  } catch (err) {
    console.error("Error reverse geocoding:", err);
  }
};

const searchTimeoutRef = useRef(null);

// Regex patterns to detect Google Maps coordinates directly
const extractCoordsFromUrl = (url) => {
  // Pattern 1: @17.4428,78.4992
  const atMatch = url.match(/@(-?\d+\.\d+),(-?\d+\.\d+)/);
  if (atMatch) return { lat: parseFloat(atMatch[1]), lng: parseFloat(atMatch[2]) };

  // Pattern 2: ?q=17.4428,78.4992 or &query=17.4428,78.4992
  const qMatch = url.match(/[?&](?:q|query)=(-?\d+\.\d+),(-?\d+\.\d+)/);
  if (qMatch) return { lat: parseFloat(qMatch[1]), lng: parseFloat(qMatch[2]) };

  // Pattern 3: ll=17.4428,78.4992
  const llMatch = url.match(/[?&]ll=(-?\d+\.\d+),(-?\d+\.\d+)/);
  if (llMatch) return { lat: parseFloat(llMatch[1]), lng: parseFloat(llMatch[2]) };

  return null;
};




const handleVenueSearch = (text) => {
  setVenue(text);

  // Clear previous timer if user is still typing
  if (searchTimeoutRef.current) {
    clearTimeout(searchTimeoutRef.current);
  }

  if (!text || text.trim().length < 3) {
    setSuggestions([]);
    return;
  }

  // Wait 500ms after the user stops typing
  searchTimeoutRef.current = setTimeout(async () => {
    setIsSearchingLocation(true);

    try {
      // 1. Add your app contact email via &email= to satisfy Nominatim usage policy
      // 2. Bound search to India
      const url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
        text
      )}&countrycodes=in&viewbox=78.2,17.6,78.7,17.2&bounded=0&limit=6&addressdetails=1&email=admin@lbnhyderabad.com`;

      const response = await fetch(url, {
        headers: {
          "Accept-Language": "en-IN,en",
        },
      });

      if (response.status === 429) {
        console.warn("Nominatim rate limit reached. Waiting before retrying.");
        return;
      }

      const data = await response.json();
      setSuggestions(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error searching location:", error);
      setSuggestions([]);
    } finally {
      setIsSearchingLocation(false);
    }
  }, 500); // 500ms delay
};

const handleVenueChange = async (text) => {
  setVenue(text);

  // Check if user pasted a link
  const urlMatch = text.match(/https?:\/\/[^\s]+/);

  if (urlMatch) {
    const rawUrl = urlMatch[0];

    // Case A: Full Google URL with coordinates already inside it
    const directCoords = extractCoordsFromUrl(rawUrl);
    if (directCoords) {
      applyExtractedLocation(directCoords.lat, directCoords.lng, text);
      return;
    }

    // Case B: Shortened link (maps.app.goo.gl or goo.gl)
    if (rawUrl.includes("maps.app.goo.gl") || rawUrl.includes("goo.gl")) {
      setIsSearchingLocation(true);
      try {
        const res = await axios.post(
          "https://api.lbnhyderabad.com/signup/extract-coordinates",
          { venueText: rawUrl }
        );

        if (res.data.success) {
          applyExtractedLocation(
            parseFloat(res.data.latitude),
            parseFloat(res.data.longitude),
            text
          );
        }
      } catch (err) {
        console.error("Failed to unshorten map link:", err);
      } finally {
        setIsSearchingLocation(false);
      }
      return;
    }
  }

  // If regular text without a link, run standard venue search
  handleVenueSearch(text);
};

// Helper: Sets coordinates, updates map position, and cleans up form
const applyExtractedLocation = (lat, lng, fullText) => {
  const formattedLat = lat.toFixed(6);
  const formattedLng = lng.toFixed(6);

  setLatitude(formattedLat);
  setLongitude(formattedLng);
  setPosition({ lat, lng }); // This moves the Leaflet map pin and centers the view!
  setMapLink(`https://www.google.com/maps?q=${formattedLat},${formattedLng}`);
  setSuggestions([]); // Close any open autocomplete dropdown
};

// When user picks a place from search dropdown -> move map marker
const handleSelectPlace = (place) => {
  const lat = parseFloat(place.lat);
  const lon = parseFloat(place.lon);

  setPosition({ lat, lng: lon });
  setLatitude(lat.toFixed(6));
  setLongitude(lon.toFixed(6));
  setMapLink(`https://www.google.com/maps?q=${lat.toFixed(6)},${lon.toFixed(6)}`);
  setVenue(place.display_name);
  setSuggestions([]);
};



  // Fetch meetings data
  const fetchMeeting = () => {
    fetch('https://api.lbnhyderabad.com/admin-dashboard/meetings')
      .then((res) => res.json())
      .then((data) => {
        setMeetings(data);
        setLoadingMeetings(false);
        const dates = [
          ...new Set(
            data.map((meeting) => formatDateToDateInput(meeting.date)) // Format date as YYYY-MM-DD
          ),
        ];
        setUniqueDates(dates);


      })
      .catch((err) => {
        setErrorMeetings('Error fetching meetings data');
        setLoadingMeetings(false);
      });
  };
  console.log(uniqueDates)




  useEffect(() => {
    if (selectedDate) {
      // Filter venues based on selected date
      const filteredVenues = meetings
        .filter((meeting) => formatDateToDateInput(meeting.date) === selectedDate)
        .map((meeting) => meeting.venue);
      setVenuesForSelectedDate(filteredVenues);
    }
  }, [selectedDate, meetings]);



  const formatDateToDateInput = (date) => {
    // Convert date string to a Date object
    const dateObj = new Date(date);

    // Adjust for timezone offset and convert to 'YYYY-MM-DD' format
    const year = dateObj.getFullYear();
    const month = (dateObj.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed
    const day = dateObj.getDate().toString().padStart(2, '0');

    return `${year}-${month}-${day}`;
  };

  // Handle change in date dropdown
  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
    setSelectedVenue('');
  };

  const [imagee, setImagee] = useState(null); // For image file

  const onImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setImagee(e.target.files[0]);
    }
  };


  // const handleSubmit = async (event) => {
  //   event.preventDefault();
  //   const data = {
  //     date,
  //     time,
  //     venue,
  //   };

  //   try {
  //     // Sending the data to backend API
  //     await axios.post('https://api.lbnhyderabad.com/admin-dashboard/meeting', data);
  //     alert('Details submitted successfully!');
  //     setDate('');
  //     setTime('');
  //     setVenue('');
  //     fetchMeeting();

  //     closeModall();
  //   } catch (error) {
  //     console.error('Error submitting form:', error);
  //   }
  // };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const formData = new FormData();
    formData.append('date', date);
    formData.append('time', time);
    formData.append('venue', venue);
    formData.append('selectedChapter',selectedChapter);
    formData.append("latitude", latitude);
    formData.append("longitude", longitude);
    if (imagee) {
      formData.append('image', imagee);
    }

    try {
      // Sending the FormData to backend API 
      // await axios.post('https://api.lbnhyderabad.com/admin-dashboard/meeting', formData, {
      await axios.post('https://api.lbnhyderabad.com/signup/create-meeting', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      alert('Details submitted successfully!');
      setDate('');
      setTime('');
      setVenue('');
      // Inside your handleSubmit try block after alert:
setLatitude('');
setLongitude('');
      setImagee(null); // Reset image
      fetchMeeting();
      closeModall();
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('Failed to submit details.');
    }
  };


  const handleSendReminder = async (meetingId, chapter) => {
    try {
      const response = await axios.post(`http://localhost:10005/signup/send-reminder/${meetingId}`,
       { chapter } 
       );
      alert('Meeting Reminder sent successfully!');
    } catch (error) {
      console.error('Error sending reminder:', error);
      alert('Failed to send reminder');
    }
  };

  const handleSendReminderEvent = async (eventId,chapter) => {
    try {
      const response = await axios.post(`http://localhost:10005/signup/event-send-reminder/${eventId}`,
        {
        chapter: chapter   
      }
      );
      alert('Event Meeting Reminder sent successfully!');
    } catch (error) {
      console.error('Error sending reminder:', error);
      alert('Failed to send reminder'); 
    }
  };



  const [uniqueEventDates, setUniqueEventDates] = useState([]);
  const [selectedEventDate, setSelectedEventDate] = useState('');



  const [venuesEventForSelectedDate, setVenuesEventForSelectedDate] = useState([]);

  const [selectedEventVenue, setSelectedEventVenue] = useState('');

  const [selectedEvents, setSelectedEvents] = useState('');

  const [EventForSelectedDate, setEventForSelectedDate] = useState([]);

  // Function to fetch events data
  const fetchEvent = () => {
    fetch('https://api.lbnhyderabad.com/admin-dashboard/events')
      .then((res) => res.json())
      .then((data) => {
        setEventss(data);
        const dates = [
          ...new Set(
            data.map((eventss) => formatDateToDateInput(eventss.date)) // Format date as YYYY-MM-DD
          ),
        ];
        setUniqueEventDates(dates);

        setLoadingEvents(false);
      })
      .catch((err) => {
        setErrorEvents('Error fetching events data');
        setLoadingEvents(false);
      });
  };

  // Call the functions to fetch data and events when component mounts
  useEffect(() => {
    fetchMeeting();
    fetchEvent();
  }, []); // Empty array ensures the functions run only once when the component mounts



  useEffect(() => {
    if (selectedEventDate) {
      // Filter venues based on selected date  setEventForSelectedDate
      const filteredEventVenues = eventss
        .filter((eventss) => formatDateToDateInput(eventss.date) === selectedEventDate)
        .map((eventss) => eventss.venue);
      setVenuesEventForSelectedDate(filteredEventVenues);
    }
    if (selectedEventVenue) {
      const filteredEvents = eventss
        .filter((eventss) => eventss.venue === selectedEventVenue)
        .map((eventss) => eventss.events);
      setEventForSelectedDate(filteredEvents);

    }
  }, [selectedEventDate, selectedEventVenue, eventss]);

  const handleDateEventChange = (e) => {
    setSelectedEventDate(e.target.value);
    setSelectedEventVenue();
    setSelectedEvents();
  };
  const handleEventVenueChange = (e) => {
    setSelectedEventVenue(e.target.value);
  };
  const handleEventChange = (e) => {
    setSelectedEvents(e.target.value);
  };

  // const isExpired = (date) => {
  //   const today = new Date();
  //   const meetingDate = new Date(date);
  //   return meetingDate < today;
  // };

  // const isExpired = (date, time) => {
  //   const today = new Date();

  //   // Convert the provided date and time into a full date object
  //   const meetingDate = new Date(date);
  //   const [hour, minute, second] = time.split(':').map(num => parseInt(num));

  //   // Set the time of the meeting based on the provided hour, minute, and second
  //   meetingDate.setHours(hour, minute, second, 0);

  //   // Check if the meeting date and time is in the past
  //   return meetingDate < today;
  // };

  const isExpired = (date, time) => {
    const today = new Date();

    // Convert the provided date and time into a full date object
    console.log('this is the data rr', date, time);
    const meetingDate = new Date(date);

    // Ensure time has hours, minutes, and optionally seconds
    const [hourStr, minuteStr, secondStr = "0"] = time.split(':');
    const hour = parseInt(hourStr, 10);
    const minute = parseInt(minuteStr, 10);
    const second = parseInt(secondStr, 10);

    // Set the full time
    meetingDate.setHours(hour, minute, second, 0);
    console.log('Meeting full datetime:', meetingDate.toString());
    console.log('Current datetime:', today.toString());
    // Check if the meeting date and time is in the past
    return meetingDate < today;



  };


  const handleSubmitEvent = async (event) => {
    event.preventDefault();
    // const dataa = {
    //   date,
    //   time,
    //   venue,
    //   events,
    //   selectedChapter:'Chapter-1'
    // };

    const formData = new FormData();
    formData.append('date', date);
    formData.append('time', time);
    formData.append('venue', venue);
    formData.append('events', events);
    formData.append('selectedChapter',selectedChapter);
    if (imagee) {
      formData.append('image', imagee);
    }

    try {

      await axios.post('https://api.lbnhyderabad.com/signup/events', formData,{
         headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      alert('Details submitted successfully!');
      setDate('');
      setTime('');
      setVenue('');
      setEvent('');
         setImagee(null); 
      fetchEvent();
      closeModalll();
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };


  const [searchMeeting, setSearchMeeting] = useState("");

  const handleSearch = (event) => {
    setSearchMeeting(event.target.value.toLowerCase());
  };



  const filteredMeetings = meetings.filter((meeting) => {
    const searchLower = searchMeeting.toLowerCase();

    // Ensure that the properties we're accessing exist and are not undefined
    const email = meeting.email ? meeting.email.toLowerCase() : '';
    const date = meeting.date ? new Date(meeting.date).toLocaleDateString().toLowerCase() : '';
    const venue = meeting.venue ? meeting.venue.toLowerCase() : '';

    return (
      email.includes(searchLower) || // Searching in email
      date.includes(searchLower) || // Searching in date
      venue.includes(searchLower) // Searching in venue
    );
  });





  const [actionMeetings, setActionMeetings] = useState([]);
  const [actionMeetingsAtt, setActionMeetionsAtt] = useState([]);

  const fetchActionMeetings = async () => {
    try {
      const response = await fetch('https://api.lbnhyderabad.com/admin-dashboard/get/meetings');
      if (!response.ok) {
        throw new Error('Error fetching data');
      }
      const data = await response.json();

      const filteredData = data.filter(meeting => meeting.response === 'no');

      setActionMeetings(data); // Store fetched meetings in state
      setActionMeetionsAtt(filteredData);
      setLoading(false);  // Set loading to false after data is fetched
    } catch (err) {
      setError(err.message); // Set error state if any error occurs
      setLoading(false); // Set loading to false even on error
    }
  };


  // const handleVenueChange = (e) => {
  //   setSelectedVenue(e.target.value);
  // };

  // const selectedVenueDetails = actionMeetings.find(
  //   (meeting) => meeting.venue === selectedVenue
  // );
 
 
  const selectedMeetingDetails = actionMeetings.filter(
    (meeting) =>
      formatDateToDateInput(meeting.date) === selectedDate && meeting.venue === selectedVenue
  );
  console.log('this is selectedMeetingDetails', selectedMeetingDetails)



  const indexOfLastUser13 = currentPage13 * usersPerPage13;
  const indexOfFirstUser13 = indexOfLastUser13 - usersPerPage13;
  const currentUsers13 = selectedMeetingDetails.slice(indexOfFirstUser13, indexOfLastUser13);  // Get current page users


  const totalPages13 = Math.ceil(selectedMeetingDetails.length / usersPerPage13);  // Total pages



  const handleNextPage13 = () => {
    if (currentPage13 < totalPages13) {

      setCurrentPage13(currentPage13 + 1)
    }
  };

  const handlePrevPage13 = () => {
    if (currentPage13 > 1) {

      setCurrentPage13(currentPage13 - 1)
    }
  };


  const closeModallAtt = () => {
    setSelectedDate('');  // Reset selected date
    setSelectedVenue(''); // Reset selected venue

    setModalIsOpen(false);  // Close the modal
  };



  const [meetingResponses, setMeetingResponses] = useState({});

  // useEffect(() => {
  //   // Initialize the response state with the initial meeting details
  //   const initialResponses = selectedMeetingDetails.reduce((acc, meeting) => {
  //     acc[meeting.user_id] = meeting.response || 'no'; // Default to 'no' if response is missing
  //     return acc;
  //   }, {});

  //   // Update the state with the initial response values
  //   setMeetingResponses(initialResponses);
  // }, [selectedMeetingDetails]); // Ensure useEffect is only called when selectedMeetingDetails changes


  // const handleUpdateResponse = async () => {
  //   // Submit the updates to the backend
  //   for (const [userId, response] of Object.entries(meetingResponses)) {
  //     const meeting = selectedMeetingDetails.find(
  //       (meeting) => meeting.user_id === parseInt(userId)
  //     );

  //     if (meeting) {
  //       try {
  //         await axios.put('https://api.lbnhyderabad.com/admin-dashboard/updateMeetingResponse', {
  //           user_email: meeting.user_email,
  //           user_id: meeting.user_id,
  //           response,
  //           meeting_id: meeting.meeting_id,
  //         });
  //         console.log(`Updated response for ${meeting.user_email}`);
  //       } catch (error) {
  //         console.error('Error updating response:', error);
  //       }
  //     }
  //   }
  // };

  const handleUpdateResponse = async () => {
    // Submit the updates to the backend
    for (const [userId, response] of Object.entries(meetingResponses)) {
      const meeting = selectedMeetingDetails.find(
        (meeting) => meeting.user_id === parseInt(userId)
      );

      if (meeting) {
        try {
          const result = await axios.put('https://api.lbnhyderabad.com/admin-dashboard/updateMeetingResponse', {
            user_email: meeting.user_email,
            user_id: meeting.user_id,
            response,
            meeting_id: meeting.meeting_id,
          });

          // If the response is successful
          console.log(result.data.message);
          alert(`Updated response for ${meeting.user_email}`);
          // 
          //  closeModallAtt();
          //  window.location.reload();
          //  setActiveSection('Meetings');
          // openModallAtt();
          // Reload the window
          localStorage.setItem('reloadMeetingAttendance', 'true');

          // Reload page
          window.location.reload();
          // Close the modal after updating

          fetchActionMeetings();  // Assuming closeModallAtt() is your function to close the modal
        } catch (error) {
          console.error('Error:', error);
          // Handle error if needed
          alert('Error updating response');
        }
      }
    }
  };


  useEffect(() => {
    const shouldReopenModal = localStorage.getItem('reloadMeetingAttendance');
    if (shouldReopenModal === 'true') {
      setActiveSection('Meetings');
      openModallAtt(); // Or setModalIsOpen(true), depending on your logic
      localStorage.removeItem('reloadMeetingAttendance');
    }
  }, []);


  useEffect(() => {
    const shouldReopenModal = localStorage.getItem('reloadEventsAttendance');
    if (shouldReopenModal === 'true') {
      setActiveSection('Events');
      openModallAtt(); // Or setModalIsOpen(true), depending on your logic
      localStorage.removeItem('reloadEventsAttendance');
    }
  }, []);


  const handleAdminResponseClick = (userId, response) => {
    setMeetingResponses((prevResponses) => {
      const newResponses = { ...prevResponses };

      // If the response is the same as what's already selected, toggle it off
      if (newResponses[userId] === response) {
        delete newResponses[userId]; // Uncheck if already selected
      } else {
        newResponses[userId] = response;
      }

      return newResponses;
    });
  };
    const handleAdminEventResponseClick = (userId, response) => {
    setEventResponses((prevResponses) => {
      const newResponses = { ...prevResponses };

      // If the response is the same as what's already selected, toggle it off
      if (newResponses[userId] === response) {
        delete newResponses[userId]; // Uncheck if already selected
      } else {
        newResponses[userId] = response;
      }

      return newResponses;
    });
  };



  const handleAdminResponseSubmit = async () => {
    const responseArray = Object.entries(meetingResponses)
      .map(([userId, response]) => {
        const userIdNum = parseInt(userId);
        const user = filtercurrentUser1.find((u) => u.id === userIdNum);

        // Instead of find once, map over selectedMeetingDetails and find matching meeting_id for userIdNum
        const meetingIdsForUser = selectedMeetingDetails
          .map(m => m.meeting_id);

        return {
          user_id: userIdNum,
          user_email: user?.email || '',
          meeting_id: meetingIdsForUser.length > 0 ? meetingIdsForUser[0] : '', // Take first matching meeting_id if any
          response: response
        };
      })
      .filter(item => item.response); // Only send those with a response

    console.log("Final Payload Sent:", responseArray);

    try {
      const res = await fetch('https://api.lbnhyderabad.com/admin-dashboard/admin-meeting-response', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(responseArray),
      });

      if (res.ok) {
        fetchActionMeetings();
        alert('Admin responses submitted successfully!');
        localStorage.setItem('reloadMeetingAttendance', 'true');

        // Reload page
        window.location.reload();
      } else {
        alert('Failed to submit admin responses');
      }
    } catch (error) {
      console.error('Error submitting admin responses:', error);
    }
  };


  const handleAdminResponseSubmitEvent = async () => {
    const responseArray = Object.entries(eventResponses)
      .map(([userId, response]) => {
        const userIdNum = parseInt(userId);
        const user = filtercurrentUser1Event.find((u) => u.id === userIdNum);

        // Instead of find once, map over selectedEventDetails and find matching meeting_id for userIdNum
        const EventIdsForUser = selectedEventDetails
          .map(e => e.events_id);

        return {
          user_id: userIdNum,
          user_email: user?.email || '',
          events_id: EventIdsForUser.length > 0 ? EventIdsForUser[0] : '', // Take first matching meeting_id if any
          response: response
        };
      })
      .filter(item => item.response); // Only send those with a response

    console.log("Final Payload Sent:", responseArray);

    try {
      const res = await fetch('https://api.lbnhyderabad.com/admin-dashboard/admin-events-response', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(responseArray),
      });

      if (res.ok) {
        fetchActionEvents();
        alert('Admin responses submitted successfully!');
        localStorage.setItem('reloadEventsAttendance', 'true');

        // Reload page
        window.location.reload();
      } else {
        alert('Failed to submit admin responses');
      }
    } catch (error) {
      console.error('Error submitting admin responses:', error);
    }
  };



  // Function to initialize or update the meeting responses
  const initializeMeetingResponses = () => {
    if (selectedMeetingDetails && selectedMeetingDetails.length > 0) {
      const initialResponses = selectedMeetingDetails.reduce((acc, meeting) => {
        acc[meeting.user_id] = meeting.response || 'no'; // Default to 'no' if missing
        return acc;
      }, {});
      setMeetingResponses(initialResponses);
    }
  };

  useEffect(() => {

    initializeMeetingResponses();
  }, []);

  const handleResponseChange = (userId, newResponse) => {
    setMeetingResponses((prevResponses) => ({
      ...prevResponses,
      [userId]: newResponse, // Set the response to "yes" or "no"
    }));
  };

  const handleAdminResponseChange = (meetingId, response) => {
    setMeetingResponses(prev => ({
      ...prev,
      [meetingId]: response
    }));
  };



  // Fetch data on component mount
  useEffect(() => {
    fetchMeeting();
    fetchActionMeetings(); // Call custom fetch function when component mounts
  }, []);

  const groupByEmail = (meetings) => {
    return meetings.reduce((groups, meeting) => {
      if (!groups[meeting.user_email]) {
        groups[meeting.user_email] = [];
      }
      groups[meeting.user_email].push(meeting);
      return groups;
    }, {});
  };
  // Get meeting label (1st, 2nd, 3rd time)
  const getMeetingLabel = (index) => {
    const suffix = ['st', 'nd', 'rd', 'th'];
    const mod = index % 10;
    return `${index + 1}${suffix[mod - 1] || suffix[3]} time`;
  };
  const groupedMeetings = groupByEmail(actionMeetingsAtt);

  const handleCheckboxChange = (meeting, newResponse) => {
    updateMeetingResponse(meeting.id, newResponse);
  };

  const updateMeetingResponse = async (meetingId, newResponse) => {
    try {
      const response = await fetch('https://api.lbnhyderabad.com/admin-dashboard/meeting-response', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          meeting_id: meetingId,
          response: newResponse,
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to update response');
      }

      // Re-fetch the meetings after updating
      fetchActionMeetings();
    } catch (err) {
      console.error('Error updating response: ', err);
    }
  };




  const [showMeetingModal, setShowMeetingModal] = useState(false);
  const [selectedMeeting, setSelectedMeeting] = useState(null);

  const handleShowModal = (meetingId) => {
    console.log('Button clicked for meetingId:', meetingId);

    // Log the actionMeetings to check its structure
    console.log('Action meetings:', actionMeetings);

    // Use meeting_id from actionMeetings to find all meetings with the same meeting_id
    const meetingsData = actionMeetings.filter(meeting => meeting.meeting_id === meetingId);

    if (meetingsData.length > 0) {
      console.log('Meetings data found:', meetingsData);
      setSelectedMeeting(meetingsData);  // Set the selected meetings for the modal
      setShowMeetingModal(true);  // Show the modal
    } else {
      console.log('No meeting found for this ID:', meetingId);
    }
  };



  // Function to handle modal close
  const handleCloseModal = () => {
    setShowMeetingModal(false);
    setSelectedMeeting(null);  // Clear the selected meeting data
  };

  console.log("this is Action data", actionMeetings)










  const [actionEvents, setActionEvents] = useState([]);
  const [actionEventsAtt, setActionEventsAtt] = useState([]);


  const fetchActionEvents = async () => {
    try {
      const response = await fetch('https://api.lbnhyderabad.com/admin-dashboard/get/events');
      if (!response.ok) {
        throw new Error('Error fetching data');
      }
      const data = await response.json();
  const filteredData = data.filter(event => event.response === 'no');


      setActionEvents(data); // Store fetched meetings in state
      setActionEventsAtt(filteredData)
      setLoading(false);  // Set loading to false after data is fetched
    } catch (err) {
      setError(err.message); // Set error state if any error occurs
      setLoading(false); // Set loading to false even on error
    }
  };

  // Fetch data on component mount
  useEffect(() => {
    fetchEvent();
    fetchActionEvents(); // Call custom fetch function when component mounts
  }, []);


  const selectedEventDetails = actionEvents.filter(
    (eventss) =>
      formatDateToDateInput(eventss.date) === selectedEventDate && eventss.venue === selectedEventVenue && eventss.events === selectedEvents
  );


  const indexOfLastUser13Event = currentPage13Event * usersPerPage13Event;
  const indexOfFirstUser13Event = indexOfLastUser13Event - usersPerPage13Event;
  const currentUsers13Event = selectedEventDetails.slice(indexOfFirstUser13Event, indexOfLastUser13Event);  // Get current page users


  const totalPages13Event = Math.ceil(selectedEventDetails.length / usersPerPage13Event);  // Total pages



  const handleNextPage13Event = () => {
    if (currentPage13Event < totalPages13Event) {

      setCurrentPage13Event(currentPage13Event + 1)
    }
  };

  const handlePrevPage13Event = () => {
    if (currentPage13Event > 1) {

      setCurrentPage13Event(currentPage13Event - 1)
    }
  };


  const closeModallEventAtt = () => {
    setSelectedDate('');  // Reset selected date
    setSelectedEventVenue(''); // Reset selected venue

    setModalIsOpenEvent(false);  // Close the modal
  };



  const [showEventModal, setShowEventModal] = useState(false);

  const [selectedEvent, setSelectedEent] = useState(null);

  const handleEventShowModal = (eventId) => {
    console.log('Button clicked for eventId:', eventId);

    // Log the actionEvents to check its structure
    console.log('Action eventss:', actionEvents);

    // Use meeting_id from actionEvents to find all eventss with the same meeting_id
    const meetingsData = actionEvents.filter(event => event.events_id === eventId);

    if (meetingsData.length > 0) {
      console.log('Meetings data found:', meetingsData);
      setSelectedEent(meetingsData);  // Set the selected eventss for the modal
      setShowEventModal(true);  // Show the modal
    } else {
      console.log('No eventId found for this ID:', eventId);
    }
  };

  // Function to handle modal close
  const handleEventCloseModal = () => {
    setShowEventModal(false);
    setSelectedEent(null);  // Clear the selected meeting data
  };

  console.log("this is Action event data", actionEvents)



  const [eventResponses, setEventResponses] = useState({});

  const handleUpdateEventResponse = async () => {
    console.log('clicked')
    // Submit the updates to the backend
    for (const [userId, response] of Object.entries(eventResponses)) {
      const event = selectedEventDetails.find(
        (event) => event.user_id === parseInt(userId)
      );

      if (event) {
        try {
          const result = await axios.put('https://api.lbnhyderabad.com/admin-dashboard/updateEventResponse', {
            user_email: event.user_email,
            user_id: event.user_id,
            response,
            events_id: event.events_id,
          });

          // If the response is successful
          console.log(result.data.message);
          alert(`Updated response for ${event.user_email}  successfully`);

          // Show alert after success
          //alert('Response updated successfully!');

             localStorage.setItem('reloadEventAttendance', 'true');

          // Reload page
          window.location.reload();

          // Close the modal after updating
          closeModallEventAtt();
          fetchActionEvents();  // Assuming closeModallAtt() is your function to close the modal
        } catch (error) {
          console.error('Error:', error);
          // Handle error if needed
          alert('Error updating response');
        }
      }
    }
  };


  // Function to initialize or update the meeting responses
  const initializeEventResponses = () => {
    if (selectedEventDetails && selectedEventDetails.length > 0) {
      const initialEventResponses = selectedEventDetails.reduce((acc, event) => {
        acc[event.user_id] = event.response || 'no'; // Default to 'no' if missing
        return acc;
      }, {});
      setMeetingResponses(initialEventResponses);
    }
  };

  useEffect(() => {

    initializeEventResponses();
  }, []);

  const handleEventResponseChange = (userId, newResponse) => {
    setEventResponses((prevResponses) => ({
      ...prevResponses,
      [userId]: newResponse, // Set the response to "yes" or "no"
    }));
  };










  /****************** for Meetings******************************* */

  const [currentPagee, setCurrentPagee] = useState(1);
  const itemsPerPage = 10;

  // Function to handle page change
  const handlePageChangee = (page) => {
    setCurrentPagee(page);
  };

  // Calculate the indexes for the current page
  const indexOfLastMeeting = currentPagee * itemsPerPage;
  const indexOfFirstMeeting = indexOfLastMeeting - itemsPerPage;

  // Slice the meetings array to show only the items for the current page
  const currentMeetings = filteredMeetings.slice(indexOfFirstMeeting, indexOfLastMeeting);

  // Calculate the total number of pages
  const totalPagess = Math.ceil(filteredMeetings.length / itemsPerPage);

  const isLastPageWithLessThan10 = currentPagee === totalPagess && filteredMeetings.length % itemsPerPage !== 0;



  /********************* for Events **************************** */
  const [currentPageee, setCurrentPageee] = useState(1);
  const itemsPerPagee = 10;

  const handlePageChangeee = (page) => {
    setCurrentPageee(page);
  };

  // Calculate the indexes for the current page
  const indexOfLastMeetingg = currentPageee * itemsPerPagee;
  const indexOfFirstMeetingg = indexOfLastMeetingg - itemsPerPagee;

  // Slice the meetings array to show only the items for the current page
  const currentMeetingss = eventss.slice(indexOfFirstMeetingg, indexOfLastMeetingg);

  // Calculate the total number of pages
  const totalPagesss = Math.ceil(eventss.length / itemsPerPagee);

  const isLastPageWithLessThann10 = currentPageee === totalPagesss && filteredMeetings.length % itemsPerPagee !== 0;

  //image adds 

  const [images, setImages] = useState({
    main_add_1: null,
    main_add_2: null,
    main_add_3: null,
    side_add_1: null,
    side_add_2: null,
    side_add_3: null,
    side_add_4: null,
    side_add_5: null,
    side_add_6: null,
  });

  const handleSubmitimage = async () => {
    const formData = new FormData();

    Object.entries(images).forEach(([key, value]) => {
      if (value) {
        formData.append(key, value);
      }
    });

    try {
      const response = await fetch('https://api.lbnhyderabad.com/admin-dashboard/api/add-images', {
        method: 'POST',
        body: formData,
      });

      const data = await response.json();
      if (response.ok) {
        alert('Images uploaded successfully!');
        fetchImages();
      } else {
        alert('Upload failed: ' + data.error);
      }
    } catch (error) {
      console.error('Upload error:', error);
      alert('An error occurred while uploading.');
    }
  };

  const handleDeleteImage = async (selectid) => {
    const confirmation = window.confirm('Are you sure you want to delete this image?');
    if (!confirmation) return;

    try {
      const response = await fetch(`https://api.lbnhyderabad.com/admin-dashboard/api/delete-image/${selectid}`, {
        method: 'DELETE',
      });

      const data = await response.json();
      if (response.ok) {
        alert('Image deleted successfully!');
      } else {
        alert('Delete failed: ' + data.error);
      }
    } catch (error) {
      console.error('Delete error:', error);
      alert('An error occurred while deleting.');
    }
  };

  const handleImageChange = (e, field) => {
    const file = e.target.files[0];
    if (file) {
      setImages((prev) => ({ ...prev, [field]: file }));
    }
  };

  const [imagess, setImagess] = useState([]);


  const fetchImages = async () => {
    try {
      const response = await fetch('https://api.lbnhyderabad.com/admin-dashboard/api/get-images');
      const data = await response.json();

      if (response.ok) {
        setImagess(data.images);
      } else {
        setError(data.error || 'Failed to fetch images');
      }
    } catch (err) {
      setError('An error occurred while fetching images');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchImages();
  }, []);

  const image = imagess[0];

  const email = sessionStorage.getItem("email");
  const [referralData, setReferralData] = useState([]);
  const [referralOutData, serReferralOutData] = useState([]);

  const [thanks, setThanks] = useState([])
  // const email = sessionStorage.getItem('email');
  // Fetch data when the component mounts
  useEffect(() => {
    axios
      .get("https://api.lbnhyderabad.com/refferal/api/referralstore") // Assuming your backend is running on port 3000
      .then((response) => {

        // const filteredData = response.data.filter(
        //   (item) => item.email === email
        // );
        // const filteredDataa = response.data.filter(
        //   (item) => item.customerEmail === email
        // );

        // const filteredDataaa = response.data.filter(
        //   (item) => item.salerEmail === email
        // );

        setReferralData(response.data); // Set the data from API to state
        serReferralOutData(response.data);
        setThanks(response.data);
        setLoading(false); // Set loading state to false when data is fetched
      })
      .catch((err) => {
        setError("Error fetching referral data");
        setLoading(false);
      });
  }, []);
  //ref send 
  const itemsPerPage1 = 10;
  const [currentPage1, setCurrentPage1] = useState(1);
  const totalPages1 = Math.ceil(referralData.length / itemsPerPage);
  //ref rec
  const itemsPerPageIn = 10;
  const [currentPageIn, setCurrentPageIn] = useState(1);
  const totalPagesIn = Math.ceil(referralOutData.length / itemsPerPageIn);


  //thanks note 

  const [myThankNote, setMyThankNote] = useState([]);

  const fetchThanksNotes = () => {
    fetch("https://api.lbnhyderabad.com/product/thanksNote") // Replace with your actual backend URL
      .then((response) => response.json()) // Parse the JSON response
      .then((data) => {
        console.log("Fetched Data:", data); // Log the data to ensure it's coming in correctly

        // const filteredData = data.filter(
        //   (note) => note.salerEmail === email
        // );
        // const filteredMyData = data.filter(
        //   (note) => note.email === email
        // );
        setMyThankNote(data);
        // setThanksNotes(filteredData); // Set the fetched data into state
        setLoading(false); // Set loading to false once data is fetched
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
        setError("Error fetching thanks note data"); // Set error state if something goes wrong
        setLoading(false); // Set loading to false on error as well
      });
  };

  // Fetch data when the component mounts or when email changes (if email can change)
  useEffect(() => {

    // Make sure email is available before fetching
    fetchThanksNotes();

  }, []);


  //one-to-one


  const [invitations, setInvitations] = useState([]);

  const [currentPageInv, setCurrentPageInv] = useState(1);
  const itemsPerPageInv = 10;
  const totalPagesInv = Math.ceil(invitations.length / itemsPerPageInv);

  useEffect(() => {
    setCurrentPageInv(1);
  }, [invitations]);

  const handleFetchInvitations = () => {
    axios.get('https://api.lbnhyderabad.com/signup/api/invitations')
      .then((response) => {
        if (response.status === 200) {
          setInvitations(response.data);
          // const allInvitations = response.data;
          // const filteredInvitations = allInvitations.filter(invite => invite.userId === userId);
          // setInvitations(filteredInvitations);
        } else {
          alert('Failed to fetch invitations');
        }
      })
      .catch((error) => {
        console.error('Error fetching invitations:', error);
        alert('An error occurred while fetching invitations');
      });
  };

  useEffect(() => {
    handleFetchInvitations();
  }, []);



  const [user, setUser] = useState([]);

  const fetchUserData = async () => {
    try {
      const response = await axios.get(`https://api.lbnhyderabad.com/signup/get`);
      setUser(response.data);

      setLoading(false);
    } catch (error) {
      console.error("There was an error fetching the data!", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  console.log(user)


  const [showReferralModal, setShowReferralModal] = useState(false);
  const [selectedUserReferrals, setSelectedUserReferrals] = useState([]);
  const [selectedUserName, setSelectedUserName] = useState("");
  // const invitedUser = user.find(user => Number(user.id) === Number(invitations.userId));
  const handleReferralClick = async (referrerId, userName) => {
    setSelectedUserName(userName);
    try {
      const response = await axios.get(
        `https://api.lbnhyderabad.com/signup/referrals/${referrerId}`
      );
      setSelectedUserReferrals(response.data);
      setShowReferralModal(true);
    } catch (error) {
      console.error("Error fetching referral members:", error);
      setSelectedUserReferrals([]);
      setShowReferralModal(true);
    }
  };



  //   const [invitationsget, setInvitationsget] = useState([]);

  // const invitecount = invitationsget.length;
  //   useEffect(() => {
  //     fetchInvitations();
  //   }, []);

  //   const fetchInvitations = async () => {
  //     try {
  //       const response = await axios.get('https://api.lbnhyderabad.com/signup/api/visitorInvitations');

  //       setInvitationsget(response.data);

  //     } catch (error) {
  //       console.error('Error fetching invitations:', error);
  //       alert('Failed to load visitor invitations.');
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
  // console.log(invitationsget)


  // const [submittedVisitorIds, setSubmittedVisitorIds] = useState(new Set());

  const [visitorResponses, setVisitorResponses] = useState({});
  
  const [visitorEventResponses, setVisitorEventResponses] = useState({});

  const [responsesSubmitted, setResponsesSubmitted] = useState(false);

  useEffect(() => {
    fetchInvitations();
  }, []);

  const fetchInvitations = async () => {
    try {
      const response = await axios.get('https://api.lbnhyderabad.com/signup/api/visitorInvitations');
      setInvitationsget(response.data);
    } catch (error) {
      console.error('Error fetching invitations:', error);
      alert('Failed to load visitor invitations.');
    } finally {
      setLoading(false);
    }
  };


  // event investor 

    useEffect(() => {
    fetchInvitationsEvent();
  }, []);

  const fetchInvitationsEvent = async () => {
    try {
      const response = await axios.get('https://api.lbnhyderabad.com/signup/api/visitorInvitations_event');
      setInvitationsgetEvent(response.data);
    } catch (error) {
      console.error('Error fetching invitations:', error);
      alert('Failed to load visitor invitations.');
    } finally {
      setLoading(false);
    }
  };


  // Update visitor response in state
  const handleVisitorResponseChange = (id, response) => {
    setVisitorResponses(prev => ({
      ...prev,
      [id]: prev[id] === response ? '' : response // toggle
    }));
  };


    const handleVisitorResponseChangeEvent = (id, response) => {
    setVisitorEventResponses(prev => ({
      ...prev,
      [id]: prev[id] === response ? '' : response // toggle
    }));
  };


  // Submit visitor responses
  // const handleUpdateVisitorResponses = async () => {
  //   try {
  //     const updates = Object.entries(visitorResponses);
  //     for (const [id, response] of updates) {
  //       if (response) {
  //         await axios.put(`https://api.lbnhyderabad.com/signup/api/updateVisitorResponse`, {
  //           id,
  //           response,
  //         });
  //       }
  //     }
  //     alert('Visitor responses updated successfully.');
  //     fetchInvitations(); // refresh updated data
  //     setResponsesSubmitted(true);
  //   } catch (error) {
  //     console.error('Error updating visitor responses:', error);
  //     alert('Failed to update visitor responses.');
  //   }
  // };


  // Submit visitor responses
 
  const handleUpdateVisitorResponses = async () => {
    try {
      const updates = Object.entries(visitorResponses);
      for (const [id, response] of updates) {
        if (response) {
          await axios.put(`https://api.lbnhyderabad.com/signup/api/updateVisitorResponse`, {
            id,
            response,
          });
        }
      }
      alert('Visitor responses updated successfully.');
      fetchInvitations(); // refresh updated data
      setResponsesSubmitted(true); // Disable further updates
    } catch (error) {
      console.error('Error updating visitor responses:', error);
      alert('Failed to update visitor responses.');
    }
  };

  const handleUpdateVisitorEventResponses = async () => {
    try {
      const updates = Object.entries(visitorEventResponses);
      for (const [id, response] of updates) {
        if (response) {
          await axios.put(`https://api.lbnhyderabad.com/signup/api/updateVisitorEventResponse`, {
            id,
            response,
          });
        }
      }
      alert('Visitor responses updated successfully.');
      fetchInvitationsEvent(); // refresh updated data
      setResponsesSubmitted(true); // Disable further updates
    } catch (error) {
      console.error('Error updating visitor responses:', error);
      alert('Failed to update visitor responses.');
    }
  };


  const getUserNameById = (userId) => {
    const found = user.find(u => String(u.id) === String(userId));
    return found ? found.name : 'Unknown User';
  };

  const meetingDate = selectedMeetingDetails[0]?.date;
  const isMeetingExpired = meetingDate ? new Date(meetingDate) < new Date() : false;

  const deleteProduct = (productId) => {
    console.log(productId);
    const confirmation = window.confirm(
      "Are you sure you want to delete this product?"
    );
    if (!confirmation) return;

    fetch(`https://api.lbnhyderabad.com/product/delete/${productId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.message === "Product deleted successfully") {
          alert("Product deleted successfully");
          fetchDataProduct();
          // fetchProducts();
        } else {
          alert(data.message);
        }
      })
      .catch((error) => {
        console.error("Error deleting product:", error);
        alert("An error occurred while deleting the product.");
      });
  };

  const [expanded, setExpanded] = useState(false);
  const toggleExpanded = () => setExpanded(!expanded);


  const formatDate = (dateStr) => {
    if (!dateStr) return "Not Given"; // If no date, return "Not Given"

    let date = new Date(dateStr);
    if (date.toString() === "Invalid Date") return "Not Given"; // Check if the date is invalid

    let day = String(date.getDate()).padStart(2, '0'); // Add leading zero if needed
    let month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed, so add 1
    let year = date.getFullYear();

    return `${day}-${month}-${year}`; // Format in dd-mm-yyyy
  };

  const isExpiredOffer = (validity) => {
    if (!validity) return false;
    const today = new Date();
    const validDate = new Date(validity);
    return validDate < today;
  };

  //this search is the Visitor Inviation 
  const [searchQuery, setSearchQuery] = useState('');

  const filteredInvites = invitationsget
    .filter(invite => invite.meeting_id === selectedMeetingDetails[0]?.meeting_id)
    .filter(invite => {
      const lowerQuery = searchQuery.toLowerCase();
      return (
        getUserNameById(invite.userId)?.toLowerCase().includes(lowerQuery) ||
        invite.visitor_name?.toLowerCase().includes(lowerQuery) ||
        invite.visitor_email?.toLowerCase().includes(lowerQuery) ||
        invite.visitor_mobile?.toLowerCase().includes(lowerQuery)
      );
    });


  // ✅ Pagination should apply *after* filtering
  const indexOfLastUser12 = currentPage12 * usersPerPage12;
  const indexOfFirstUser12 = indexOfLastUser12 - usersPerPage12;
  const currentUsers12 = filteredInvites.slice(indexOfFirstUser12, indexOfLastUser12);
  const totalPages12 = Math.ceil(filteredInvites.length / usersPerPage12);

// this is for the event investor meeting 

  //this search is the Visitor Inviation 
  const [searchQueryEvent, setSearchQueryEvent] = useState('');

  const filteredInvitesEvent = invitationsgetEvent
    .filter(invite => invite.events_id === selectedMeetingDetails[0]?.events_id)
    .filter(invite => {
      const lowerQuery = searchQueryEvent.toLowerCase();
      return (
        getUserNameById(invite.userId)?.toLowerCase().includes(lowerQuery) ||
        invite.visitor_name?.toLowerCase().includes(lowerQuery) ||
        invite.visitor_email?.toLowerCase().includes(lowerQuery) ||
        invite.visitor_mobile?.toLowerCase().includes(lowerQuery)
      );
    });


  // ✅ Pagination should apply *after* filtering
  const indexOfLastUser12Event = currentPage12Event * usersPerPage12Event;
  const indexOfFirstUser12Event = indexOfLastUser12Event - usersPerPage12Event;
  const currentUsers12Event = filteredInvitesEvent.slice(indexOfFirstUser12Event, indexOfLastUser12Event);
  const totalPages12Event = Math.ceil(filteredInvitesEvent.length / usersPerPage12Event);





//end here

  // this is  (Response not given Members)   
  const filtercurrentUser1 = adminfilteredUsers.filter(meeting => meeting.isApprove === 1).filter(meeting => !selectedMeetingDetails.some(m => m.user_email === meeting.email))


  const indexOfLastUser1 = currentPage11 * usersPerPage1;
  const indexOfFirstUser1 = indexOfLastUser1 - usersPerPage1;
  const currentUsers1 = filtercurrentUser1.slice(indexOfFirstUser1, indexOfLastUser1);  // Get current page users

  const totalPages11 = Math.ceil(filtercurrentUser1.length / usersPerPage1);  // Total pages


  // event all users

   const filtercurrentUser1Event = adminfilteredUsersEvent.filter(event => event.isApprove === 1).filter(event => !selectedEventDetails.some(m => m.user_email === event.email))


  const indexOfLastUser1Event = currentPage11Event * usersPerPage1Event;
  const indexOfFirstUser1Event = indexOfLastUser1Event - usersPerPage1Event;
  const currentUsers1Event = filtercurrentUser1Event.slice(indexOfFirstUser1Event, indexOfLastUser1Event);  // Get current page users

  const totalPages11Event = Math.ceil(filtercurrentUser1Event.length / usersPerPage1Event);  // Total pages


  // count of referral

  const [showReferralModal1, setShowReferralModal1] = useState(false);
  const [referralFromDate, setReferralFromDate] = useState("");
  const [referralToDate, setReferralToDate] = useState("");
  const [highestReferralResult, setHighestReferralResult] = useState(null);
  const [referralStats, setReferralStats] = useState([]); // For all referrals


  const handleCheckHighestReferral1 = () => {
    const from = new Date(referralFromDate);
    const to = new Date(referralToDate);

    if (!referralFromDate || !referralToDate || from > to) {
      alert("Please select a valid date range.");
      return;
    }

    const filteredData = referralData.filter((item) => {
      const created = new Date(item.createdDate);
      return created >= from && created <= to;
    });

    const referralCounts = {};

    filteredData.forEach((item) => {
      if (item.email) {
        referralCounts[item.email] = (referralCounts[item.email] || 0) + 1;
      }
    });

    const sorted = Object.entries(referralCounts).sort((a, b) => b[1] - a[1]);

    setHighestReferralResult(
      sorted.length > 0
        ? { email: sorted[0][0], count: sorted[0][1] }
        : null
    );
    // setShowReferralModal(false);
  };

  const handleCheckHighestReferral = () => {
    const from = new Date(referralFromDate);
    const to = new Date(referralToDate);

    if (!referralFromDate || !referralToDate || from > to) {
      alert("Please select a valid date range.");
      return;
    }

    const filteredData = referralData.filter((item) => {
      const created = new Date(item.createdDate);
      return created >= from && created <= to;
    });

    const referralCounts = {};

    filteredData.forEach((item) => {
      if (item.email) {
        referralCounts[item.email] = (referralCounts[item.email] || 0) + 1;
      }
    });

    const sortedReferrals = Object.entries(referralCounts)
      .map(([email, count]) => ({ email, count }))
      .sort((a, b) => b.count - a.count);

    setReferralStats(sortedReferrals);
    setShowReferralModal(false);
  };

  //count for thanks note 

  const [showThanksModal, setShowThanksModal] = useState(false);
  const [thanksFromDate, setThanksFromDate] = useState("");
  const [thanksToDate, setThanksToDate] = useState("");
  const [thanksStats, setThanksStats] = useState([]);

  const handleCheckThanksStats = () => {
    const from = new Date(thanksFromDate);
    const to = new Date(thanksToDate);

    if (!thanksFromDate || !thanksToDate || from > to) {
      alert("Please select a valid date range.");
      return;
    }

    const filteredData = myThankNote.filter((item) => {
      const created = new Date(item.createdAt);
      return created >= from && created <= to;
    });

    const counts = {};
    filteredData.forEach((item) => {
      if (item.salerEmail) {
        counts[item.salerEmail] = (counts[item.salerEmail] || 0) + 1;
      }
    });

    const sorted = Object.entries(counts)
      .map(([salerEmail, count]) => ({ salerEmail, count }))
      .sort((a, b) => b.count - a.count);

    setThanksStats(sorted);
    // setShowThanksModal(false);
  };



  // one to one invitation count

  const [showInviteModal, setShowInviteModal] = useState(false);
  const [inviteFromDate, setInviteFromDate] = useState("");
  const [inviteToDate, setInviteToDate] = useState("");
  const [inviteStats, setInviteStats] = useState([]);

  const handleCheckInviteStats = () => {
    const from = new Date(inviteFromDate);
    const to = new Date(inviteToDate);

    if (!inviteFromDate || !inviteToDate || from > to) {
      alert("Please select a valid date range.");
      return;
    }

    const filtered = invitations.filter((invite) => {
      const created = new Date(invite.createdAt);
      return created >= from && created <= to;
    });

    const counts = {};
    filtered.forEach((invite) => {
      const senderId = invite.userId;
      const sender = user.find((u) => Number(u.id) === Number(senderId));
      const senderName = sender?.name || "Unknown";

      counts[senderName] = (counts[senderName] || 0) + 1;
    });

    const result = Object.entries(counts)
      .map(([name, count]) => ({ name, count }))
      .sort((a, b) => b.count - a.count);

    setInviteStats(result);
    // setShowInviteModal(false);
  };


  // chapter
  //   const [chapters, setChapters] = useState([]);
  // const [formData, setFormData] = useState({ title: '', chapter: '' });
  // const [selectedId, setSelectedId] = useState(null);
  // const [adminData, setAdminData] = useState({ email: '', password: '' });
  // const [dropdownId, setDropdownId] = useState('');

  // const fetchChapters = async () => {
  //   const res = await axios.get('https://api.lbnhyderabad.com/admin-dashboard/chapters');
  //   setChapters(res.data);
  // };

  // useEffect(() => {
  //   fetchChapters();
  // }, []);

  // const createChapter = async () => {
  //   await axios.post('https://api.lbnhyderabad.com/admin-dashboard/chapters', formData);
  //   setFormData({  chapter: '' });
  //   fetchChapters();
  // };

  // const deleteChapter = async (id) => {
  //   await axios.delete(`https://api.lbnhyderabad.com/admin-dashboard/chapters/${id}`);
  //   fetchChapters();
  // };

  // const editChapter = async () => {
  //   await axios.put(`https://api.lbnhyderabad.com/admin-dashboard/chapters/${selectedId}`, formData);
  //   setSelectedId(null);
  //   setFormData({ title: '', chapter: '' });
  //   fetchChapters();
  // };

  // const saveAdmin = async () => {
  //   if (!dropdownId) return alert("Select a chapter");
  //   await axios.post(`https://api.lbnhyderabad.com/admin-dashboard/chapters/${dropdownId}/admin`, adminData);
  //   setAdminData({ email: '', password: '' });
  //   fetchChapters();
  // };

  const [chapters, setChapters] = useState([]);
  const [formData, setFormData] = useState({ title: '', chapter: '' });
  const [adminData, setAdminData] = useState({ email: '', password: '' }); // Admin data state
  const [selectedId, setSelectedId] = useState(null);
  const [dropdownId, setDropdownId] = useState('');
  const [showModal, setShowModal] = useState(false); // State to control modal visibility
const [selectedChapter, setSelectedChapter] = useState('');

  // Fetch chapters from the backend
  const fetchChapters = async () => {
    const res = await axios.get('https://api.lbnhyderabad.com/admin-dashboard/chapters');
    setChapters(res.data);
  };

  useEffect(() => {
    fetchChapters();
  }, []);
  useEffect(() => {
  if (modalIsOpenn) {
    fetchChapters();
  }
}, [modalIsOpenn]);


  // Create new chapter
  const createChapter = async () => {
    await axios.post('https://api.lbnhyderabad.com/admin-dashboard/chapters', formData);
    setFormData({ chapter: '' });
    fetchChapters();
  };

  // Delete chapter
  const deleteChapter = async (id) => {
    await axios.delete(`https://api.lbnhyderabad.com/admin-dashboard/chapters/${id}`);
    fetchChapters();
  };

  // Edit chapter along with Admin Email and Password
  const editChapter = async () => {
    // Update the chapter with the formData and adminData
    await axios.put(`https://api.lbnhyderabad.com/admin-dashboard/chapters/${selectedId}`, {
      chapter: formData.chapter,
      email: adminData.email,
      pass: adminData.password,
    });

    setSelectedId(null);
    setFormData({ chapter: '' });
    setAdminData({ email: '', password: '' }); // Reset admin data
    setShowModal(false); // Close the modal after editing
    fetchChapters();
  };

  // Save admin data (Admin Email and Password)
  const saveAdmin = async () => {
    if (!dropdownId) return alert("Select a chapter");
    await axios.post(`https://api.lbnhyderabad.com/admin-dashboard/chapters/${dropdownId}/admin`, adminData);
    setAdminData({ email: '', password: '' });
    fetchChapters();
  };

  // Open the modal for editing
  const handleEditClick = (chap) => {
    setFormData({ chapter: chap.chapter });
    setAdminData({ email: chap.email || '', password: chap.pass || '' }); // Set the admin data for editing
    setSelectedId(chap.id);
    setShowModal(true);
  };

    const [currentPageIndex, setCurrentPageIndex] = useState(0);
  const [chaptersPerPageLimit] = useState(5); // Limit number of chapters per page

  // Calculate the index for the first and last chapter on the current page
  const lastChapterIndex = (currentPageIndex + 1) * chaptersPerPageLimit;
  const firstChapterIndex = lastChapterIndex - chaptersPerPageLimit;

  // Paginate the chapters for the current page
  const chaptersToDisplay = chapters.slice(firstChapterIndex, lastChapterIndex);

  // Calculate total pages
  const totalPageCount = Math.ceil(chapters.length / chaptersPerPageLimit);

  // Handle going to previous page
  const goToPreviousPage = () => {
    if (currentPageIndex > 0) {
      setCurrentPageIndex(currentPageIndex - 1);
    }
  };

  // Handle going to next page
  const goToNextPage = () => {
    if (currentPageIndex < totalPageCount - 1) {
      setCurrentPageIndex(currentPageIndex + 1);
    }
  };


  // --- Push Notification States & Handlers ---
  const [notificationModalIsOpen, setNotificationModalIsOpen] = React.useState(false);
  const [notificationType, setNotificationType] = React.useState('ios'); // 'ios' or 'android'
  const [notificationData, setNotificationData] = React.useState({
    title: '',
    body: '',
    image: null,
  });


  const [notificationsList, setNotificationsList] = React.useState([]);
  const [filterPlatform, setFilterPlatform] = React.useState('all');

  // Fetch notifications whenever filter changes
  const fetchNotifications = async () => {
    try {
      const url = filterPlatform === 'all' 
        ? 'https://api.lbnhyderabad.com/notification/api/push-notifications' 
        : `https://api.lbnhyderabad.com/notification/api/push-notifications?platform=${filterPlatform}`;
      
      const response = await fetch(url);
      const data = await response.json();
      if (data.success) {
        setNotificationsList(data.data);
      }
    } catch (error) {
      console.error('Error fetching notifications:', error);
    }
  };

  React.useEffect(() => {
    if (activeSection === "Notifications") {
      fetchNotifications();
    }
  }, [activeSection, filterPlatform]);

  // Delete notification handler
  const handleDeleteNotification = async (id) => {
    if (!window.confirm("Are you sure you want to delete this notification record?")) return;
    
    try {
      const response = await fetch(`/api/push-notifications/${id}`, {
        method: 'DELETE',
      });
      const data = await response.json();
      if (data.success) {
        setNotificationsList((prev) => prev.filter((item) => item.id !== id));
        alert('Notification deleted successfully!');
      } else {
        alert(data.message || 'Failed to delete');
      }
    } catch (error) {
      console.error('Error deleting notification:', error);
    }
  };

  const handleOpenNotificationModal = (type) => {
    setNotificationType(type);
    setNotificationModalIsOpen(true);
  };

  const handleCloseNotificationModal = () => {
    setNotificationModalIsOpen(false);
    setNotificationData({ title: '', body: '', image: null });
  };

  const handleNotificationChange = (e) => {
    const { name, value } = e.target;
    setNotificationData((prev) => ({ ...prev, [name]: value }));
  };

  const handleNotificationImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setNotificationData((prev) => ({ ...prev, image: e.target.files[0] }));
    }
  };

  const handleNotificationSubmit = async (e) => {
    e.preventDefault();
    try {
      // Create FormData if uploading an image file, or send JSON if storing image URL/base64
      const formData = new FormData();
      formData.append('platform', notificationType);
      formData.append('title', notificationData.title);
      formData.append('body', notificationData.body);
      if (notificationData.image) {
        formData.append('image', notificationData.image);
      }

      const response = await fetch('https://api.lbnhyderabad.com/notification/api/send-notification', {
        method: 'POST',
        body: formData, // use JSON.stringify if you handle images separately
      });

      const data = await response.json();
      if (data.success) {
        alert(`${notificationType.toUpperCase()} notification sent successfully!`);
        handleCloseNotificationModal();
      } else {
        alert(data.message || 'Failed to send notification');
      }
    } catch (error) {
      console.error('Error submitting notification:', error);
      alert('An error occurred while sending the notification.');
    }
  };


  return (
    <>
      {/* <div className="header">
        <img
          alt="Lions Club Logo"
          height="50"
          src={logo1}
          width="50"
        />
        <header className="header-dashboard">
          <Navbar
            expand="lg"
            style={{ color: "white", backgroundColor: "#4c51bf" }}
          >
            <Container style={{ color: "white" }}>


              <Navbar.Toggle aria-controls="navbar-nav" onClick={() => setIsNavbarCollapsed(!isNavbarCollapsed)} />

              <Navbar.Collapse id="navbar-nav" in={!isNavbarCollapsed}>
                <Nav className="me-auto">
                  <Nav.Link
                    onClick={() => handleNavClick("dashboard")}
                    style={{ color: "white" }}
                  >
                    Home
                  </Nav.Link>
                   <Nav.Link
                    onClick={() => handleNavClick("chapter")}
                    style={{ color: "white" }}
                  >
                    Chapter Admins
                  </Nav.Link>
                  <Nav.Link
                    onClick={() => handleNavClick("products")}
                    style={{ color: "white" }}
                  >
                    Products
                  </Nav.Link>

                  <Nav.Link
                    onClick={() => handleNavClick("Meetings")}
                    style={{ color: "white" }}
                  >
                    Meetings
                  </Nav.Link>
                  <Nav.Link
                    onClick={() => handleNavClick("Events")}
                    style={{ color: "white" }}
                  >
                    Events
                  </Nav.Link>

                  <Nav.Link onClick={() => handleNavClick("Images")} style={{ color: "white" }}>AD Images</Nav.Link>
                    <NavDropdown title={<span style={{ color: "white" }}>Reports</span>} id="reports-dropdown" >
                    <NavDropdown.Item onClick={() => handleNavClick("referral-out")}>Referral Report</NavDropdown.Item>
                     <NavDropdown.Item onClick={() => handleNavClick("thanks-note")}>Thanks Report</NavDropdown.Item>
                    <NavDropdown.Item onClick={() => handleNavClick("one-to-one")}>One-to-One Report</NavDropdown.Item>
                    <NavDropdown.Item onClick={() => handleNavClick("meeting-attendance")}>Meeting Att Report</NavDropdown.Item>
                    <NavDropdown.Item onClick={() => handleNavClick("event-attendance")}>Event Att Report</NavDropdown.Item>
                  </NavDropdown>
                </Nav>


                <Nav>


                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>
        </header>



        <h1>Welcome Admin Dashboard</h1>

        <FaUserCircle
          className="profile-icon"
          onClick={handleIconClick}
          style={{ cursor: 'pointer', fontSize: '30px' }}
        />

        {showLogout && (
          <div className="logout-dropdown">
            <button onClick={handleLogout} className="logout-btn">Logout</button>
          </div>
        )}
      </div> */}
<div
  className="header"
  style={{
    position: "sticky",
    top: 0,
    zIndex: 999,
    background: "rgba(255,255,255,0.96)",
    backdropFilter: "blur(12px)",
    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
    borderBottom: "1px solid rgba(0,0,0,0.06)",
      display:
      modalIsOpenn || modalIsOpen || notificationModalIsOpen|| 
      showMeetingModal || modalIsOpennn || notificationModalIsOpen|| 
      modalIsOpennn || modalIsOpenEvent ||  showThanksModal ||
  showInviteModal ||
      showReferralModal1  
        ? "none"
        : "block",
  
  }}
>
  {/* LEFT LOGO */}
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "12px",
    }}
  >
    <img
      alt="Lions Club Logo"
      src={logo1}
      width="55"
      height="55"
      style={{
        borderRadius: "50%",
        objectFit: "cover",
        border: "3px solid #f59e0b",
        boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
      }}
    />

    <div className="desktop-admin-title">
      <h3
        style={{
          margin: 0,
          color: "#1e3a8a",
          fontSize: "20px",
          fontWeight: "700",
          lineHeight: "1.1",
        }}
      >
        Admin Portal
      </h3>

      <p
        style={{
          margin: 0,
          color: "#666",
          fontSize: "12px",
          fontWeight: "500",
        }}
      >
        Multiple District 320
      </p>
    </div>
  </div>

  {/* NAVBAR */}
  <header
    className="header-dashboard"
    style={{
      flex: 1,
      display: "flex",
      justifyContent: "center",
    }}
  >
    <Navbar
      expand="lg"
      expanded={!isNavbarCollapsed}
      style={{
        width: "100%",
        background: "transparent",
        padding: 0,
      }}
    >
      <Container
        fluid
        style={{
          padding: 0,
        }}
      >
        {/* MOBILE TOGGLE */}
        <Navbar.Toggle
          aria-controls="navbar-nav"
          onClick={() =>
            setIsNavbarCollapsed(!isNavbarCollapsed)
          }
          style={{
            border: "none",
            background: "#eff6ff",
            padding: "10px 12px",
            borderRadius: "12px",
            boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
          }}
        >
          {isNavbarCollapsed ? (
            <FaBars
              style={{
                color: "#1e3a8a",
                fontSize: "22px",
              }}
            />
          ) : (
            <FaTimes
              style={{
                color: "#1e3a8a",
                fontSize: "22px",
              }}
            />
          )}
        </Navbar.Toggle>

        {/* OVERLAY */}
        {!isNavbarCollapsed && (
          <div
            onClick={() => setIsNavbarCollapsed(true)}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100vh",
              background: "rgba(0,0,0,0.45)",
              zIndex: 9998,
            }}
          />
        )}

        {/* DESKTOP + MOBILE SIDEBAR */}
        <Navbar.Collapse
          id="navbar-nav"
          style={{
            justifyContent: "center",
          }}
        >
          {/* DESKTOP MENU */}
          <Nav
            className="desktop-navbar-links"
            style={{
              alignItems: "center",
              gap: "8px",
            }}
          >
            <Nav.Link
              onClick={() => handleNavClick("dashboard")}
              style={{
                color: "#1e3a8a",
                fontWeight: "600",
                padding: "10px 18px",
                borderRadius: "10px",
              }}
            >
              Home
            </Nav.Link>

            <Nav.Link
              onClick={() => handleNavClick("chapter")}
              style={{
                color: "#1e3a8a",
                fontWeight: "600",
                padding: "10px 18px",
                borderRadius: "10px",
              }}
            >
              Chapter Admins
            </Nav.Link>

            <Nav.Link
              onClick={() => handleNavClick("products")}
              style={{
                color: "#1e3a8a",
                fontWeight: "600",
                padding: "10px 18px",
                borderRadius: "10px",
              }}
            >
              Products
            </Nav.Link>

            <Nav.Link
              onClick={() => handleNavClick("Meetings")}
              style={{
                color: "#1e3a8a",
                fontWeight: "600",
                padding: "10px 18px",
                borderRadius: "10px",
              }}
            >
              Meetings
            </Nav.Link>

            <Nav.Link
              onClick={() => handleNavClick("Events")}
              style={{
                color: "#1e3a8a",
                fontWeight: "600",
                padding: "10px 18px",
                borderRadius: "10px",
              }}
            >
              Events
            </Nav.Link>

            <Nav.Link
              onClick={() => handleNavClick("Images")}
              style={{
                color: "#1e3a8a",
                fontWeight: "600",
                padding: "10px 18px",
                borderRadius: "10px",
              }}
            >
              AD Images
            </Nav.Link>

    <Nav.Link
              onClick={() => handleNavClick("Notifications")}
              style={{
                color: "#1e3a8a",
                fontWeight: "600",
                padding: "10px 18px",
                borderRadius: "10px",
              }}
            >
              Notifications
            </Nav.Link>
            <NavDropdown
              title={
                <span
                  style={{
                    color: "#1e3a8a",
                    fontWeight: "600",
                  }}
                >
                  Reports
                </span>
              }
              id="reports-dropdown"
            >
              <NavDropdown.Item
                onClick={() =>
                  handleNavClick("referral-out")
                }
              >
                Referral Report
              </NavDropdown.Item>

              <NavDropdown.Item
                onClick={() =>
                  handleNavClick("thanks-note")
                }
              >
                Thanks Report
              </NavDropdown.Item>

              <NavDropdown.Item
                onClick={() =>
                  handleNavClick("one-to-one")
                }
              >
                One-to-One Report
              </NavDropdown.Item>

              <NavDropdown.Item
                onClick={() =>
                  handleNavClick("meeting-attendance")
                }
              >
                Meeting Att Report
              </NavDropdown.Item>

              <NavDropdown.Item
                onClick={() =>
                  handleNavClick("event-attendance")
                }
              >
                Event Att Report
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>

          {/* MOBILE SIDEBAR */}
          <div
            className="mobile-sidebar"
            style={{
              position: "fixed",
              top: 0,
              right: isNavbarCollapsed ? "-100%" : "0",
              width: "290px",
              maxWidth: "85%",
              height: "100vh",
              background: "#fff",
              zIndex: 9999,
              padding: "22px",
              transition: "all 0.35s ease",
              boxShadow:
                "-10px 0 30px rgba(0,0,0,0.18)",
              overflowY: "auto",
            }}
          >
            {/* TOP */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "30px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <img
                  src={logo1}
                  alt=""
                  width="50"
                  height="50"
                  style={{
                    borderRadius: "50%",
                    border: "3px solid #f59e0b",
                  }}
                />

                <div>
                  <h4
                    style={{
                      margin: 0,
                      color: "#1e3a8a",
                      fontSize: "18px",
                      fontWeight: "700",
                    }}
                  >
                    Admin
                  </h4>

                  <p
                    style={{
                      margin: 0,
                      fontSize: "12px",
                      color: "#777",
                    }}
                  >
                    Dashboard
                  </p>
                </div>
              </div>

              <FaTimes
                onClick={() =>
                  setIsNavbarCollapsed(true)
                }
                style={{
                  cursor: "pointer",
                  color: "#1e3a8a",
                  fontSize: "24px",
                }}
              />
            </div>

            {/* MOBILE LINKS */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              <button
                onClick={() => {
                  handleNavClick("dashboard");
                  setIsNavbarCollapsed(true);
                }}
                style={mobileBtnStyle}
              >
                Home
              </button>

              <button
                onClick={() => {
                  handleNavClick("chapter");
                  setIsNavbarCollapsed(true);
                }}
                style={mobileBtnStyle}
              >
                Chapter Admins
              </button>

              <button
                onClick={() => {
                  handleNavClick("products");
                  setIsNavbarCollapsed(true);
                }}
                style={mobileBtnStyle}
              >
                Products
              </button>

              <button
                onClick={() => {
                  handleNavClick("Meetings");
                  setIsNavbarCollapsed(true);
                }}
                style={mobileBtnStyle}
              >
                Meetings
              </button>

              <button
                onClick={() => {
                  handleNavClick("Events");
                  setIsNavbarCollapsed(true);
                }}
                style={mobileBtnStyle}
              >
                Events
              </button>

              <button
                onClick={() => {
                  handleNavClick("Images");
                  setIsNavbarCollapsed(true);
                }}
                style={mobileBtnStyle}
              >
                AD Images
              </button>

              <div
                style={{
                  marginTop: "15px",
                  paddingTop: "15px",
                  borderTop: "1px solid #eee",
                }}
              >
                <h5
                  style={{
                    color: "#1e3a8a",
                    marginBottom: "12px",
                    fontWeight: "700",
                  }}
                >
                  Reports
                </h5>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                  }}
                >
                  <button
                    onClick={() => {
                      handleNavClick("referral-out");
                      setIsNavbarCollapsed(true);
                    }}
                    style={mobileSubBtnStyle}
                  >
                    Referral Report
                  </button>

                  <button
                    onClick={() => {
                      handleNavClick("thanks-note");
                      setIsNavbarCollapsed(true);
                    }}
                    style={mobileSubBtnStyle}
                  >
                    Thanks Report
                  </button>

                  <button
                    onClick={() => {
                      handleNavClick("one-to-one");
                      setIsNavbarCollapsed(true);
                    }}
                    style={mobileSubBtnStyle}
                  >
                    One-to-One Report
                  </button>

                  <button
                    onClick={() => {
                      handleNavClick("meeting-attendance");
                      setIsNavbarCollapsed(true);
                    }}
                    style={mobileSubBtnStyle}
                  >
                    Meeting Att Report
                  </button>

                  <button
                    onClick={() => {
                      handleNavClick("event-attendance");
                      setIsNavbarCollapsed(true);
                    }}
                    style={mobileSubBtnStyle}
                  >
                    Event Att Report
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  </header>

  {/* RIGHT SECTION */}
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: "15px",
      marginTop:'20px'
    }}
  >
    <h1
      style={{
        margin: 0,
        color: "#1e3a8a",
        fontSize: "22px",
        fontWeight: "700",
      }}
      className="welcome-admin-title"
    >
      Welcome Admin Dashboard
    </h1>

    <div 
    style={{ position: "relative" }}
    >
      <FaUserCircle
        className="profile-icon"
        onClick={handleIconClick}
        style={{
          cursor: "pointer",
          fontSize: "36px",
          color: "#1e3a8a",
        }}
      />

      {showLogout && (
        <div
          className="logout-dropdown"
          style={{
            position: "absolute",
            top: "48px",
            right: 0,
            background: "#fff",
            borderRadius: "14px",
            padding: "10px",
            minWidth: "160px",
            boxShadow:
              "0 10px 25px rgba(0,0,0,0.12)",
            zIndex: 999,
          }}
        >
          <button
            onClick={handleLogout}
            className="logout-btn"
            style={{
              width: "100%",
              border: "none",
              background:
                "linear-gradient(135deg,#ef4444,#dc2626)",
              color: "#fff",
              padding: "12px",
              borderRadius: "10px",
              fontWeight: "600",
              cursor: "pointer",
            }}
          >
            Logout
          </button>
        </div>
      )}
    </div>
  </div>

  {/* RESPONSIVE CSS */}
  <style>
    {`
      .header{
        width:100%;
        display:flex;
        align-items:center;
        justify-content:space-between;
        gap:20px;
        padding:14px 24px;
      }

      .mobile-sidebar{
        display:none;
      }

      @media(max-width:991px){

        .desktop-navbar-links{
          display:none !important;
        }

        .mobile-sidebar{
          display:block !important;
        }

        .welcome-admin-title{
          display:none;
        }

        .desktop-admin-title{
          display:none;
        }

        .header{
          padding:12px 16px;
        }
      }

      @media(max-width:500px){

        .header{
          gap:10px;
          padding:10px 12px;
        }

        .profile-icon{
          font-size:32px !important;
        }
      }
    `}
  </style>
</div>

      

      {/* {activeSection === "dashboard" && (
        <div className="container">
          <h2 style={{ marginTop: 20 }} className="section-title">Lions Business Network - Multiple District 320</h2>


          <div className="search-box">
            <input placeholder="Search users..." type="text" style={{ fontSize: '14px', padding: '8px' }} value={searchTerm} // Bind the input to the search term state
              onChange={(e) => setSearchTerm(e.target.value)} />
          </div>
          <div className='response-container'>

            <div className="table-container">
              <table className="user-table">
                <thead>
                  <tr>
                    <th>User</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Mobile</th>
                    <th>Membership Number</th>
                    <th>Referral Details</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentUsers.map((user, index) => (
                    <tr key={index}>
                      <td>
                        <FaUserCircle className="user-icon" style={{ fontSize: '20px' }} />
                      </td>
                      <td>{user.name}</td>
                      <td>{user.email}</td>
                      <td>{user.mobile}</td>
                      <td>{user.membershipNo}</td>
                      <td>
                        <button onClick={() => handleReferralClick(user.id, user.name)}>Click here</button>
                      </td>
                      <td>{user.isApprove === 0 ? 'Not Approved' : 'Approved'}</td>
                      <td className="action-buttons">
                        {user.isApprove === 0 ? (
                          <button style={{ backgroundColor: '#4c51bf', color: 'white' }} onClick={() => handleApprove({ userEmail: user.email, userName: user.name, id: user.id })}>Approve</button>
                        ) : (
                          <span > <button style={{ color: 'white', backgroundColor: 'green' }}>Approved</button></span>
                        )}

                        {/* <button className="view" onClick={() => {
                          openModal()
                          handleView({ userEmail: user.email });
                          handleViewUser({ userEmail: user.email });
                        }}>
                          View
                        </button>  *
                      </td>
                      {/* <td className="action-buttons">
                        {user.isApprove === 0 ? (
                          <button
                            style={{ backgroundColor: '#4c51bf', color: 'white' }}
                            onClick={() => handleApprove({ userEmail: user.email, userName: user.name, userId: user.id })}
                            disabled={isApproving} // Optionally disable the button while approving
                          >
                            {isApproving ? 'Approving...' : 'Approve'}
                          </button>
                        ) : (
                          <span>
                            <button style={{ color: 'white', backgroundColor: 'green' }}>Approved</button>
                          </span>
                        )}
                      </td> *

                    </tr>
                  ))}
                </tbody>
              </table>
              <Modal
                isOpen={showReferralModal}
                onRequestClose={() => setShowReferralModal(false)}
                contentLabel="Referral Details"
                style={{
                  chapter: {
                    top: "50%",
                    left: "50%",
                    right: "auto",
                    bottom: "auto",
                    marginRight: "-50%",
                    transform: "translate(-50%, -50%)",
                    width: "600px",
                    maxHeight: "80vh",
                    overflowY: "auto",
                    padding: "20px",
                    borderRadius: "12px",
                  },
                  overlay: {
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                  },
                }}
              >
                <h2 style={{ marginBottom: "10px" }}>{selectedUserName}'s Referral Details</h2>
                <p style={{ marginTop: "5px", fontWeight: "bold", color: "#4c51bf" }}>
                  {selectedUserReferrals.length} member{selectedUserReferrals.length !== 1 && "s"} referred by {selectedUserName}
                </p>
                <button
                  onClick={() => setShowReferralModal(false)}
                  style={{
                    float: "right",
                    padding: "6px 12px",
                    backgroundColor: "red",
                    color: "white",
                    border: "none",
                    borderRadius: "6px",
                    cursor: "pointer",
                  }}
                >
                  Close
                </button>

                {selectedUserReferrals.length > 0 ? (
                  <ul style={{ marginTop: "20px" }}>
                    {selectedUserReferrals.map((ref, idx) => (
                      <li key={idx} style={{ marginBottom: "10px" }}>
                        <strong>{ref.name}</strong> - {ref.email}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p>No referral data found.</p>
                )}
              </Modal>
              {/* Pagination *
              <div className="paginationn">
                <button
                  onClick={handlePrevPage}
                  className="page-buttonn"
                  disabled={currentPage === 1}  // Disable the Previous button if on the first page
                >
                  Previous
                </button>

                {/* Page numbers *
                {Array.from({ length: totalPages }, (_, index) => (
                  <button
                    key={index}
                    className={`page-buttonn ${currentPage === index + 1 ? 'active' : ''}`}
                    onClick={() => handlePageChange(index + 1)}
                  >
                    {index + 1}
                  </button>
                ))}

                <button
                  onClick={handleNextPage}
                  className="page-buttonn"
                  disabled={currentPage === totalPages}  // Disable the Next button if on the last page
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      )} */}
      {activeSection === "dashboard" && (
  <div
    style={{
      minHeight: "100vh",
      background: "#f4f7fb",
      padding: "20px 10px",
    }}
  >
    {/* Top Header Card */}
    <div
      style={{
        background: "linear-gradient(135deg, #1e3a8a, #2563eb)",
        borderRadius: "20px",
        padding: "25px",
        marginBottom: "25px",
        color: "white",
        boxShadow: "0 10px 30px rgba(37,99,235,0.18)",
      }}
    >
      <h2
        style={{
          margin: 0,
          fontSize: "32px",
          fontWeight: "700",
          lineHeight: "42px",
        }}
      >
        Lions Business Network
      </h2>

      <p
        style={{
          marginTop: "8px",
          opacity: 0.9,
          fontSize: "16px",
        }}
      >
        Multiple District 320 Admin Dashboard
      </p>
    </div>

    {/* Main Content Card */}
    <div
      style={{
        background: "#fff",
        borderRadius: "20px",
        overflow: "hidden",
        boxShadow: "0 4px 25px rgba(0,0,0,0.08)",
      }}
    >
      {/* Search Section */}
      <div
        style={{
          padding: "20px",
          borderBottom: "1px solid #edf2f7",
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "15px",
          background: "#fafcff",
        }}
      >
        <div>
          <h3
            style={{
              margin: 0,
              fontSize: "22px",
              fontWeight: "700",
              color: "#1e293b",
            }}
          >
            Membership Verification Requests
          </h3>

          <p
            style={{
              marginTop: "5px",
              color: "#64748b",
              fontSize: "14px",
            }}
          >
            Review and approve member onboarding requests
          </p>
        </div>

        <div
          style={{
            position: "relative",
            width: "100%",
            maxWidth: "350px",
          }}
        >
          <input
            placeholder="Search users..."
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              width: "100%",
              padding: "12px 18px",
              borderRadius: "12px",
              border: "1px solid #dbe4f0",
              outline: "none",
              fontSize: "14px",
              background: "#fff",
              boxShadow: "0 2px 10px rgba(0,0,0,0.03)",
            }}
          />
        </div>
      </div>

      {/* Responsive Table */}
      <div
        style={{
          width: "100%",
          overflowX: "auto",
        }}
      >
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            minWidth: "1100px",
          }}
        >
          <thead
            style={{
              background: "#f8fafc",
            }}
          >
            <tr>
              <th
                style={{
                  padding: "18px",
                  textAlign: "left",
                  color: "#475569",
                  fontSize: "13px",
                  fontWeight: "700",
                }}
              >
                User
              </th>

              <th
                style={{
                  padding: "18px",
                  textAlign: "left",
                  color: "#475569",
                  fontSize: "13px",
                  fontWeight: "700",
                }}
              >
                Name
              </th>

              <th
                style={{
                  padding: "18px",
                  textAlign: "left",
                  color: "#475569",
                  fontSize: "13px",
                  fontWeight: "700",
                }}
              >
                Email
              </th>

              <th
                style={{
                  padding: "18px",
                  textAlign: "left",
                  color: "#475569",
                  fontSize: "13px",
                  fontWeight: "700",
                }}
              >
                Mobile
              </th>

              <th
                style={{
                  padding: "18px",
                  textAlign: "left",
                  color: "#475569",
                  fontSize: "13px",
                  fontWeight: "700",
                }}
              >
                Membership Number
              </th>

              <th
                style={{
                  padding: "18px",
                  textAlign: "left",
                  color: "#475569",
                  fontSize: "13px",
                  fontWeight: "700",
                }}
              >
                Referral Details
              </th>

              <th
                style={{
                  padding: "18px",
                  textAlign: "left",
                  color: "#475569",
                  fontSize: "13px",
                  fontWeight: "700",
                }}
              >
                Status
              </th>

              <th
                style={{
                  padding: "18px",
                  textAlign: "center",
                  color: "#475569",
                  fontSize: "13px",
                  fontWeight: "700",
                }}
              >
                Action
              </th>
            </tr>
          </thead>

          <tbody>
            {currentUsers.map((user, index) => (
              <tr
                key={index}
                style={{
                  borderTop: "1px solid #edf2f7",
                  transition: "0.3s",
                }}
              >
                <td
                  style={{
                    padding: "18px",
                  }}
                >
                  <div
                    style={{
                      width: "42px",
                      height: "42px",
                      borderRadius: "50%",
                      background:
                        "linear-gradient(135deg, #2563eb, #1e40af)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "white",
                    }}
                  >
                    <FaUserCircle style={{ fontSize: "22px" }} />
                  </div>
                </td>

                <td
                  style={{
                    padding: "18px",
                    fontWeight: "600",
                    color: "#0f172a",
                  }}
                >
                  {user.name}
                </td>

                <td
                  style={{
                    padding: "18px",
                    color: "#475569",
                    fontSize: "14px",
                  }}
                >
                  {user.email}
                </td>

                <td
                  style={{
                    padding: "18px",
                    color: "#475569",
                  }}
                >
                  {user.mobile}
                </td>

                <td
                  style={{
                    padding: "18px",
                    color: "#0f172a",
                    fontWeight: "600",
                  }}
                >
                  {user.membershipNo}
                </td>

                <td
                  style={{
                    padding: "18px",
                  }}
                >
                  <button
                    onClick={() =>
                      handleReferralClick(user.id, user.name)
                    }
                    style={{
                      border: "none",
                      background: "#eff6ff",
                      color: "#2563eb",
                      padding: "10px 14px",
                      borderRadius: "10px",
                      fontWeight: "600",
                      cursor: "pointer",
                      transition: "0.3s",
                    }}
                  >
                    Click here
                  </button>
                </td>

                <td
                  style={{
                    padding: "18px",
                  }}
                >
                  {user.isApprove === 0 ? (
                    <span
                      style={{
                        background: "#fff7ed",
                        color: "#ea580c",
                        padding: "8px 14px",
                        borderRadius: "30px",
                        fontSize: "12px",
                        fontWeight: "700",
                      }}
                    >
                      Not Approved
                    </span>
                  ) : (
                    <span
                      style={{
                        background: "#ecfdf5",
                        color: "#059669",
                        padding: "8px 14px",
                        borderRadius: "30px",
                        fontSize: "12px",
                        fontWeight: "700",
                      }}
                    >
                      Approved
                    </span>
                  )}
                </td>

                <td
                  style={{
                    padding: "18px",
                    textAlign: "center",
                  }}
                >
                  {user.isApprove === 0 ? (
                    <button
                      style={{
                        background:
                          "linear-gradient(135deg, #2563eb, #1d4ed8)",
                        color: "white",
                        border: "none",
                        padding: "10px 18px",
                        borderRadius: "10px",
                        fontWeight: "600",
                        cursor: "pointer",
                        boxShadow:
                          "0 4px 14px rgba(37,99,235,0.25)",
                      }}
                      onClick={() =>
                        handleApprove({
                          userEmail: user.email,
                          userName: user.name,
                          id: user.id,
                        })
                      }
                    >
                      Approve
                    </button>
                  ) : (
                    <button
                      style={{
                        background:
                          "linear-gradient(135deg, #10b981, #059669)",
                        color: "white",
                        border: "none",
                        padding: "10px 18px",
                        borderRadius: "10px",
                        fontWeight: "600",
                      }}
                    >
                      Approved
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal */}
      <Modal
        isOpen={showReferralModal}
        onRequestClose={() => setShowReferralModal(false)}
        contentLabel="Referral Details"
        style={{
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            width: "95%",
            maxWidth: "650px",
            maxHeight: "85vh",
            overflowY: "auto",
            padding: "0",
            borderRadius: "20px",
            border: "none",
            background: "#fff",
            boxShadow: "0 20px 60px rgba(0,0,0,0.2)",
          },
          overlay: {
            backgroundColor: "rgba(15,23,42,0.65)",
            zIndex: 999,
          },
        }}
      >
        {/* Modal Header */}
        <div
          style={{
            padding: "22px",
            borderBottom: "1px solid #edf2f7",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background:
              "linear-gradient(135deg, #1e3a8a, #2563eb)",
            color: "white",
          }}
        >
          <div>
            <h2
              style={{
                margin: 0,
                fontSize: "24px",
                fontWeight: "700",
              }}
            >
              {selectedUserName}'s Referral Details
            </h2>

            <p
              style={{
                marginTop: "6px",
                opacity: 0.9,
                fontSize: "14px",
              }}
            >
              {selectedUserReferrals.length} member
              {selectedUserReferrals.length !== 1 && "s"} referred
            </p>
          </div>

          <button
            onClick={() => setShowReferralModal(false)}
            style={{
              background: "rgba(255,255,255,0.15)",
              border: "none",
              color: "white",
              padding: "10px 14px",
              borderRadius: "10px",
              cursor: "pointer",
              fontWeight: "600",
            }}
          >
            Close
          </button>
        </div>

        {/* Modal Content */}
        <div
          style={{
            padding: "20px",
            background: "#f8fafc",
          }}
        >
          {selectedUserReferrals.length > 0 ? (
            selectedUserReferrals.map((ref, idx) => (
              <div
                key={idx}
                style={{
                  background: "white",
                  borderRadius: "14px",
                  padding: "16px",
                  marginBottom: "12px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.04)",
                }}
              >
                <div>
                  <div
                    style={{
                      fontWeight: "700",
                      color: "#0f172a",
                    }}
                  >
                    {ref.name}
                  </div>

                  <div
                    style={{
                      marginTop: "4px",
                      color: "#64748b",
                      fontSize: "14px",
                    }}
                  >
                    {ref.email}
                  </div>
                </div>

                <div
                  style={{
                    background: "#eff6ff",
                    color: "#2563eb",
                    padding: "6px 12px",
                    borderRadius: "30px",
                    fontSize: "12px",
                    fontWeight: "700",
                  }}
                >
                  #{idx + 1}
                </div>
              </div>
            ))
          ) : (
            <div
              style={{
                textAlign: "center",
                padding: "30px",
                color: "#64748b",
              }}
            >
              No referral data found.
            </div>
          )}
        </div>
      </Modal>

      {/* Pagination */}
      <div
        className="paginationn"
        style={{
          padding: "20px",
          borderTop: "1px solid #edf2f7",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "10px",
          flexWrap: "wrap",
          background: "#fafcff",
        }}
      >
        <button
          onClick={handlePrevPage}
          className="page-buttonn"
          disabled={currentPage === 1}
          style={{
            border: "1px solid #dbe4f0",
            background: "#fff",
            padding: "10px 16px",
            borderRadius: "10px",
            cursor: "pointer",
            fontWeight: "600",
          }}
        >
          Previous
        </button>

        {Array.from({ length: totalPages }, (_, index) => (
          <button
            key={index}
            className={`page-buttonn ${
              currentPage === index + 1 ? "active" : ""
            }`}
            onClick={() => handlePageChange(index + 1)}
            style={{
              width: "42px",
              height: "42px",
              borderRadius: "10px",
              border:
                currentPage === index + 1
                  ? "none"
                  : "1px solid #dbe4f0",
              background:
                currentPage === index + 1
                  ? "#2563eb"
                  : "#fff",
              color:
                currentPage === index + 1
                  ? "white"
                  : "#334155",
              fontWeight: "700",
              cursor: "pointer",
            }}
          >
            {index + 1}
          </button>
        ))}

        <button
          onClick={handleNextPage}
          className="page-buttonn"
          disabled={currentPage === totalPages}
          style={{
            border: "1px solid #dbe4f0",
            background: "#fff",
            padding: "10px 16px",
            borderRadius: "10px",
            cursor: "pointer",
            fontWeight: "600",
          }}
        >
          Next
        </button>
      </div>
    </div>
  </div>
)}

{/* {activeSection === "chapter" && (
 <>
    <div style={{ padding: 20,margin:20 }}>
      <h2>📘 Chapters</h2>
      {/* <input
        placeholder="Title"
        value={formData.title}
        onChange={e => setFormData({ ...formData, title: e.target.value })}
      />*
      <input 
        placeholder="Chapter"
        value={formData.chapter}
        onChange={e => setFormData({ ...formData, chapter: e.target.value })}
        style={{ marginLeft: 10 }}
      />
      <button onClick={selectedId ? editChapter : createChapter} style={{ marginLeft: 10 }}>
        {selectedId ? 'Update' : 'Create'}
      </button>


      <h3 style={{ marginTop: 30 }}>🔐 Assign Admin to Chapter</h3>
      <select
        value={dropdownId}
        onChange={e => setDropdownId(e.target.value)}
      >
        <option value="">-- Select Chapter --</option>
        {chapters.map(c => (
          <option key={c.id} value={c.id}>{c.chapter}</option>
        ))}
      </select>
      <div style={{ marginTop: 10 }}>
        <input
          placeholder="Email"
          value={adminData.email}
          onChange={e => setAdminData({ ...adminData, email: e.target.value })}
        />
        <input
          placeholder="Password"
          type="text"
          value={adminData.password}
          onChange={e => setAdminData({ ...adminData, password: e.target.value })}
          style={{ marginLeft: 10 }}
        />
        <button onClick={saveAdmin} style={{ marginLeft: 10 }}>Save Admin</button>
      </div>

      
      <table border="1" style={{ marginTop: 20, width: '100%' }}>
        <thead>
          <tr>
           
            <th>Content</th>
            <th>Admin Email</th>
            <th>Admin Password</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {chapters.map(chap => (
            <tr key={chap.id}>
              
              <td>{chap.chapter}</td>
              <td>{chap.email || '-'}</td>
              <td>{chap.password || '-'}</td>
              <td>
                <button onClick={() => {
                  setFormData({ title: chap.title, chapter: chap.chapter });
                  setSelectedId(chap.id);
                }}>Edit</button>
                <button onClick={() => deleteChapter(chap.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
 </>
)} */}


{/* {activeSection === "chapter" && (
    <div style={{ padding: 20, maxWidth: 600, margin: 'auto' }}>
      <h2>📘 Chapter Management</h2>

      <div style={{ marginBottom: 20 }}>
        <label>Chapter Name:</label><br />
        <input
          placeholder="Enter chapter name"
          value={formData.chapter}
          onChange={(e) => setFormData({ ...formData, chapter: e.target.value })}
          style={{ width: '100%', padding: 8, marginTop: 5 }}
        />
        <button
          onClick={selectedId ? editChapter : createChapter}
          style={{
            marginTop: 10,
            padding: '8px 16px',
            backgroundColor: '#007bff',
            color: '#fff',
            border: 'none',
            cursor: 'pointer',
          }}
        >
          {selectedId ? 'Update Chapter' : 'Create Chapter'}
        </button>
      </div>

      <h3>🔐 Assign Admin to Chapter</h3>
      <div style={{ marginBottom: 20 }}>
        <label>Select Chapter:</label><br />
        <select
          value={dropdownId}
          onChange={(e) => {
            const selectedValue = e.target.value;
            setDropdownId(selectedValue);

            const selectedChapter = chapters.find((c) => c.id.toString() === selectedValue);

            if (selectedChapter && selectedChapter.email && selectedChapter.pass) {
              alert("⚠️ Login details already created for this chapter.");
              setDropdownId('');
            }
          }}
          style={{ width: '100%', padding: 8, marginTop: 5 }}
        >
          <option value="">-- Select Chapter --</option>
          {chapters.map((c) => (
            <option key={c.id} value={c.id}>
              {c.chapter}
            </option>
          ))}
        </select>

        <div style={{ marginTop: 10 }}>
          <input
            placeholder="Admin Email"
            value={adminData.email}
            onChange={(e) => setAdminData({ ...adminData, email: e.target.value })}
            style={{ width: '100%', padding: 8, marginBottom: 10 }}
          />
          <input
            placeholder="Admin Password"
            type="text"
            value={adminData.password}
            onChange={(e) => setAdminData({ ...adminData, password: e.target.value })}
            style={{ width: '100%', padding: 8 }}
          />
          <button
            onClick={saveAdmin}
            style={{
              marginTop: 10,
              padding: '8px 16px',
              backgroundColor: '#28a745',
              color: '#fff',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            Save Admin
          </button>
        </div>
      </div>

      <h3>📄 Chapters List</h3>
      <table border="1" style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th>Chapter</th>
            <th>Admin Email</th>
            <th>Admin Password</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {chapters.map((chap) => (
            <tr key={chap.id}>
              <td>{chap.chapter}</td>
              <td>{chap.email || '-'}</td>
              <td>{chap.pass || '-'}</td>
              <td>
                <button
                  onClick={() => handleEditClick(chap)} // Open modal for editing
                  style={{ marginRight: 5 }}
                >
                  Edit
                </button>
                <button onClick={() => deleteChapter(chap.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <Modal
        isOpen={showModal}
        onRequestClose={() => setShowModal(false)} // Close modal on request
        contentLabel="Edit Chapter Modal"
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            transform: 'translate(-50%, -50%)',
            width: '400px',
            padding: '20px',
            borderRadius: '8px',
          },
        }}
      >
        <h2>Edit Chapter</h2>
        <div style={{ marginBottom: 20 }}>
          <label>Chapter Name:</label><br />
          <input
            placeholder="Enter chapter name"
            value={formData.chapter}
            onChange={(e) => setFormData({ ...formData, chapter: e.target.value })}
            style={{ width: '100%', padding: 8, marginTop: 5 }}
          />
        </div>

        <div style={{ marginBottom: 20 }}>
          <label>Admin Email:</label><br />
          <input
            placeholder="Enter admin email"
            value={adminData.email}
            onChange={(e) => setAdminData({ ...adminData, email: e.target.value })}
            style={{ width: '100%', padding: 8, marginTop: 5 }}
          />
        </div>

        <div style={{ marginBottom: 20 }}>
          <label>Admin Password:</label><br />
          <input
            placeholder="Enter admin password"
            value={adminData.password}
            onChange={(e) => setAdminData({ ...adminData, password: e.target.value })}
            style={{ width: '100%', padding: 8, marginTop: 5 }}
          />
        </div>

        <div>
          <button
            onClick={editChapter}
            style={{
              marginRight: 10,
              padding: '8px 16px',
              backgroundColor: '#007bff',
              color: '#fff',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            Save Changes
          </button>
          <button
            onClick={() => setShowModal(false)}
            style={{
              padding: '8px 16px',
              backgroundColor: '#dc3545',
              color: '#fff',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            Cancel
          </button>
        </div>
      </Modal>
    </div>
)} */}


{/* {activeSection === "chapter" && (
  <div style={{ padding: 20, maxWidth: 800, margin: "auto", fontFamily: "Arial, sans-serif" }}>
      <h2 style={{ fontSize: "1.8rem", color: "#333" }}>📘 Chapter Management</h2>

   
      <div style={{ marginBottom: 20 }}>
        <label style={{ fontSize: "1rem", color: "#555" }}>Chapter Name:</label>
        <br />
        <input
          placeholder="Enter chapter name"
          value={formData.chapter}
          onChange={(e) => setFormData({ ...formData, chapter: e.target.value })}
          style={{
            width: "100%",
            padding: "12px",
            fontSize: "1rem",
            marginTop: 5,
            border: "1px solid #ddd",
            borderRadius: "4px",
            backgroundColor: "#f9f9f9",
            boxSizing: "border-box",
          }}
        />
        <button
          onClick={selectedId ? editChapter : createChapter}
          style={{
            marginTop: 15,
            padding: "10px 20px",
            backgroundColor: "#007bff",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            fontSize: "1rem",
          }}
        >
          {selectedId ? "Update Chapter" : "Create Chapter"}
        </button>
      </div>

      <h3 style={{ fontSize: "1.2rem", color: "#333" }}>🔐 Assign Admin to Chapter</h3>

      <div style={{ marginBottom: 20 }}>
        <label style={{ fontSize: "1rem", color: "#555" }}>Select Chapter:</label>
        <br />
        <select
          value={dropdownId}
          onChange={(e) => {
            const selectedValue = e.target.value;
            setDropdownId(selectedValue);

            const selectedChapter = chapters.find((c) => c.id.toString() === selectedValue);

            if (selectedChapter && selectedChapter.email && selectedChapter.pass) {
              alert("⚠️ Login details already created for this chapter.");
              setDropdownId("");
            }
          }}
          style={{
            width: "100%",
            padding: "12px",
            fontSize: "1rem",
            marginTop: 5,
            border: "1px solid #ddd",
            borderRadius: "4px",
            backgroundColor: "#f9f9f9",
          }}
        >
          <option value="">-- Select Chapter --</option>
          {chapters.map((c) => (
            <option key={c.id} value={c.id}>
              {c.chapter}
            </option>
          ))}
        </select>

     
        <div style={{ marginTop: 15 }}>
          <input
            placeholder="Admin Email"
            value={adminData.email}
            onChange={(e) => setAdminData({ ...adminData, email: e.target.value })}
            style={{
              width: "100%",
              padding: "12px",
              fontSize: "1rem",
              marginBottom: 10,
              border: "1px solid #ddd",
              borderRadius: "4px",
              backgroundColor: "#f9f9f9",
            }}
          />
          <input
            placeholder="Admin Password"
            type="text"
            value={adminData.password}
            onChange={(e) => setAdminData({ ...adminData, password: e.target.value })}
            style={{
              width: "100%",
              padding: "12px",
              fontSize: "1rem",
              marginBottom: 20,
              border: "1px solid #ddd",
              borderRadius: "4px",
              backgroundColor: "#f9f9f9",
            }}
          />
          <button
            onClick={saveAdmin}
            style={{
              padding: "10px 20px",
              backgroundColor: "#28a745",
              color: "#fff",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              fontSize: "1rem",
            }}
          >
            Save Admin
          </button>
        </div>
      </div>

      
      <h3 style={{ fontSize: "1.2rem", color: "#333" }}>📄 Chapters List</h3>
      <table border="1" style={{ width: "100%", borderCollapse: "collapse", marginTop: 20 }}>
        <thead style={{ backgroundColor: "#f2f2f2" }}>
          <tr>
            <th style={{ padding: "12px", textAlign: "left", fontSize: "1rem" }}>Chapter</th>
            <th style={{ padding: "12px", textAlign: "left", fontSize: "1rem" }}>Admin Email</th>
            <th style={{ padding: "12px", textAlign: "left", fontSize: "1rem" }}>Admin Password</th>
            <th style={{ padding: "12px", textAlign: "center", fontSize: "1rem" }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {chaptersToDisplay.map((chap) => (
            <tr key={chap.id}>
              <td style={{ padding: "12px", fontSize: "1rem" }}>{chap.chapter}</td>
              <td style={{ padding: "12px", fontSize: "1rem" }}>{chap.email || "-"}</td>
              <td style={{ padding: "12px", fontSize: "1rem" }}>{chap.pass || "-"}</td>
              <td style={{ padding: "12px", textAlign: "center", fontSize: "1rem" }}>
                <button
                  onClick={() => handleEditClick(chap)}
                  style={{
                    padding: "5px 10px",
                    backgroundColor: "#007bff",
                    color: "#fff",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    marginRight: 5,
                  }}
                >
                  Edit
                </button>
                <button
                  onClick={() => deleteChapter(chap.id)}
                  style={{
                    padding: "5px 10px",
                    backgroundColor: "#dc3545",
                    color: "#fff",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      
      <Modal
        isOpen={showModal}
        onRequestClose={() => setShowModal(false)} // Close modal on request
        contentLabel="Edit Chapter Modal"
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            transform: 'translate(-50%, -50%)',
            width: '400px',
            padding: '20px',
            borderRadius: '8px',
          },
        }}
      >
        <h2>Edit Chapter</h2>
        <div style={{ marginBottom: 20 }}>
          <label>Chapter Name:</label><br />
          <input
            placeholder="Enter chapter name"
            value={formData.chapter}
            onChange={(e) => setFormData({ ...formData, chapter: e.target.value })}
            style={{ width: '100%', padding: 8, marginTop: 5 }}
          />
        </div>

        <div style={{ marginBottom: 20 }}>
          <label>Admin Email:</label><br />
          <input
            placeholder="Enter admin email"
            value={adminData.email}
            onChange={(e) => setAdminData({ ...adminData, email: e.target.value })}
            style={{ width: '100%', padding: 8, marginTop: 5 }}
          />
        </div>

        <div style={{ marginBottom: 20 }}>
          <label>Admin Password:</label><br />
          <input
            placeholder="Enter admin password"
            value={adminData.password}
            onChange={(e) => setAdminData({ ...adminData, password: e.target.value })}
            style={{ width: '100%', padding: 8, marginTop: 5 }}
          />
        </div>

        <div>
          <button
            onClick={editChapter}
            style={{
              marginRight: 10,
              padding: '8px 16px',
              backgroundColor: '#007bff',
              color: '#fff',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            Save Changes
          </button>
          <button
            onClick={() => setShowModal(false)}
            style={{
              padding: '8px 16px',
              backgroundColor: '#dc3545',
              color: '#fff',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            Cancel
          </button>
        </div>
      </Modal>

      
      <div style={{ marginTop: 20, textAlign: "center" }}>
        <button
          onClick={goToPreviousPage}
          disabled={currentPageIndex === 0}
          style={{
            padding: "10px 20px",
            marginRight: 10,
            backgroundColor: "#007bff",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Previous
        </button>
        <span style={{ fontSize: "1rem", color: "#555" }}>
          Page {currentPageIndex + 1} of {totalPageCount}
        </span>
        <button
          onClick={goToNextPage}
          disabled={currentPageIndex === totalPageCount - 1}
          style={{
            padding: "10px 20px",
            marginLeft: 10,
            backgroundColor: "#007bff",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Next
        </button>
      </div>
    </div>
)} */} 

{activeSection === "chapter" && (
  <div
    style={{
      minHeight: "100vh",
      background: "linear-gradient(to bottom right, #f8fafc, #eef2ff)",
      padding: "25px 15px",
    }}
  >
    {/* Header Section */}
    <div
      style={{
        maxWidth: "1400px",
        margin: "0 auto 25px auto",
        background: "linear-gradient(135deg, #1e3a8a, #4338ca)",
        borderRadius: "24px",
        padding: "35px 30px",
        color: "#fff",
        boxShadow: "0 10px 30px rgba(37, 99, 235, 0.18)",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "15px",
        }}
      >
        <div>
          <h2
            style={{
              margin: 0,
              fontSize: "34px",
              fontWeight: "700",
              letterSpacing: "-0.5px",
            }}
          >
            📘 Chapter Management
          </h2>

          <p
            style={{
              marginTop: "10px",
              color: "rgba(255,255,255,0.85)",
              fontSize: "15px",
            }}
          >
            Configure chapters and securely assign chapter administrators
          </p>
        </div>
      </div>
    </div>

    {/* Main Layout */}
    <div
      style={{
        maxWidth: "1400px",
        margin: "auto",
        display: "grid",
        gridTemplateColumns: "350px 1fr",
        gap: "25px",
        alignItems: "start",
      }}
    >
      {/* LEFT PANEL */}
      <div style={{ display: "flex", flexDirection: "column", gap: "25px" }}>
        
        {/* Create Chapter */}
        <div
          style={{
            background: "#fff",
            borderRadius: "22px",
            padding: "25px",
            boxShadow: "0 4px 18px rgba(15, 23, 42, 0.06)",
            border: "1px solid #e2e8f0",
          }}
        >
          <h3
            style={{
              marginTop: 0,
              marginBottom: "20px",
              fontSize: "20px",
              fontWeight: "700",
              color: "#111827",
            }}
          >
            🏢 Create Chapter
          </h3>

          <label
            style={{
              fontSize: "13px",
              fontWeight: "600",
              color: "#64748b",
              display: "block",
              marginBottom: "8px",
            }}
          >
            Chapter Name
          </label>

          <input
            placeholder="Enter chapter name"
            value={formData.chapter}
            onChange={(e) =>
              setFormData({ ...formData, chapter: e.target.value })
            }
            style={{
              width: "100%",
              padding: "14px",
              borderRadius: "12px",
              border: "1px solid #cbd5e1",
              fontSize: "14px",
              outline: "none",
              background: "#f8fafc",
              marginBottom: "18px",
              boxSizing: "border-box",
            }}
          />

          <button
            onClick={selectedId ? editChapter : createChapter}
            style={{
              width: "100%",
              padding: "13px",
              border: "none",
              borderRadius: "12px",
              background: "linear-gradient(135deg, #2563eb, #4338ca)",
              color: "#fff",
              fontSize: "14px",
              fontWeight: "600",
              cursor: "pointer",
              boxShadow: "0 6px 18px rgba(37,99,235,0.25)",
            }}
          >
            {selectedId ? "Update Chapter" : "Create Chapter"}
          </button>
        </div>

        {/* Assign Admin */}
        <div
          style={{
            background: "#fff",
            borderRadius: "22px",
            padding: "25px",
            boxShadow: "0 4px 18px rgba(15, 23, 42, 0.06)",
            border: "1px solid #e2e8f0",
          }}
        >
          <h3
            style={{
              marginTop: 0,
              marginBottom: "20px",
              fontSize: "20px",
              fontWeight: "700",
              color: "#111827",
            }}
          >
            🔐 Assign Admin
          </h3>

          {/* Dropdown */}
          <label
            style={{
              fontSize: "13px",
              fontWeight: "600",
              color: "#64748b",
              display: "block",
              marginBottom: "8px",
            }}
          >
            Select Chapter
          </label>

          <select
            value={dropdownId}
            onChange={(e) => {
              const selectedValue = e.target.value;
              setDropdownId(selectedValue);

              const selectedChapter = chapters.find(
                (c) => c.id.toString() === selectedValue
              );

              if (
                selectedChapter &&
                selectedChapter.email &&
                selectedChapter.pass
              ) {
                alert("⚠️ Login details already created for this chapter.");
                setDropdownId("");
              }
            }}
            style={{
              width: "100%",
              padding: "14px",
              borderRadius: "12px",
              border: "1px solid #cbd5e1",
              background: "#f8fafc",
              fontSize: "14px",
              outline: "none",
              marginBottom: "16px",
            }}
          >
            <option value="">-- Select Chapter --</option>
            {chapters.map((c) => (
              <option key={c.id} value={c.id}>
                {c.chapter}
              </option>
            ))}
          </select>

          {/* Email */}
          <input
            placeholder="Admin Email"
            value={adminData.email}
            onChange={(e) =>
              setAdminData({ ...adminData, email: e.target.value })
            }
            style={{
              width: "100%",
              padding: "14px",
              borderRadius: "12px",
              border: "1px solid #cbd5e1",
              background: "#f8fafc",
              fontSize: "14px",
              outline: "none",
              marginBottom: "14px",
              boxSizing: "border-box",
            }}
          />

          {/* Password */}
          <input
            placeholder="Admin Password"
            type="text"
            value={adminData.password}
            onChange={(e) =>
              setAdminData({ ...adminData, password: e.target.value })
            }
            style={{
              width: "100%",
              padding: "14px",
              borderRadius: "12px",
              border: "1px solid #cbd5e1",
              background: "#f8fafc",
              fontSize: "14px",
              outline: "none",
              marginBottom: "18px",
              boxSizing: "border-box",
            }}
          />

          <button
            onClick={saveAdmin}
            style={{
              width: "100%",
              padding: "13px",
              border: "none",
              borderRadius: "12px",
              background: "linear-gradient(135deg, #059669, #0f766e)",
              color: "#fff",
              fontSize: "14px",
              fontWeight: "600",
              cursor: "pointer",
              boxShadow: "0 6px 18px rgba(5,150,105,0.25)",
            }}
          >
            Save Admin
          </button>
        </div>
      </div>

      {/* RIGHT PANEL */}
      <div>
        {/* Table Header */}
        <div
          style={{
            background: "#fff",
            borderRadius: "20px 20px 0 0",
            padding: "20px 25px",
            borderBottom: "1px solid #e5e7eb",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "15px",
          }}
        >
          <div>
            <h3
              style={{
                margin: 0,
                fontSize: "22px",
                fontWeight: "700",
                color: "#111827",
              }}
            >
              📄 Chapters List
            </h3>

            <p
              style={{
                marginTop: "6px",
                color: "#64748b",
                fontSize: "13px",
              }}
            >
              Manage chapter administrators and credentials
            </p>
          </div>
        </div>

        {/* Table */}
        <div
          style={{
            background: "#fff",
            borderRadius: "0 0 20px 20px",
            overflowX: "auto",
            boxShadow: "0 4px 18px rgba(15, 23, 42, 0.06)",
            border: "1px solid #e2e8f0",
            borderTop: "none",
          }}
        >
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              minWidth: "800px",
            }}
          >
            <thead
              style={{
                background: "#f8fafc",
                borderBottom: "1px solid #e5e7eb",
              }}
            >
              <tr>
                <th
                  style={{
                    padding: "18px",
                    textAlign: "left",
                    fontSize: "13px",
                    color: "#64748b",
                    fontWeight: "700",
                  }}
                >
                  Chapter
                </th>

                <th
                  style={{
                    padding: "18px",
                    textAlign: "left",
                    fontSize: "13px",
                    color: "#64748b",
                    fontWeight: "700",
                  }}
                >
                  Admin Email
                </th>

                <th
                  style={{
                    padding: "18px",
                    textAlign: "left",
                    fontSize: "13px",
                    color: "#64748b",
                    fontWeight: "700",
                  }}
                >
                  Admin Password
                </th>

                <th
                  style={{
                    padding: "18px",
                    textAlign: "center",
                    fontSize: "13px",
                    color: "#64748b",
                    fontWeight: "700",
                  }}
                >
                  Actions
                </th>
              </tr>
            </thead>

            <tbody>
              {chaptersToDisplay.map((chap) => (
                <tr
                  key={chap.id}
                  style={{
                    borderBottom: "1px solid #f1f5f9",
                    transition: "0.3s",
                  }}
                >
                  <td
                    style={{
                      padding: "18px",
                      fontSize: "14px",
                      fontWeight: "600",
                      color: "#111827",
                    }}
                  >
                    {chap.chapter}
                  </td>

                  <td
                    style={{
                      padding: "18px",
                      fontSize: "14px",
                      color: "#475569",
                    }}
                  >
                    {chap.email || "-"}
                  </td>

                  <td
                    style={{
                      padding: "18px",
                      fontSize: "13px",
                      color: "#475569",
                      fontFamily: "monospace",
                    }}
                  >
                    {chap.pass || "-"}
                  </td>

                  <td
                    style={{
                      padding: "18px",
                      textAlign: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "10px",
                      }}
                    >
                      <button
                        onClick={() => handleEditClick(chap)}
                        style={{
                          padding: "8px 14px",
                          border: "none",
                          borderRadius: "10px",
                          background: "#2563eb",
                          color: "#fff",
                          fontSize: "13px",
                          fontWeight: "600",
                          cursor: "pointer",
                        }}
                      >
                        Edit
                      </button>

                      <button
                        onClick={() => deleteChapter(chap.id)}
                        style={{
                          padding: "8px 14px",
                          border: "none",
                          borderRadius: "10px",
                          background: "#dc2626",
                          color: "#fff",
                          fontSize: "13px",
                          fontWeight: "600",
                          cursor: "pointer",
                        }}
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Pagination */}
          <div
            style={{
              padding: "20px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              borderTop: "1px solid #e5e7eb",
              background: "#f8fafc",
              flexWrap: "wrap",
              gap: "15px",
            }}
          >
            <button
              onClick={goToPreviousPage}
              disabled={currentPageIndex === 0}
              style={{
                padding: "10px 18px",
                borderRadius: "10px",
                border: "1px solid #cbd5e1",
                background: "#fff",
                cursor: "pointer",
                fontWeight: "600",
              }}
            >
              Previous
            </button>

            <span
              style={{
                fontSize: "14px",
                color: "#475569",
                fontWeight: "600",
              }}
            >
              Page {currentPageIndex + 1} of {totalPageCount}
            </span>

            <button
              onClick={goToNextPage}
              disabled={currentPageIndex === totalPageCount - 1}
              style={{
                padding: "10px 18px",
                borderRadius: "10px",
                border: "1px solid #cbd5e1",
                background: "#fff",
                cursor: "pointer",
                fontWeight: "600",
              }}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>

    {/* MODAL */}
    <Modal
      isOpen={showModal}
      onRequestClose={() => setShowModal(false)}
      contentLabel="Edit Chapter Modal"
      style={{
        content: {
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          transform: "translate(-50%, -50%)",
          width: "420px",
          padding: "0",
          border: "none",
          borderRadius: "24px",
          overflow: "hidden",
        },
        overlay: {
          backgroundColor: "rgba(15,23,42,0.65)",
          zIndex: 999,
        },
      }}
    >
      <div
        style={{
          background: "linear-gradient(135deg, #1e3a8a, #4338ca)",
          padding: "22px",
          color: "#fff",
        }}
      >
        <h2 style={{ margin: 0 }}>Edit Chapter</h2>
      </div>

      <div style={{ padding: "25px", background: "#fff" }}>
        <div style={{ marginBottom: 18 }}>
          <label style={{ fontWeight: "600", fontSize: "14px" }}>
            Chapter Name
          </label>

          <input
            placeholder="Enter chapter name"
            value={formData.chapter}
            onChange={(e) =>
              setFormData({ ...formData, chapter: e.target.value })
            }
            style={{
              width: "100%",
              padding: "12px",
              marginTop: 8,
              borderRadius: "10px",
              border: "1px solid #cbd5e1",
              background: "#f8fafc",
              boxSizing: "border-box",
            }}
          />
        </div>

        <div style={{ marginBottom: 18 }}>
          <label style={{ fontWeight: "600", fontSize: "14px" }}>
            Admin Email
          </label>

          <input
            placeholder="Enter admin email"
            value={adminData.email}
            onChange={(e) =>
              setAdminData({ ...adminData, email: e.target.value })
            }
            style={{
              width: "100%",
              padding: "12px",
              marginTop: 8,
              borderRadius: "10px",
              border: "1px solid #cbd5e1",
              background: "#f8fafc",
              boxSizing: "border-box",
            }}
          />
        </div>

        <div style={{ marginBottom: 25 }}>
          <label style={{ fontWeight: "600", fontSize: "14px" }}>
            Admin Password
          </label>

          <input
            placeholder="Enter admin password"
            value={adminData.password}
            onChange={(e) =>
              setAdminData({ ...adminData, password: e.target.value })
            }
            style={{
              width: "100%",
              padding: "12px",
              marginTop: 8,
              borderRadius: "10px",
              border: "1px solid #cbd5e1",
              background: "#f8fafc",
              boxSizing: "border-box",
            }}
          />
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "12px",
          }}
        >
          <button
            onClick={() => setShowModal(false)}
            style={{
              padding: "10px 18px",
              borderRadius: "10px",
              border: "1px solid #cbd5e1",
              background: "#fff",
              cursor: "pointer",
              fontWeight: "600",
            }}
          >
            Cancel
          </button>

          <button
            onClick={editChapter}
            style={{
              padding: "10px 18px",
              borderRadius: "10px",
              border: "none",
              background: "#2563eb",
              color: "#fff",
              cursor: "pointer",
              fontWeight: "600",
            }}
          >
            Save Changes
          </button>
        </div>
      </div>
    </Modal>
  </div>
)}
      {/* {activeSection === 'products' && (

        <div className="products-section">
          <h2 className="section-title">Approve Products</h2>

          <div className="products">
           
            {Array.isArray(productss) && productss.map((product) => (
              <div className="product-card" key={product.id}>
                <div className="product-image-container">
                  <img
                    src={product.productPhoto}
                    alt={product.productName}
                    className="product-image"
                    height="400"
                    width="300"
                  />
                  <div className="overlay">
                    <div className="overlay-chapter">
                      <h3>{product.productName}</h3>
                      <>
                        {!expanded ? (
                          <p style={{ color: "yellow", textTransform: "uppercase" }}>
                            {product.productDesc.length > 100
                              ? `${product.productDesc.substring(0, 100)}... `
                              : product.productDesc}
                            {product.productDesc.length > 100 && (
                              <span
                                style={{ color: "skyblue", cursor: "pointer" }}
                                onClick={toggleExpanded}
                              >
                                more
                              </span>
                            )}
                          </p>
                        ) : (
                          <div
                            style={{
                              maxHeight: "150px",
                              overflowY: "auto",
                              border: "1px solid #999",
                              padding: "8px",
                              borderRadius: "4px",
                              background: "#222",
                              color: "yellow",
                              textTransform: "uppercase",
                            }}
                          >
                            {product.productDesc}
                            <div>
                              <span
                                style={{ color: "skyblue", cursor: "pointer" }}
                                onClick={toggleExpanded}
                              >
                                ...less
                              </span>
                            </div>
                          </div>
                        )}
                      </>
                      <p>Email: {product.UserId}</p>
                      <p>Price: {product.productPrice}</p>
                        <p
                        style={{
                          color: isExpiredOffer(product.validity) ? 'red' : 'yellow',
                          textDecoration: isExpiredOffer(product.validity) ? 'line-through' : 'none',
                          textTransform: 'uppercase',
                        }}
                      >
                        <strong>Offer:</strong> {product.offer ? `${product.offer}%` : 'No offer available'}{' '}
                        {isExpiredOffer(product.validity) && '(Expired!)'}
                      </p>
                      <p
                        style={{
                          color: isExpiredOffer(product.validity) ? 'red' : 'yellow',
                          textDecoration: isExpiredOffer(product.validity) ? 'line-through' : 'none',
                          textTransform: 'uppercase',
                        }}
                      >
                        Validity: {formatDate(product.validity)} {isExpiredOffer(product.validity) && '(Expired!)'}
                      </p>
                    </div>
                  </div>
                  {product.isApprove !== '1' && <button className="edit-btn" onClick={() => handleApproveProduct({ productId: product.id })}>Approve</button>}
                  <button className="delete-btn"
                    onClick={() => deleteProduct(product.id)}
                  > Delete</button>
                </div>
              </div>
            ))}
          </div>

          <h2 className="section-title">Approved Products</h2>

          <div className="products">
            {allProducts.map((product) => {

              const productRatings = product.ratings || [];
              const productAverageRating = calculateAverageRating(productRatings);
              return (
                <div className="product-card" key={product.id}>
                  <div className="product-image-container">
                    <img
                      src={product.productPhoto}
                      alt={product.productName}
                      className="product-image"
                      height="400"
                      width="300"
                    />
                    <div className="overlay">
                      <div className="overlay-chapter">
                        <h3
                          style={{
                            color: "yellow",
                            textTransform: "uppercase",
                          }}
                        >
                          {product.productName}
                        </h3>
                      
                        <>
                          {!expanded ? (
                            <p style={{ color: "yellow", textTransform: "uppercase" }}>
                              {product.productDesc.length > 100
                                ? `${product.productDesc.substring(0, 100)}... `
                                : product.productDesc}
                              {product.productDesc.length > 100 && (
                                <span
                                  style={{ color: "skyblue", cursor: "pointer" }}
                                  onClick={toggleExpanded}
                                >
                                  more
                                </span>
                              )}
                            </p>
                          ) : (
                            <div
                              style={{
                                maxHeight: "150px",
                                overflowY: "auto",
                                border: "1px solid #999",
                                padding: "8px",
                                borderRadius: "4px",
                                background: "#222",
                                color: "yellow",
                                textTransform: "uppercase",
                              }}
                            >
                              {product.productDesc}
                              <div>
                                <span
                                  style={{ color: "skyblue", cursor: "pointer" }}
                                  onClick={toggleExpanded}
                                >
                                  ...less
                                </span>
                              </div>
                            </div>
                          )}
                        </>
                        <p
                          style={{
                            color: "yellow",
                            textTransform: "uppercase",
                          }}
                        >
                          Price: {product.productPrice}
                        </p>
                        
                        <p
                          style={{
                            color: isExpiredOffer(product.validity) ? 'red' : 'yellow',
                            textDecoration: isExpiredOffer(product.validity) ? 'line-through' : 'none',
                            textTransform: 'uppercase',
                          }}
                        >
                          <strong>Offer:</strong> {product.offer ? `${product.offer}%` : 'No offer available'}{' '}
                          {isExpiredOffer(product.validity) && '(Expired!)'}
                        </p>
                        <p
                          style={{
                            color: isExpiredOffer(product.validity) ? 'red' : 'yellow',
                            textDecoration: isExpiredOffer(product.validity) ? 'line-through' : 'none',
                            textTransform: 'uppercase',
                          }}
                        >
                          Validity: {formatDate(product.validity)} {isExpiredOffer(product.validity) && '(Expired!)'}
                        </p>

                        <p><strong>Average Rating:</strong>
                          {renderStars(productAverageRating)} ({productAverageRating.toFixed(1)})
                        </p>
                        <p>GST Verifyed ✅</p>
                      </div>
                    </div>


                  </div>
                </div>

              )
            }
            )}





          </div>

        </div>
      )} */}


      {activeSection === 'products' && (

  <div
    style={{
      minHeight: "100vh",
      background: "#f3f4f6",
      padding: "20px 12px",
    }}
  >

    {/* APPROVE PRODUCTS */}
    <div
      // style={{
      //   display: "flex",
      //   justifyContent: "space-between",
      //   alignItems: "center",
      //   marginBottom: "20px",
      //   flexWrap: "wrap",
      //   gap: "10px",

      //    background: "linear-gradient(to right, #1e3a8a, #2563eb)",
      //   padding: "35px 25px",
      //   borderRadius: "20px",
      //   color: "#fff",
      //   boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
      // }}
           style={{
        // display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "20px",
        flexWrap: "wrap",
        gap: "10px",

         background: "linear-gradient(to right, #1e3a8a, #2563eb)",
      padding: "35px 25px",
        borderRadius: "25px 25px",
        color: "#fff",
        boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
        margin:'20px'
      }}
    >
      <h2
        style={{
          fontSize: "32px",
          fontWeight: "700",
          color: "#ffffff",
          margin: 0,
        }}
      >
        Approve Products
      </h2>
    </div>

    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit,minmax(300px,1fr))",
        gap: "24px",
      }}
    >

      {Array.isArray(productss) && productss.map((product) => (

        <div
          key={product.id}
          style={{
            background: "#fff",
            borderRadius: "22px",
            overflow: "hidden",
            boxShadow: "0 4px 18px rgba(0,0,0,0.08)",
            border: "1px solid #e5e7eb",
            transition: "0.3s",
            display: "flex",
            flexDirection: "column",
          }}
        >

          {/* IMAGE */}
          <div
            style={{
              position: "relative",
              height: "230px",
              background: "#e5e7eb",
            }}
          >

            <img
              src={product.productPhoto}
              alt={product.productName}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
            />

            {product.offer && (
              <div
                style={{
                  position: "absolute",
                  top: "14px",
                  right: "14px",
                  background: "#ef4444",
                  color: "#fff",
                  padding: "6px 14px",
                  borderRadius: "30px",
                  fontSize: "13px",
                  fontWeight: "700",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
                }}
              >
                🔖 {product.offer}% OFF
              </div>
            )}

          </div>

          {/* CONTENT */}
          <div
            style={{
              padding: "20px",
              display: "flex",
              flexDirection: "column",
              flex: 1,
            }}
          >

            <h3
              style={{
                fontSize: "26px",
                fontWeight: "700",
                color: "#111827",
                marginBottom: "10px",
              }}
            >
              {product.productName}
            </h3>

            {/* DESCRIPTION */}
            <>
              {!expanded ? (
                <p
                  style={{
                    color: "#4b5563",
                    fontSize: "14px",
                    lineHeight: "22px",
                    marginBottom: "16px",
                  }}
                >
                  {product.productDesc.length > 100
                    ? `${product.productDesc.substring(0, 100)}... `
                    : product.productDesc}

                  {product.productDesc.length > 100 && (
                    <span
                      style={{
                        color: "#2563eb",
                        cursor: "pointer",
                        fontWeight: "600",
                      }}
                      onClick={toggleExpanded}
                    >
                      more
                    </span>
                  )}
                </p>
              ) : (
                <div
                  style={{
                    maxHeight: "140px",
                    overflowY: "auto",
                    border: "1px solid #d1d5db",
                    padding: "10px",
                    borderRadius: "10px",
                    background: "#f9fafb",
                    color: "#374151",
                    fontSize: "14px",
                    lineHeight: "22px",
                    marginBottom: "16px",
                  }}
                >
                  {product.productDesc}

                  <div>
                    <span
                      style={{
                        color: "#2563eb",
                        cursor: "pointer",
                        fontWeight: "600",
                      }}
                      onClick={toggleExpanded}
                    >
                      ...less
                    </span>
                  </div>
                </div>
              )}
            </>

            {/* EMAIL */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                color: "#6b7280",
                marginBottom: "14px",
                wordBreak: "break-word",
                fontSize: "14px",
              }}
            >
              📧 {product.UserId}
            </div>

            <hr
              style={{
                border: "none",
                borderTop: "1px solid #e5e7eb",
                marginBottom: "16px",
              }}
            />

            {/* PRICE */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "12px",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  color: "#6b7280",
                  fontSize: "15px",
                }}
              >
                Pricing:
              </span>

              <span
                style={{
                  color: "#059669",
                  fontSize: "28px",
                  fontWeight: "700",
                }}
              >
                ₹{product.productPrice}
              </span>
            </div>

            {/* OFFER */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "12px",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  color: "#6b7280",
                  fontSize: "15px",
                }}
              >
                Offer:
              </span>

              <span
                style={{
                  color: isExpiredOffer(product.validity)
                    ? "red"
                    : "#ea580c",
                  fontWeight: "600",
                  fontSize: "14px",
                  textDecoration: isExpiredOffer(product.validity)
                    ? "line-through"
                    : "none",
                  background: "#fff7ed",
                  padding: "4px 10px",
                  borderRadius: "8px",
                }}
              >
                {product.offer
                  ? `${product.offer}% OFF`
                  : "No offer available"}

                {isExpiredOffer(product.validity) && " (Expired)"}
              </span>
            </div>

            {/* VALIDITY */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "22px",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  color: "#6b7280",
                  fontSize: "15px",
                }}
              >
                📅 Validity:
              </span>

              <span
                style={{
                  color: isExpiredOffer(product.validity)
                    ? "red"
                    : "#111827",
                  fontWeight: "600",
                  fontSize: "14px",
                }}
              >
                {formatDate(product.validity)}

                {isExpiredOffer(product.validity) && " (Expired)"}
              </span>
            </div>

            {/* BUTTONS */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns:
                  product.isApprove !== '1'
                    ? "1fr 1fr"
                    : "1fr",
                gap: "14px",
                marginTop: "auto",
              }}
            >

              <button
                onClick={() => deleteProduct(product.id)}
                style={{
                  border: "none",
                  background: "#fef2f2",
                  color: "#dc2626",
                  padding: "14px",
                  borderRadius: "14px",
                  fontWeight: "700",
                  cursor: "pointer",
                  fontSize: "16px",
                }}
              >
                🗑 Delete
              </button>

              {product.isApprove !== '1' && (
                <button
                  onClick={() =>
                    handleApproveProduct({
                      productId: product.id,
                    })
                  }
                  style={{
                    border: "none",
                    background:
                      "linear-gradient(to right,#059669,#10b981)",
                    color: "#fff",
                    padding: "14px",
                    borderRadius: "14px",
                    fontWeight: "700",
                    cursor: "pointer",
                    fontSize: "16px",
                    boxShadow: "0 4px 10px rgba(16,185,129,0.3)",
                  }}
                >
                  ✔ Approve
                </button>
              )}

            </div>

          </div>
        </div>

      ))}

    </div>



    {/* APPROVED PRODUCTS */}
    <div
      style={{
        // display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "20px",
        flexWrap: "wrap",
        gap: "10px",

         background: "linear-gradient(to right, #1e3a8a, #2563eb)",
        padding: "5px",
        borderRadius: "25px 25px",
        color: "#fff",
        boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
        margin:'20px'
      }}
    >
    <h2
      style={{
        fontSize: "32px",
        fontWeight: "700",
        color: "#ffffff",
        marginTop: "24px",
        marginBottom: "24px",
      }}
    >
      Approved Products
    </h2>
</div>
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit,minmax(300px,1fr))",
        gap: "24px",
      }}
    >

      {allProducts.map((product) => {

        const productRatings = product.ratings || [];
        const productAverageRating =
          calculateAverageRating(productRatings);

        return (

          <div
            key={product.id}
            style={{
              background: "#fff",
              borderRadius: "22px",
              overflow: "hidden",
              boxShadow: "0 4px 18px rgba(0,0,0,0.08)",
              border: "1px solid #e5e7eb",
            }}
          >

            {/* IMAGE */}
            <div
              style={{
                position: "relative",
                height: "230px",
                background: "#e5e7eb",
              }}
            >

              <img
                src={product.productPhoto}
                alt={product.productName}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
              />

              {product.offer && (
                <div
                  style={{
                    position: "absolute",
                    top: "14px",
                    right: "14px",
                    background: "#ef4444",
                    color: "#fff",
                    padding: "6px 14px",
                    borderRadius: "30px",
                    fontSize: "13px",
                    fontWeight: "700",
                  }}
                >
                  🔖 {product.offer}% OFF
                </div>
              )}

            </div>

            {/* CONTENT */}
            <div style={{ padding: "20px" }}>

              <h3
                style={{
                  fontSize: "24px",
                  fontWeight: "700",
                  color: "#111827",
                  marginBottom: "12px",
                }}
              >
                {product.productName}
              </h3>

              <>
                {!expanded ? (
                  <p
                    style={{
                      color: "#4b5563",
                      fontSize: "14px",
                      lineHeight: "22px",
                    }}
                  >
                    {product.productDesc.length > 100
                      ? `${product.productDesc.substring(0, 100)}... `
                      : product.productDesc}

                    {product.productDesc.length > 100 && (
                      <span
                        style={{
                          color: "#2563eb",
                          cursor: "pointer",
                          fontWeight: "600",
                        }}
                        onClick={toggleExpanded}
                      >
                        more
                      </span>
                    )}
                  </p>
                ) : (
                  <div
                    style={{
                      maxHeight: "140px",
                      overflowY: "auto",
                      border: "1px solid #d1d5db",
                      padding: "10px",
                      borderRadius: "10px",
                      background: "#f9fafb",
                      color: "#374151",
                      fontSize: "14px",
                      lineHeight: "22px",
                    }}
                  >
                    {product.productDesc}

                    <div>
                      <span
                        style={{
                          color: "#2563eb",
                          cursor: "pointer",
                          fontWeight: "600",
                        }}
                        onClick={toggleExpanded}
                      >
                        ...less
                      </span>
                    </div>
                  </div>
                )}
              </>

              <div
                style={{
                  marginTop: "18px",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <span style={{ color: "#6b7280" }}>
                  Pricing:
                </span>

                <span
                  style={{
                    color: "#059669",
                    fontWeight: "700",
                    fontSize: "28px",
                  }}
                >
                  ₹{product.productPrice}
                </span>
              </div>

              <div
                style={{
                  marginTop: "14px",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <span style={{ color: "#6b7280" }}>
                  Offer:
                </span>

                <span
                  style={{
                    color: isExpiredOffer(product.validity)
                      ? "red"
                      : "#ea580c",
                    fontWeight: "600",
                    background: "#fff7ed",
                    padding: "4px 10px",
                    borderRadius: "8px",
                  }}
                >
                  {product.offer
                    ? `${product.offer}% OFF`
                    : "No offer available"}
                </span>
              </div>

              <div
                style={{
                  marginTop: "14px",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <span style={{ color: "#6b7280" }}>
                  📅 Validity:
                </span>

                <span
                  style={{
                    color: isExpiredOffer(product.validity)
                      ? "red"
                      : "#111827",
                    fontWeight: "600",
                  }}
                >
                  {formatDate(product.validity)}
                </span>
              </div>

              <div
                style={{
                  marginTop: "18px",
                  fontWeight: "600",
                  color: "#111827",
                }}
              >
                Average Rating:
                {" "}
                {renderStars(productAverageRating)}
                {" "}
                ({productAverageRating.toFixed(1)})
              </div>

              <div
                style={{
                  marginTop: "10px",
                  color: "#059669",
                  fontWeight: "700",
                }}
              >
                GST Verified ✅
              </div>

            </div>
          </div>

        );
      })}

    </div>

  </div>
)}


      {/* {activeSection === "Meetings" && (
        <div>
          <button style={{ margin: '30px' }} onClick={openModall}>+ Meeting</button>

          <Modal isOpen={modalIsOpenn} onRequestClose={closeModall}>
            <h2>Add Meetings </h2>
            <Form>
<div style={{ marginBottom: '15px' }}>
  <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Chapter:</label>
  <select
    value={selectedChapter}
    onChange={(e) => setSelectedChapter(e.target.value)}
    style={{
      width: '30%',
      padding: '10px',
      borderRadius: '5px',
      border: '1px solid #ccc',
      fontSize: '16px',
      outline: 'none',
      boxSizing: 'border-box',
      backgroundColor: '#f9f9f9'
    }}
  >
    <option value="">Select a chapter</option>
    {chapters.map((chapter) => (
      <option key={chapter.chapter} value={chapter.chapter}>
        {chapter.chapter}
      </option>
    ))}
  </select>
</div>


              <div>
                <label>Date:</label>
                <DatePicker
                  selected={date}
                  onChange={(date) => setDate(date)}
                  dateFormat="MM/dd/yyyy"
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />
              </div>

              <div>
                <label>Time:</label>
                <input
                  type="time"
                  value={time}
                  onChange={(e) => setTime(e.target.value)}
                />
              </div>

              <div>
                <label>Venue:</label>
                <input
                  type="text"
                  value={venue}
                  onChange={(e) => setVenue(e.target.value)}
                />
              </div>
              <div>
                <label>Image:</label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={onImageChange}
                />
              </div>


              <div>
                <button type="button " className='m-3' onClick={handleSubmit}>Submit</button>
                <button type="button" className='m-3' onClick={closeModall}>Cancel</button>
              </div>
            </Form>
          </Modal>


          <button style={{ margin: '30px' }} onClick={openModallAtt}>+ Meeting Attendance List</button>
          <Modal isOpen={modalIsOpen} onRequestClose={closeModallAtt}>
            <h2>Meeting Attendance List</h2>
            <button type="button" className='m-3' onClick={closeModallAtt}>Close</button>





            <>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ marginRight: '10px' }}>
                  <label htmlFor="dateDropdown">Select Date:</label>
                  <select
                    id="dateDropdown"
                    value={selectedDate}
                    onChange={handleDateChange}
                    style={{
                      width: '150px',
                      padding: '8px',
                      borderRadius: '8px',
                      fontSize: '14px',
                      overflowY: 'auto',
                      maxHeight: '200px',

                    }}
                  >
                    <option value="">Select a date</option>
                    {uniqueDates.map((date) => (
                      <option key={date} value={date}>
                        {new Date(date).toLocaleDateString()}
                      </option>
                    ))}
                  </select>
                </div>

                {selectedDate && (
                  <div>
                    <label htmlFor="venueDropdown">Select Venue:</label>
                    <select
                      id="venueDropdown"
                      value={selectedVenue}
                      onChange={handleVenueChange}
                      style={{
                        width: '150px',
                        padding: '8px',
                        borderRadius: '8px',
                        fontSize: '14px',
                      }}
                    >
                      <option value="">Select a venue</option>
                      {venuesForSelectedDate.map((venue, index) => (
                        <option key={index} value={venue}>
                          {venue}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
              </div>

              {selectedVenue && selectedMeetingDetails.length > 0 && (
                <div>
                  <h3>Meeting Details (Response Given Members):</h3>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr>
                        <th style={{ border: '1px solid black', padding: '10px' }}>USERID</th>

                        <th style={{ border: '1px solid black', padding: '10px' }}>User Email</th>

                        <th style={{ border: '1px solid black', padding: '10px' }}>Response</th>
                        <th style={{ border: '1px solid black', padding: '10px' }}>  Action</th>

                      </tr>
                    </thead>
                    <tbody>
                      {currentUsers13.map((meeting, index) => {

                        const user = users.find((user) => user.id === meeting.user_id);
                        // const isMeetingExpired = new Date(meeting.date) < new Date(); // Check if meeting is expired
                        const meetingDateTime = new Date(`${meeting.date}T${meeting.time}:00`);
                        console.log('this is the meetingDateTime', meetingDateTime)
                        const isMeetingExpired = meetingDateTime.getTime() + 24 * 60 * 60 * 1000 < Date.now();

                        let responseText = meeting.response === 'yes' ? 'Attending' : 'Not Attending';

                        // If meeting is expired, update response to Present or Absent
                        if (isMeetingExpired) {
                          responseText = meeting.response === 'yes' ? 'Present' : 'Absent';
                        }


                        return (
                          <tr key={index}>
                            <td style={{ border: '1px solid black', padding: '8px' }}>{user ? user.name : 'Unknown'}</td>
                            <td style={{ border: '1px solid black', padding: '8px' }}>{meeting.user_email}</td>

                            <td style={{ border: '1px solid black', padding: '8px', color: meeting.response === 'yes' ? 'green' : 'red' }}>
                              {meeting.response === 'yes' ? 'Attending' : 'Not Attending'}
                            
                            </td>


                            <td style={{ border: '1px solid black', padding: '8px' }}>
                              {meeting.admin_response ? (
                                <span style={{ color: meeting.admin_response === 'yes' ? 'green' : 'red', fontWeight: 'bold' }}>
                                  {meeting.admin_response === 'yes' ? '✔ Attended' : '✘ Not Attended'}
                                </span>
                              ) : (
                                <>
                                  <label>
                                    <input
                                      type="checkbox"
                                      checked={meetingResponses[meeting.user_id] === 'yes'}
                                      onChange={() => handleResponseChange(meeting.user_id, 'yes')}
                                      disabled={isMeetingExpired}
                                    />
                                    Yes
                                  </label>
                                  <label>
                                    <input
                                      type="checkbox"
                                      checked={meetingResponses[meeting.user_id] === 'no'}
                                      onChange={() => handleResponseChange(meeting.user_id, 'no')}
                                      disabled={isMeetingExpired}
                                    />
                                    No
                                  </label>
                                </>
                              )}
                            </td>


                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  <div className="paginationn">
                    <button
                      onClick={handlePrevPage13}
                      className="page-buttonn"
                      disabled={currentPage13 === 1}  // Disable the Previous button if on the first page
                    >
                      Previous
                    </button>



                    <span className="current-page">
                      Page {currentPage13} of {totalPages13}
                    </span>

                    <button
                      onClick={handleNextPage13}
                      className="page-buttonn"
                      disabled={currentPage13 === totalPages13}  // Disable the Next button if on the last page
                    >
                      Next
                    </button>
                  </div>
                  <button onClick={handleUpdateResponse}>Submit</button>
                </div>
              )}

              {selectedVenue && selectedMeetingDetails.length > 0 && (
                <div>
                  <h3>Meeting Details (Response not given Members)</h3>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr>
                        <th style={{ border: '1px solid black', padding: '10px' }}>USERID</th>

                        <th style={{ border: '1px solid black', padding: '10px' }}>User Email</th>

   <th style={{ border: '1px solid black', padding: '10px' }}>  Action</th>

                      </tr>
                    </thead>
                    <tbody>
                      {currentUsers1
                        .map((meeting, index) => {

                          console.log('this is the currentUsers', currentUsers)
                          // console.log('this is ths users', users)
                          const user = users.find((user) => user.id === meeting.user_id);

                          //const isMeetingExpired = new Date(meeting.date) < new Date(); // Check if meeting is expired
                          const meetingDateTime = new Date(`${meeting.date}T${meeting.time}:00`);
                          console.log('this is the meetingDateTime', meetingDateTime)
                          const isMeetingExpired = meetingDateTime.getTime() + 24 * 60 * 60 * 1000 < Date.now();

                          let responseText = meeting.response === 'yes' ? 'Attending' : 'Not Attending';

                          // If meeting is expired, update response to Present or Absent
                          if (isMeetingExpired) {
                            responseText = meeting.response === 'yes' ? 'Present' : 'Absent';
                          }


                          return (
                            <tr key={index}>
                              <td style={{ border: '1px solid black', padding: '8px' }}>{meeting.name}</td>
                              <td style={{ border: '1px solid black', padding: '8px' }}>{meeting.email}</td>
                              <td style={{ border: '1px solid black', padding: '8px' }}>
                                {meeting.admin_response ? (
                                  <span style={{ color: meeting.admin_response === 'yes' ? 'green' : 'red', fontWeight: 'bold' }}>
                                    {meeting.admin_response === 'yes' ? '✔ Attended' : '✘ Not Attended'}
                                  </span>
                                ) : (
                                  <>
                                    <label>
                                      <input
                                        type="checkbox"
                                        checked={meetingResponses[meeting.id] === 'yes'}
                                        onClick={() => handleAdminResponseClick(meeting.id, "yes")}
                                      // onChange={() => handleAdminResponseChange(meeting.id, 'yes')}
                                      // disabled={isMeetingExpired}
                                      />
                                      Yes
                                    </label>
                                    <label>
                                      <input
                                        type="checkbox"
                                        checked={meetingResponses[meeting.id] === 'no'}
                                        // onChange={() => handleAdminResponseChange(meeting.id, 'no')}
                                        onClick={() => handleAdminResponseClick(meeting.id, "no")}
                                      // disabled={isMeetingExpired}
                                      />
                                      No
                                    </label>
                                  </>
                                )}
                              </td>


                            </tr>
                          );
                        })}

                    </tbody>
                  </table>
                  <div className="paginationn">
                    <button
                      onClick={handlePrevPage11}
                      className="page-buttonn"
                      disabled={currentPage11 === 1}  // Disable the Previous button if on the first page
                    >
                      Previous
                    </button>



                    <span className="current-page">
                      Page {currentPage11} of {totalPages11}
                    </span>

                    <button
                      onClick={handleNextPage11}
                      className="page-buttonn"
                      disabled={currentPage11 === totalPages11}  // Disable the Next button if on the last page
                    >
                      Next
                    </button>
                  </div>
                  <button onClick={handleAdminResponseSubmit}>Submit Admin Response m</button>
                </div>
              )}


              {selectedVenue && selectedMeetingDetails.length > 0 && (
                <>
                
                  <div style={{ marginTop: '30px' }}>
                    <h3>Visitor Invitations:</h3>

                   
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      border: '1px solid #ccc',
                      borderRadius: '8px',
                      padding: '8px 12px',
                      maxWidth: '320px',
                      marginBottom: '20px',
                      backgroundColor: '#fff',
                      boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                    }}>
                      <FiSearch size={20} color="#666" style={{ marginRight: '8px' }} />
                      <input
                        type="text"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        placeholder="Search by Name, Email, Mobile..."
                        style={{
                          border: 'none',
                          outline: 'none',
                          fontSize: '16px',
                          width: '100%',
                          backgroundColor: 'transparent',
                          color: '#333'
                        }}
                      />
                    </div>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th style={{ border: '1px solid black', padding: '10px' }}>Visitor Invite Sender </th>
                          <th style={{ border: '1px solid black', padding: '10px' }}>Visitor Name</th>
                          <th style={{ border: '1px solid black', padding: '10px' }}>Email</th>
                          <th style={{ border: '1px solid black', padding: '10px' }}>Mobile</th>
                          <th style={{ border: '1px solid black', padding: '10px' }}>Response</th>
                          <th style={{ border: '1px solid black', padding: '10px' }}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentUsers12
                          // .filter(invite => invite.meeting_id === selectedMeetingDetails[0]?.meeting_id)
                          .map((invite, index) => (

                            <tr key={index}>
                              <td style={{ border: '1px solid black', padding: '8px' }}>{getUserNameById(invite.userId)}</td>

                              <td style={{ border: '1px solid black', padding: '8px' }}>{invite.visitor_name}</td>
                              <td style={{ border: '1px solid black', padding: '8px' }}>{invite.visitor_email}</td>
                              <td style={{ border: '1px solid black', padding: '8px' }}>{invite.visitor_mobile}</td>
                              <td style={{ border: '1px solid black', padding: '8px', color: invite.response === 'yes' ? 'green' : invite.response === 'no' ? 'red' : 'gray' }}>
                                {invite.response ? (invite.response === 'yes' ? 'Attending' : 'Not Attending') : 'Pending'}
                              </td>
                              <td style={{ border: '1px solid black', padding: '8px' }}>
                                <label>
                                  <input
                                    type="checkbox"
                                    checked={visitorResponses[invite.id] === 'yes'}
                                    onChange={() => handleVisitorResponseChange(invite.id, 'yes')}
                                    // disabled={invite.response === 'yes' || invite.response === 'no' || responsesSubmitted}
                                    disabled={invite.response === 'yes' || invite.response === 'no'}

                                  />
                                  Yes
                                </label>
                                <label>
                                  <input
                                    type="checkbox"
                                    checked={visitorResponses[invite.id] === 'no'}
                                    onChange={() => handleVisitorResponseChange(invite.id, 'no')}
                                    // disabled={invite.response === 'yes' || invite.response === 'no' || responsesSubmitted}
                                    disabled={invite.response === 'yes' || invite.response === 'no'}

                                  />
                                  No
                                </label>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                    <div className="paginationn">
                      <button
                        onClick={handlePrevPage12}
                        className="page-buttonn"
                        disabled={currentPage12 === 1}  // Disable the Previous button if on the first page
                      >
                        Previous
                      </button>



                      <span className="current-page">
                        Page {currentPage12}
                      </span>

                      <button
                        onClick={handleNextPage12}
                        className="page-buttonn"
                        disabled={currentPage12 === totalPages12}  // Disable the Next button if on the last page
                      >
                        Next
                      </button>
                    </div>
                    <button onClick={handleUpdateVisitorResponses} >Submit Visitor Responses</button>
                  </div>
                </>
              )}

            </>

          </Modal>


          <Row className="my-4 m-3 p-3">
            <Col>
              <h3>Meetingss</h3>
              <InputGroup className="mb-3">
                <FormControl
                  placeholder="Search by Date or Venue"
                  onChange={handleSearch}
                />
              </InputGroup>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>User</th>
                    <th>Date</th>
                    <th>Time</th>
                    <th>Venue</th>
                      <th>Chapter</th>
                    <th>Action</th>
                    <th>Remainder</th>
                  </tr>
                </thead>
                <tbody>
                  {currentMeetings.map((meeting, index) => {
                    const expired = isExpired(meeting.date, meeting.time); // Check if the meeting is expired
                    return (
                      <tr key={index}>
                        <td>
                          <FaUserCircle className="user-icon" style={{ fontSize: '20px' }} />
                        </td>
                        <td style={{
                          backgroundColor: expired ? '#f2f2f2' : 'transparent',
                          color: expired ? '#b0b0b0' : 'black',
                          cursor: expired ? 'not-allowed' : 'default',
                        }}>
                          <FaRegCalendarAlt /> {new Date(meeting.date).toLocaleDateString()}
                        </td>
                        <td style={{
                          backgroundColor: expired ? '#f2f2f2' : 'transparent',
                          color: expired ? '#b0b0b0' : 'black',
                          cursor: expired ? 'not-allowed' : 'default',
                        }}>
                          <FaRegClock /> {meeting.time}
                        </td>
                        <td style={{
                          backgroundColor: expired ? '#f2f2f2' : 'transparent',
                          color: expired ? '#b0b0b0' : 'black',
                          cursor: expired ? 'not-allowed' : 'default',
                        }}>
                          <FaMapPin /> {meeting.venue}
                        </td>
                               <td style={{
                          backgroundColor: expired ? '#f2f2f2' : 'transparent',
                          color: expired ? '#b0b0b0' : 'black',
                          cursor: expired ? 'not-allowed' : 'default',
                        }}>
                          <FaMapPin /> {meeting.chapter}
                        </td>
                        <td>
                          <Button
                            variant="primary"
                            onClick={() => handleShowModal(meeting.id, meeting.date)}
                          // Disable button if meeting is expired
                          >
                            Check here
                          </Button>
                        </td>
                        <td style={{
                          cursor: expired ? 'not-allowed' : 'pointer',
                          display: 'inline-block',
                        }}>
                          <Button
                            variant="primary"
                            // onClick={() => handleSendReminder(meeting.id)}
                             onClick={() => handleSendReminder(meeting.id, meeting.chapter)}
                            disabled={expired}
                            style={{
                              backgroundColor: expired ? '#f2f2f2' : 'transparent',
                              color: expired ? '#b0b0b0' : 'black',
                              cursor: expired ? 'not-allowed' : 'pointer', // optional for better UX
                            }}
                          >
                            Send Reminder
                          </Button>

                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>

              <div className="pagination">
                <Button
                  variant="secondary"
                  disabled={currentPagee === 1}
                  onClick={() => handlePageChangee(currentPagee - 1)}
                >
                  Prev
                </Button>

                {[...Array(totalPagess)].map((_, index) => (
                  <Button
                    key={index}
                    variant={currentPagee === index + 1 ? 'primary' : 'secondary'}
                    onClick={() => handlePageChangee(index + 1)}
                  >
                    {index + 1}
                  </Button>
                ))}

                <Button
                  variant="secondary"
                  disabled={isLastPageWithLessThan10}
                  onClick={() => handlePageChangee(currentPagee + 1)}
                >
                  Next
                </Button>
              </div>


            </Col>
          </Row>


          <Modal
            isOpen={showMeetingModal}
            onRequestClose={handleCloseModal}
            contentLabel="Meeting Details"
            style={{
              chapter: {
                width: '80%',
                maxWidth: '900px',
                margin: 'auto',
                padding: '20px',
                height: '80%',
                overflow: 'auto',
              },
            }}
          >
            <h2>Meeting Details</h2>

            {selectedMeeting && selectedMeeting.length > 0 ? ( // Check if selectedMeeting exists and has data
              <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr>
                      <th>Meeting ID</th>
                      <th>User</th>
                      <th>Date</th>
                      <th>Time</th>
                      <th>Venue</th>
                      <th>Meeting Response</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedMeeting.map((meeting) => {
                      const isMeetingExpired = new Date(meeting.date) < new Date(); // Compare meeting date with current date
                      let responseText = meeting.response === "yes" ? "Attending the Meeting" : "Not Attending the Meeting";

                      // If the meeting is expired, update the response text to Present/Absent
                      if (isMeetingExpired) {
                        responseText = meeting.response === "yes" ? "Present" : "Absent";
                      }
                      return (
                        <tr key={meeting.id}>
                          <td>{meeting.meeting_id}</td>
                          <td>{meeting.user_email}</td>
                          <td>{new Date(meeting.date).toLocaleDateString()}</td>
                          <td>{meeting.time}</td>
                          <td>{meeting.venue}</td>
                           <td>
                          
                            <span style={{ color: meeting.response === "yes" ? "green" : "red" }}>
                              {responseText}
                            </span>
                          </td>

                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              <p>Loading meeting details...</p>
            )}

            <button onClick={handleCloseModal} style={{ marginTop: '20px' }}>Close</button>
          </Modal>

        </div>
      )} */}

{activeSection === "Meetings" && (
  <div
    style={{
      minHeight: "100vh",
      background: "#f4f7fb",
      padding: "20px",
    }}
  >
    {/* HEADER */}
    <div
      style={{
        background: "linear-gradient(135deg,#1e3a8a,#2563eb)",
        padding: "30px",
        borderRadius: "20px",
        color: "#fff",
        marginBottom: "25px",
        boxShadow: "0 10px 30px rgba(37,99,235,0.2)",
      }}
    >
      <h2
        style={{
          margin: 0,
          fontSize: "32px",
          fontWeight: "700",
        }}
      >
        Meetings Management
      </h2>

      <p
        style={{
          marginTop: "8px",
          opacity: 0.9,
          fontSize: "15px",
        }}
      >
        Manage meetings, attendance, visitors & reminders
      </p>

      <div
        style={{
          display: "flex",
          gap: "15px",
          flexWrap: "wrap",
          marginTop: "25px",
        }}
      >
        <button
          onClick={openModall}
          style={{
            border: "none",
            background: "#10b981",
            color: "#fff",
            padding: "12px 22px",
            borderRadius: "12px",
            fontWeight: "600",
            cursor: "pointer",
            boxShadow: "0 4px 12px rgba(16,185,129,0.3)",
          }}
        >
          + Add Meeting
        </button>

        <button
          onClick={openModallAtt}
          style={{
            border: "none",
            background: "#fff",
            color: "#1e3a8a",
            padding: "12px 22px",
            borderRadius: "12px",
            fontWeight: "600",
            cursor: "pointer",
          }}
        >
          + Attendance List
        </button>
      </div>
    </div>


          <Modal isOpen={modalIsOpenn} onRequestClose={closeModall}>
            <h2>Add Meetings </h2>
            <Form>
<div style={{ marginBottom: '15px' }}>
  <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Chapter:</label>
  <select
    value={selectedChapter}
    onChange={(e) => setSelectedChapter(e.target.value)}
    style={{
      width: '30%',
      padding: '10px',
      borderRadius: '5px',
      border: '1px solid #ccc',
      fontSize: '16px',
      outline: 'none',
      boxSizing: 'border-box',
      backgroundColor: '#f9f9f9'
    }}
  >
    <option value="">Select a chapter</option>
    {chapters.map((chapter) => (
      <option key={chapter.chapter} value={chapter.chapter}>
        {chapter.chapter}
      </option>
    ))}
  </select>
</div>


              <div>
                <label>Date:</label>
                <DatePicker
                  selected={date}
                  onChange={(date) => setDate(date)}
                  dateFormat="MM/dd/yyyy"
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />
              </div>

              <div>
                <label>Time:</label>
                <input
                  type="time"
                  value={time}
                  onChange={(e) => setTime(e.target.value)}
                />
              </div>

            
<div style={{ marginBottom: "20px" }}>


{/* Google Map Picker */}
<GoogleMapPicker
  onLocationSelect={({ venueName, latitude, longitude, mapUrl }) => {
   
    setLatitude(latitude);
    setLongitude(longitude);

  }}
/>


  {/* Auto-Captured Details (Link + Coordinates) */}
  <div style={{ display: "flex", gap: "10px" }}>
    <div style={{ flex: 1 }}>
      <label style={{ fontSize: "12px", color: "#64748b", fontWeight: "600" }}>Latitude:</label>
      <input
        type="text"
        value={latitude}
        readOnly
        style={{
          width: "100%",
          padding: "6px 8px",
          borderRadius: "6px",
          border: "1px solid #cbd5e1",
          backgroundColor: "#f8fafc",
          fontSize: "13px",
          boxSizing: "border-box",
        }}
      />
    </div>

    <div style={{ flex: 1 }}>
      <label style={{ fontSize: "12px", color: "#64748b", fontWeight: "600" }}>Longitude:</label>
      <input
        type="text"
        value={longitude}
        readOnly
        style={{
          width: "100%",
          padding: "6px 8px",
          borderRadius: "6px",
          border: "1px solid #cbd5e1",
          backgroundColor: "#f8fafc",
          fontSize: "13px",
          boxSizing: "border-box",
        }}
      />
    </div>
  </div>

 <div>
                <label>Venue:</label>
                <input
                  type="text"
                  value={venue}
                  onChange={(e) => setVenue(e.target.value)}
                />
              </div>
</div>
              <div>
                <label>Image:</label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={onImageChange}
                />
              </div>


              <div>
                <button type="button " className='m-3' onClick={handleSubmit}>Submit</button>
                <button type="button" className='m-3' onClick={closeModall}>Cancel</button>
              </div>
            </Form>
          </Modal>


           <Modal isOpen={modalIsOpen} onRequestClose={closeModallAtt}>
            <h2>Meeting Attendance List</h2>
            <button type="button" className='m-3' onClick={closeModallAtt}>Close</button>





            <>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ marginRight: '10px' }}>
                  <label htmlFor="dateDropdown">Select Date:</label>
                  <select
                    id="dateDropdown"
                    value={selectedDate}
                    onChange={handleDateChange}
                    style={{
                      width: '150px',
                      padding: '8px',
                      borderRadius: '8px',
                      fontSize: '14px',
                      overflowY: 'auto',
                      maxHeight: '200px',

                    }}
                  >
                    <option value="">Select a date</option>
                    {uniqueDates.map((date) => (
                      <option key={date} value={date}>
                        {new Date(date).toLocaleDateString()}
                      </option>
                    ))}
                  </select>
                </div>

                {selectedDate && (
                  <div>
                    <label htmlFor="venueDropdown">Select Venue:</label>
                    <select
                      id="venueDropdown"
                      value={selectedVenue}
                      onChange={handleVenueChange}
                      style={{
                        width: '150px',
                        padding: '8px',
                        borderRadius: '8px',
                        fontSize: '14px',
                      }}
                    >
                      <option value="">Select a venue</option>
                      {venuesForSelectedDate.map((venue, index) => (
                        <option key={index} value={venue}>
                          {venue}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
              </div>

              {selectedVenue && selectedMeetingDetails.length > 0 && (
                <div>
                  <h3>Meeting Details (Response Given Members):</h3>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr>
                        <th style={{ border: '1px solid black', padding: '10px' }}>USERID</th>

                        <th style={{ border: '1px solid black', padding: '10px' }}>User Email</th>

                        <th style={{ border: '1px solid black', padding: '10px' }}>Response</th>
                        <th style={{ border: '1px solid black', padding: '10px' }}>  Action</th>

                      </tr>
                    </thead>
                    <tbody>
                      {currentUsers13.map((meeting, index) => {

                        const user = users.find((user) => user.id === meeting.user_id);
                        // const isMeetingExpired = new Date(meeting.date) < new Date(); // Check if meeting is expired
                        const meetingDateTime = new Date(`${meeting.date}T${meeting.time}:00`);
                        console.log('this is the meetingDateTime', meetingDateTime)
                        const isMeetingExpired = meetingDateTime.getTime() + 24 * 60 * 60 * 1000 < Date.now();

                        let responseText = meeting.response === 'yes' ? 'Attending' : 'Not Attending';

                        // If meeting is expired, update response to Present or Absent
                        if (isMeetingExpired) {
                          responseText = meeting.response === 'yes' ? 'Present' : 'Absent';
                        }


                        return (
                          <tr key={index}>
                            <td style={{ border: '1px solid black', padding: '8px' }}>{user ? user.name : 'Unknown'}</td>
                            <td style={{ border: '1px solid black', padding: '8px' }}>{meeting.user_email}</td>

                            <td style={{ border: '1px solid black', padding: '8px', color: meeting.response === 'yes' ? 'green' : 'red' }}>
                              {meeting.response === 'yes' ? 'Attending' : 'Not Attending'}
                            
                            </td>


                            <td style={{ border: '1px solid black', padding: '8px' }}>
                              {meeting.admin_response ? (
                                <span style={{ color: meeting.admin_response === 'yes' ? 'green' : 'red', fontWeight: 'bold' }}>
                                  {meeting.admin_response === 'yes' ? '✔ Attended' : '✘ Not Attended'}
                                </span>
                              ) : (
                                <>
                                  <label>
                                    <input
                                      type="checkbox"
                                      checked={meetingResponses[meeting.user_id] === 'yes'}
                                      onChange={() => handleResponseChange(meeting.user_id, 'yes')}
                                      disabled={isMeetingExpired}
                                    />
                                    Yes
                                  </label>
                                  <label>
                                    <input
                                      type="checkbox"
                                      checked={meetingResponses[meeting.user_id] === 'no'}
                                      onChange={() => handleResponseChange(meeting.user_id, 'no')}
                                      disabled={isMeetingExpired}
                                    />
                                    No
                                  </label>
                                </>
                              )}
                            </td>


                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  <div className="paginationn">
                    <button
                      onClick={handlePrevPage13}
                      className="page-buttonn"
                      disabled={currentPage13 === 1}  // Disable the Previous button if on the first page
                    >
                      Previous
                    </button>



                    <span className="current-page">
                      Page {currentPage13} of {totalPages13}
                    </span>

                    <button
                      onClick={handleNextPage13}
                      className="page-buttonn"
                      disabled={currentPage13 === totalPages13}  // Disable the Next button if on the last page
                    >
                      Next
                    </button>
                  </div>
                  <button onClick={handleUpdateResponse}>Submit</button>
                </div>
              )}

              {selectedVenue && selectedMeetingDetails.length > 0 && (
                <div>
                  <h3>Meeting Details (Response not given Members)</h3>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr>
                        <th style={{ border: '1px solid black', padding: '10px' }}>USERID</th>

                        <th style={{ border: '1px solid black', padding: '10px' }}>User Email</th>

   <th style={{ border: '1px solid black', padding: '10px' }}>  Action</th>

                      </tr>
                    </thead>
                    <tbody>
                      {currentUsers1
                        .map((meeting, index) => {

                          console.log('this is the currentUsers', currentUsers)
                          // console.log('this is ths users', users)
                          const user = users.find((user) => user.id === meeting.user_id);

                          //const isMeetingExpired = new Date(meeting.date) < new Date(); // Check if meeting is expired
                          const meetingDateTime = new Date(`${meeting.date}T${meeting.time}:00`);
                          console.log('this is the meetingDateTime', meetingDateTime)
                          const isMeetingExpired = meetingDateTime.getTime() + 24 * 60 * 60 * 1000 < Date.now();

                          let responseText = meeting.response === 'yes' ? 'Attending' : 'Not Attending';

                          // If meeting is expired, update response to Present or Absent
                          if (isMeetingExpired) {
                            responseText = meeting.response === 'yes' ? 'Present' : 'Absent';
                          }


                          return (
                            <tr key={index}>
                              <td style={{ border: '1px solid black', padding: '8px' }}>{meeting.name}</td>
                              <td style={{ border: '1px solid black', padding: '8px' }}>{meeting.email}</td>
                              <td style={{ border: '1px solid black', padding: '8px' }}>
                                {meeting.admin_response ? (
                                  <span style={{ color: meeting.admin_response === 'yes' ? 'green' : 'red', fontWeight: 'bold' }}>
                                    {meeting.admin_response === 'yes' ? '✔ Attended' : '✘ Not Attended'}
                                  </span>
                                ) : (
                                  <>
                                    <label>
                                      <input
                                        type="checkbox"
                                        checked={meetingResponses[meeting.id] === 'yes'}
                                        onClick={() => handleAdminResponseClick(meeting.id, "yes")}
                                      // onChange={() => handleAdminResponseChange(meeting.id, 'yes')}
                                      // disabled={isMeetingExpired}
                                      />
                                      Yes
                                    </label>
                                    <label>
                                      <input
                                        type="checkbox"
                                        checked={meetingResponses[meeting.id] === 'no'}
                                        // onChange={() => handleAdminResponseChange(meeting.id, 'no')}
                                        onClick={() => handleAdminResponseClick(meeting.id, "no")}
                                      // disabled={isMeetingExpired}
                                      />
                                      No
                                    </label>
                                  </>
                                )}
                              </td>


                            </tr>
                          );
                        })}

                    </tbody>
                  </table>
                  <div className="paginationn">
                    <button
                      onClick={handlePrevPage11}
                      className="page-buttonn"
                      disabled={currentPage11 === 1}  // Disable the Previous button if on the first page
                    >
                      Previous
                    </button>



                    <span className="current-page">
                      Page {currentPage11} of {totalPages11}
                    </span>

                    <button
                      onClick={handleNextPage11}
                      className="page-buttonn"
                      disabled={currentPage11 === totalPages11}  // Disable the Next button if on the last page
                    >
                      Next
                    </button>
                  </div>
                  <button onClick={handleAdminResponseSubmit}>Submit Admin Response m</button>
                </div>
              )}


              {selectedVenue && selectedMeetingDetails.length > 0 && (
                <>
                
                  <div style={{ marginTop: '30px' }}>
                    <h3>Visitor Invitations:</h3>

                   
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      border: '1px solid #ccc',
                      borderRadius: '8px',
                      padding: '8px 12px',
                      maxWidth: '320px',
                      marginBottom: '20px',
                      backgroundColor: '#fff',
                      boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                    }}>
                      <FiSearch size={20} color="#666" style={{ marginRight: '8px' }} />
                      <input
                        type="text"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        placeholder="Search by Name, Email, Mobile..."
                        style={{
                          border: 'none',
                          outline: 'none',
                          fontSize: '16px',
                          width: '100%',
                          backgroundColor: 'transparent',
                          color: '#333'
                        }}
                      />
                    </div>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th style={{ border: '1px solid black', padding: '10px' }}>Visitor Invite Sender </th>
                          <th style={{ border: '1px solid black', padding: '10px' }}>Visitor Name</th>
                          <th style={{ border: '1px solid black', padding: '10px' }}>Email</th>
                          <th style={{ border: '1px solid black', padding: '10px' }}>Mobile</th>
                          <th style={{ border: '1px solid black', padding: '10px' }}>Response</th>
                          <th style={{ border: '1px solid black', padding: '10px' }}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentUsers12
                          // .filter(invite => invite.meeting_id === selectedMeetingDetails[0]?.meeting_id)
                          .map((invite, index) => (

                            <tr key={index}>
                              <td style={{ border: '1px solid black', padding: '8px' }}>{getUserNameById(invite.userId)}</td>

                              <td style={{ border: '1px solid black', padding: '8px' }}>{invite.visitor_name}</td>
                              <td style={{ border: '1px solid black', padding: '8px' }}>{invite.visitor_email}</td>
                              <td style={{ border: '1px solid black', padding: '8px' }}>{invite.visitor_mobile}</td>
                              <td style={{ border: '1px solid black', padding: '8px', color: invite.response === 'yes' ? 'green' : invite.response === 'no' ? 'red' : 'gray' }}>
                                {invite.response ? (invite.response === 'yes' ? 'Attending' : 'Not Attending') : 'Pending'}
                              </td>
                              <td style={{ border: '1px solid black', padding: '8px' }}>
                                <label>
                                  <input
                                    type="checkbox"
                                    checked={visitorResponses[invite.id] === 'yes'}
                                    onChange={() => handleVisitorResponseChange(invite.id, 'yes')}
                                    // disabled={invite.response === 'yes' || invite.response === 'no' || responsesSubmitted}
                                    disabled={invite.response === 'yes' || invite.response === 'no'}

                                  />
                                  Yes
                                </label>
                                <label>
                                  <input
                                    type="checkbox"
                                    checked={visitorResponses[invite.id] === 'no'}
                                    onChange={() => handleVisitorResponseChange(invite.id, 'no')}
                                    // disabled={invite.response === 'yes' || invite.response === 'no' || responsesSubmitted}
                                    disabled={invite.response === 'yes' || invite.response === 'no'}

                                  />
                                  No
                                </label>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                    <div className="paginationn">
                      <button
                        onClick={handlePrevPage12}
                        className="page-buttonn"
                        disabled={currentPage12 === 1}  // Disable the Previous button if on the first page
                      >
                        Previous
                      </button>



                      <span className="current-page">
                        Page {currentPage12}
                      </span>

                      <button
                        onClick={handleNextPage12}
                        className="page-buttonn"
                        disabled={currentPage12 === totalPages12}  // Disable the Next button if on the last page
                      >
                        Next
                      </button>
                    </div>
                    <button onClick={handleUpdateVisitorResponses} >Submit Visitor Responses</button>
                  </div>
                </>
              )}

            </>

          </Modal>

          <Modal
            isOpen={showMeetingModal}
            onRequestClose={handleCloseModal}
            contentLabel="Meeting Details"
            style={{
              chapter: {
                width: '80%',
                maxWidth: '900px',
                margin: 'auto',
                padding: '20px',
                height: '80%',
                overflow: 'auto',
              },
            }}
          >
            <h2>Meeting Details</h2>

            {selectedMeeting && selectedMeeting.length > 0 ? ( // Check if selectedMeeting exists and has data
              <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <thead>
                    <tr>
                      <th>Meeting ID</th>
                      <th>User</th>
                      <th>Date</th>
                      <th>Time</th>
                      <th>Venue</th>
                      <th>Meeting Response</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedMeeting.map((meeting) => {
                      const isMeetingExpired = new Date(meeting.date) < new Date(); // Compare meeting date with current date
                      let responseText = meeting.response === "yes" ? "Attending the Meeting" : "Not Attending the Meeting";

                      // If the meeting is expired, update the response text to Present/Absent
                      if (isMeetingExpired) {
                        responseText = meeting.response === "yes" ? "Present" : "Absent";
                      }
                      return (
                        <tr key={meeting.id}>
                          <td>{meeting.meeting_id}</td>
                          <td>{meeting.user_email}</td>
                          <td>{new Date(meeting.date).toLocaleDateString()}</td>
                          <td>{meeting.time}</td>
                          <td>{meeting.venue}</td>
                           <td>
                          
                            <span style={{ color: meeting.response === "yes" ? "green" : "red" }}>
                              {responseText}
                            </span>
                          </td>

                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              <p>Loading meeting details...</p>
            )}

            <button onClick={handleCloseModal} style={{ marginTop: '20px' }}>Close</button>
          </Modal>


    {/* MEETINGS TABLE */}
    <div
      style={{
        background: "#fff",
        borderRadius: "20px",
        overflow: "hidden",
        boxShadow: "0 8px 25px rgba(0,0,0,0.06)",
      }}
    >
      <div
        style={{
          padding: "20px",
          borderBottom: "1px solid #e2e8f0",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "15px",
        }}
      >
        <h3
          style={{
            margin: 0,
            fontWeight: "700",
            color: "#1e293b",
          }}
        >
          Meetings List
        </h3>

        <div style={{ width: "300px" }}>
          <InputGroup>
            <FormControl
              placeholder="Search by Date or Venue"
              onChange={handleSearch}
              style={{
                borderRadius: "12px",
                padding: "12px",
                border: "1px solid #cbd5e1",
              }}
            />
          </InputGroup>
        </div>
      </div>

      <div style={{ overflowX: "auto" }}>
        <Table
          striped
          bordered
          hover
          style={{
            marginBottom: 0,
            minWidth: "1000px",
          }}
        >
          <thead
            style={{
              background: "#eff6ff",
            }}
          >
            <tr>
              <th>User</th>
              <th>Date</th>
              <th>Time</th>
              <th>Venue</th>
              <th>Chapter</th>
              <th>Action</th>
              <th>Reminder</th>
            </tr>
          </thead>

          <tbody>
            {currentMeetings.map((meeting, index) => {
              const expired = isExpired(
                meeting.date,
                meeting.time
              );

              return (
                <tr key={index}>
                  <td>
                    <FaUserCircle
                      className="user-icon"
                      style={{
                        fontSize: "24px",
                        color: "#2563eb",
                      }}
                    />
                  </td>

                  <td>{new Date(meeting.date).toLocaleDateString()}</td>

                  <td>{meeting.time}</td>

                  <td>{meeting.venue}</td>

                  <td>{meeting.chapter}</td>

                  <td>
                    <Button
                      variant="primary"
                      onClick={() =>
                        handleShowModal(
                          meeting.id,
                          meeting.date
                        )
                      }
                      style={{
                        borderRadius: "10px",
                        fontWeight: "600",
                      }}
                    >
                      Check Here
                    </Button>
                  </td>

                  <td>
                    <Button
                      variant="primary"
                      onClick={() =>
                        handleSendReminder(
                          meeting.id,
                          meeting.chapter
                        )
                      }
                      disabled={expired}
                      style={{
                        borderRadius: "10px",
                        fontWeight: "600",
                        opacity: expired ? 0.5 : 1,
                      }}
                    >
                      Send Reminder
                    </Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>

      {/* PAGINATION */}
      <div
        style={{
          padding: "20px",
          display: "flex",
          justifyContent: "center",
          gap: "10px",
          flexWrap: "wrap",
        }}
      >
        <Button
          variant="secondary"
          disabled={currentPagee === 1}
          onClick={() =>
            handlePageChangee(currentPagee - 1)
          }
        >
          Prev
        </Button>

        {[...Array(totalPagess)].map((_, index) => (
          <Button
            key={index}
            variant={
              currentPagee === index + 1
                ? "primary"
                : "secondary"
            }
            onClick={() =>
              handlePageChangee(index + 1)
            }
          >
            {index + 1}
          </Button>
        ))}

        <Button
          variant="secondary"
          disabled={isLastPageWithLessThan10}
          onClick={() =>
            handlePageChangee(currentPagee + 1)
          }
        >
          Next
        </Button>
      </div>
    </div>
  </div>
)}


{activeSection === "Notifications" && (
  <div
    style={{
      minHeight: "100vh",
      background: "#f4f7fb",
      padding: "20px",
    }}
  >
    {/* HEADER */}
    <div
      style={{
        background: "linear-gradient(135deg, #7c3aed, #4f46e5)",
        padding: "30px",
        borderRadius: "20px",
        color: "#fff",
        marginBottom: "25px",
        boxShadow: "0 10px 30px rgba(79, 70, 229, 0.2)",
      }}
    >
      <h2
        style={{
          margin: 0,
          fontSize: "32px",
          fontWeight: "700",
        }}
      >
        Push Notifications
      </h2>

      <p
        style={{
          marginTop: "8px",
          opacity: 0.9,
          fontSize: "15px",
        }}
      >
        Send targeted push notifications to iOS and Android users
      </p>

      <div
        style={{
          display: "flex",
          gap: "15px",
          flexWrap: "wrap",
          marginTop: "25px",
        }}
      >
        <button
          onClick={() => handleOpenNotificationModal("ios")}
          style={{
            border: "none",
            background: "#fff",
            color: "#4f46e5",
            padding: "12px 22px",
            borderRadius: "12px",
            fontWeight: "600",
            cursor: "pointer",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          }}
        >
          📱 Send iOS Notification
        </button>

        <button
          onClick={() => handleOpenNotificationModal("android")}
          style={{
            border: "none",
            background: "#10b981",
            color: "#fff",
            padding: "12px 22px",
            borderRadius: "12px",
            fontWeight: "600",
            cursor: "pointer",
            boxShadow: "0 4px 12px rgba(16,185,129,0.3)",
          }}
        >
          🤖 Send Android Notification
        </button>
      </div>
    </div>

    {/* NOTIFICATION MODAL */}
    <Modal isOpen={notificationModalIsOpen} onRequestClose={handleCloseNotificationModal}>
      <div style={{ padding: "10px" }}>
        <h2 style={{ marginBottom: "20px", color: "#1e293b", textTransform: "capitalize" }}>
          Send {notificationType} Push Notification
        </h2>
        
        <Form onSubmit={handleNotificationSubmit}>
          <div style={{ marginBottom: "15px" }}>
            <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Title:</label>
            <input
              type="text"
              name="title"
              value={notificationData.title}
              onChange={handleNotificationChange}
              placeholder="Enter notification title..."
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "8px",
                border: "1px solid #cbd5e1",
                fontSize: "16px",
                outline: "none",
                boxSizing: "border-box",
              }}
              required
            />
          </div>

          <div style={{ marginBottom: "15px" }}>
            <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Body:</label>
            <textarea
              name="body"
              rows="4"
              value={notificationData.body}
              onChange={handleNotificationChange}
              placeholder="Type your message body here..."
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "8px",
                border: "1px solid #cbd5e1",
                fontSize: "16px",
                outline: "none",
                boxSizing: "border-box",
              }}
              required
            />
          </div>

          <div style={{ marginBottom: "20px" }}>
            <label style={{ display: "block", marginBottom: "5px", fontWeight: "bold" }}>Image (Optional):</label>
            <input
              type="file"
              accept="image/*"
              onChange={handleNotificationImageChange}
              style={{ fontSize: "14px" }}
            />
          </div>

          <div style={{ display: "flex", gap: "10px" }}>
            <button
              type="submit"
              style={{
                background: "#4f46e5",
                color: "#fff",
                border: "none",
                padding: "10px 20px",
                borderRadius: "8px",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              Send Notification
            </button>
            <button
              type="button"
              onClick={handleCloseNotificationModal}
              style={{
                background: "#e2e8f0",
                color: "#334155",
                border: "none",
                padding: "10px 20px",
                borderRadius: "8px",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              Cancel
            </button>
          </div>
        </Form>
      </div>
    </Modal>
    {/* NOTIFICATIONS LIST TABLE SECTION */}
    <div
      style={{
        background: "#fff",
        borderRadius: "20px",
        overflow: "hidden",
        boxShadow: "0 8px 25px rgba(0,0,0,0.06)",
      }}
    >
      <div
        style={{
          padding: "20px",
          borderBottom: "1px solid #e2e8f0",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "15px",
        }}
      >
        <h3 style={{ margin: 0, fontWeight: "700", color: "#1e293b" }}>
          Notification History & Logs
        </h3>

        {/* Platform Filter Dropdown */}
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <label style={{ fontWeight: "600", fontSize: "14px", color: "#64748b" }}>Filter Platform:</label>
          <select
            value={filterPlatform}
            onChange={(e) => setFilterPlatform(e.target.value)}
            style={{
              padding: "8px 12px",
              borderRadius: "10px",
              border: "1px solid #cbd5e1",
              fontSize: "14px",
              outline: "none",
              background: "#f8fafc",
            }}
          >
            <option value="all">All Platforms</option>
            <option value="ios">iOS</option>
            <option value="android">Android</option>
          </select>
        </div>
      </div>

      <div style={{ overflowX: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", minWidth: "900px" }}>
          <thead>
            <tr style={{ background: "#eff6ff", textAlign: "left" }}>
              <th style={{ padding: "12px 15px", borderBottom: "1px solid #e2e8f0" }}>ID</th>
              <th style={{ padding: "12px 15px", borderBottom: "1px solid #e2e8f0" }}>Platform</th>
              <th style={{ padding: "12px 15px", borderBottom: "1px solid #e2e8f0" }}>Title</th>
              <th style={{ padding: "12px 15px", borderBottom: "1px solid #e2e8f0" }}>Body</th>
              <th style={{ padding: "12px 15px", borderBottom: "1px solid #e2e8f0" }}>Image</th>
              <th style={{ padding: "12px 15px", borderBottom: "1px solid #e2e8f0" }}>Created At</th>
              <th style={{ padding: "12px 15px", borderBottom: "1px solid #e2e8f0" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {notificationsList.length > 0 ? (
              notificationsList.map((item) => (
                <tr key={item.id} style={{ borderBottom: "1px solid #f1f5f9" }}>
                  <td style={{ padding: "12px 15px", fontWeight: "600", color: "#334155" }}>{item.id}</td>
                  <td style={{ padding: "12px 15px" }}>
                    <span
                      style={{
                        padding: "4px 10px",
                        borderRadius: "20px",
                        fontSize: "12px",
                        fontWeight: "600",
                        background: item.platform === "ios" ? "#e0e7ff" : "#dcfce7",
                        color: item.platform === "ios" ? "#3730a3" : "#166534",
                        textTransform: "uppercase",
                      }}
                    >
                      {item.platform}
                    </span>
                  </td>
                  <td style={{ padding: "12px 15px", color: "#1e293b", fontWeight: "500" }}>{item.title}</td>
                  <td style={{ padding: "12px 15px", color: "#64748b" }}>{item.body}</td>
                  <td style={{ padding: "12px 15px" }}>
                    {item.image_url ? (
                      <a href={item.image_url} target="_blank" rel="noopener noreferrer">
                        <img
                          src={item.image_url}
                          alt="notification thumbnail"
                          style={{ width: "40px", height: "40px", objectFit: "cover", borderRadius: "6px" }}
                        />
                      </a>
                    ) : (
                      <span style={{ color: "#94a3b8", fontSize: "12px" }}>No Image</span>
                    )}
                  </td>
                  <td style={{ padding: "12px 15px", color: "#64748b", fontSize: "14px" }}>
                    {new Date(item.created_at).toLocaleString()}
                  </td>
                  <td style={{ padding: "12px 15px" }}>
                    <button
                      onClick={() => handleDeleteNotification(item.id)}
                      style={{
                        background: "#fee2e2",
                        color: "#991b1b",
                        border: "none",
                        padding: "6px 12px",
                        borderRadius: "8px",
                        fontWeight: "600",
                        cursor: "pointer",
                        fontSize: "13px",
                      }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" style={{ textAlign: "center", padding: "30px", color: "#94a3b8" }}>
                  No push notifications found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  </div>
)}

      {/* {activeSection === "Events" && (
        <div>
          <button style={{ margin: '30px' }} onClick={openModalll}>+ Events </button>

          <Modal isOpen={modalIsOpennn} onRequestClose={closeModalll}>
            <h2>Events Details</h2>
            <Form>

              <div style={{ marginBottom: '15px' }}>
  <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Chapter:</label>
  <select
    value={selectedChapter}
    onChange={(e) => setSelectedChapter(e.target.value)}
    style={{
      width: '30%',
      padding: '10px',
      borderRadius: '5px',
      border: '1px solid #ccc',
      fontSize: '16px',
      outline: 'none',
      boxSizing: 'border-box',
      backgroundColor: '#f9f9f9'
    }}
  >
    <option value="">Select a chapter</option>
    {chapters.map((chapter) => (
      <option key={chapter.chapter} value={chapter.chapter}>
        {chapter.chapter}
      </option>
    ))}
  </select>
</div>
              <div>
                <label>Date:</label>
                <DatePicker
                  selected={date}
                  onChange={(date) => setDate(date)}
                  dateFormat="MM/dd/yyyy"
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                />
              </div>

              <div>
                <label>Time:</label>
                <input
                  type="time"
                  value={time}
                  onChange={(e) => setTime(e.target.value)}
                />
              </div>

              <div>
                <label>Venue:</label>
                <input
                  type="text"
                  value={venue}
                  onChange={(e) => setVenue(e.target.value)}
                />
              </div>
              <div>
                <label>Events:</label>
                <input
                  type="text"
                  value={events}
                  onChange={(e) => setEvent(e.target.value)}
                />
              </div>

               <div>
                <label>Image:</label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={onImageChange}
                />
              </div>

              <div>
                <button type="button " className='m-3' onClick={handleSubmitEvent}>Submit</button>
                <button type="button" className='m-3' onClick={closeModalll}>Cancel</button>
              </div>
            </Form>
          </Modal>

          <button style={{ margin: '30px' }} onClick={openModallEventAtt}>+ Events Attendance List</button>

          <Modal isOpen={modalIsOpenEvent} onRequestClose={closeModallEventAtt}>
            <h2>Event Attendance List</h2>
            <button type="button" className='m-3' onClick={closeModallEventAtt}>Close</button>





            <>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ marginRight: '10px' }}>
                  <label htmlFor="dateDropdown">Select Date:</label>
                  <select
                    id="dateDropdown"
                    value={selectedEventDate}
                    onChange={handleDateEventChange}
                    style={{
                      width: '150px',
                      padding: '8px',
                      borderRadius: '8px',
                      fontSize: '14px',
                      overflowY: 'auto',
                      maxHeight: '200px',

                    }}
                  >
                    <option value="">Select Event date</option>
                    {uniqueEventDates.map((date) => (
                      <option key={date} value={date}>
                        {new Date(date).toLocaleDateString()}
                      </option>
                    ))}
                  </select>
                </div>

                {selectedEventDate && (
                  <div>
                    <label htmlFor="venueDropdown">Select Venue:</label>
                    <select
                      id="venueDropdown"
                      value={selectedEventVenue}
                      onChange={handleEventVenueChange}
                      style={{
                        width: '150px',
                        padding: '8px',
                        borderRadius: '8px',
                        fontSize: '14px',
                      }}
                    >
                      <option value="">Select a venue</option>
                      {venuesEventForSelectedDate.map((venue, index) => (
                        <option key={index} value={venue}>
                          {venue}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                {selectedEventVenue && (
                  <div>
                    <label htmlFor="venueDropdown">Select Event:</label>
                    <select
                      id="venueDropdown"
                      value={selectedEvents}
                      onChange={handleEventChange}
                      style={{
                        width: '150px',
                        padding: '8px',
                        borderRadius: '8px',
                        fontSize: '14px',
                      }}
                    >
                      <option value="">Select a evnte </option>
                      {EventForSelectedDate.map((venue, index) => (
                        <option key={index} value={venue}>
                          {venue}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
              </div>


              {selectedEvents && selectedEventDetails.length > 0 && (
                <div>
                  <h3>Event Details (Response Given Members):</h3>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr>
                        <th style={{ border: '1px solid black', padding: '10px' }}>USERID</th>

                        <th style={{ border: '1px solid black', padding: '10px' }}>User Email</th>

                        <th style={{ border: '1px solid black', padding: '10px' }}>Response</th>
                        <th style={{ border: '1px solid black', padding: '10px' }}>  Action</th>

                      </tr>
                    </thead>
                    <tbody>
                    

                      {currentUsers13Event.map((event, index) => {
                        const user = users.find(user => user.id === event.user_id);
                        const meetingDateTime = new Date(`${event.date}T${event.time}:00`);
                        const isMeetingExpired = meetingDateTime.getTime() + 24 * 60 * 60 * 1000 < Date.now();

                        let responseText = event.response === 'yes' ? 'Attending' : 'Not Attending';

                        // If meeting is expired, update response to Present or Absent
                        if (isMeetingExpired) {
                          responseText = event.response === 'yes' ? 'Present' : 'Absent';
                        }


                        return (
                          <tr key={index}>
                            <td style={{ border: '1px solid black', padding: '8px' }}>{user ? user.name : 'Unknown'}</td>
                            <td style={{ border: '1px solid black', padding: '8px' }}>{event.user_email}</td>

                            {/* <td style={{ border: '1px solid black', padding: '8px', color: event.response === 'yes' ? 'green' : 'red' }}>
                              {event.response === 'yes' ? 'Attending' : 'Not Attending'}
                            </td> */}
                            {/* <td style={{ border: '1px solid black', padding: '8px' }}>
                              {/* Yes Checkbox 
                              <label>
                                <input
                                  type="checkbox"
                                  checked={eventResponses[event.user_id] === 'yes'}
                                  onChange={() => handleEventResponseChange(event.user_id, 'yes')}
                                />
                                Yes
                              </label>

                      
                              <label>
                                <input
                                  type="checkbox"
                                  checked={eventResponses[event.user_id] === 'no'}
                                  onChange={() => handleEventResponseChange(event.user_id, 'no')}
                                />
                                No
                              </label>
                            </td> *
                              <td style={{ border: '1px solid black', padding: '8px', color: event.response === 'yes' ? 'green' : 'red' }}>
                              {event.response === 'yes' ? 'Attending' : 'Not Attending'}
                             
                            </td>


                            <td style={{ border: '1px solid black', padding: '8px' }}>
                              {event.admin_response ? (
                                <span style={{ color: event.admin_response === 'yes' ? 'green' : 'red', fontWeight: 'bold' }}>
                                  {event.admin_response === 'yes' ? '✔ Attended' : '✘ Not Attended'}
                                </span>
                              ) : (
                                <>
                                  <label>
                                    <input
                                      type="checkbox"
                                      checked={eventResponses[event.user_id] === 'yes'}
                                      onChange={() => handleEventResponseChange(event.user_id, 'yes')}
                                      disabled={isMeetingExpired}
                                    />
                                    Yes
                                  </label>
                                  <label>
                                    <input
                                      type="checkbox"
                                      checked={eventResponses[event.user_id] === 'no'}
                                      onChange={() => handleEventResponseChange(event.user_id, 'no')}
                                      disabled={isMeetingExpired}
                                    />
                                    No
                                  </label>
                                </>
                              )}
                            </td>


                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                     <div className="paginationn">
                    <button
                      onClick={handlePrevPage13Event}
                      className="page-buttonn"
                      disabled={currentPage13Event === 1}  // Disable the Previous button if on the first page
                    >
                      Previous
                    </button>



                    <span className="current-page">
                      Page {currentPage13Event} of {totalPages13Event}
                    </span>

                    <button
                      onClick={handleNextPage13Event}
                      className="page-buttonn"
                      disabled={currentPage13Event === totalPages13Event}  // Disable the Next button if on the last page
                    >
                      Next
                    </button>
                  </div>
                  <button onClick={handleUpdateEventResponse}>Submit</button>
                </div>
              )}





               {selectedEvents && selectedEventDetails.length > 0 && (
                <div>
                  <h3>Event Details (Response not given Members)</h3>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr>
                        <th style={{ border: '1px solid black', padding: '10px' }}>USERID</th>

                        <th style={{ border: '1px solid black', padding: '10px' }}>User Email</th>

                         <th style={{ border: '1px solid black', padding: '10px' }}>  Action</th>

                      </tr>
                    </thead>
                    <tbody> 
                       {currentUsers1Event
                        .map((event, index) => {

                          console.log('this is the currentUsers', currentUsers)
                          // console.log('this is ths users', users)
                          const user = users.find((user) => user.id === event.user_id);

                          //const isMeetingExpired = new Date(meeting.date) < new Date(); // Check if meeting is expired
                          const meetingDateTime = new Date(`${event.date}T${event.time}:00`);
                          console.log('this is the meetingDateTime', meetingDateTime)
                          const isMeetingExpired = meetingDateTime.getTime() + 24 * 60 * 60 * 1000 < Date.now();

                          let responseText = event.response === 'yes' ? 'Attending' : 'Not Attending';

                          // If meeting is expired, update response to Present or Absent
                          if (isMeetingExpired) {
                            responseText = event.response === 'yes' ? 'Present' : 'Absent';
                          }


                          return (
                            <tr key={index}>
                              <td style={{ border: '1px solid black', padding: '8px' }}>{event.name}</td>
                              <td style={{ border: '1px solid black', padding: '8px' }}>{event.email}</td>
                              <td style={{ border: '1px solid black', padding: '8px' }}>
                                {event.admin_response ? (
                                  <span style={{ color: event.admin_response === 'yes' ? 'green' : 'red', fontWeight: 'bold' }}>
                                    {event.admin_response === 'yes' ? '✔ Attended' : '✘ Not Attended'}
                                  </span>
                                ) : (
                                  <>
                                    <label>
                                      <input
                                        type="checkbox"
                                        checked={eventResponses[event.id] === 'yes'}
                                        onClick={() => handleAdminEventResponseClick(event.id, "yes")}
                                      // onChange={() => handleAdminResponseChange(meeting.id, 'yes')}
                                      // disabled={isMeetingExpired}
                                      />
                                      Yes
                                    </label>
                                    <label>
                                      <input
                                        type="checkbox"
                                        checked={eventResponses[event.id] === 'no'}
                                        // onChange={() => handleAdminResponseChange(meeting.id, 'no')}
                                        onClick={() => handleAdminEventResponseClick(event.id, "no")}
                                      // disabled={isMeetingExpired}
                                      />
                                      No
                                    </label>
                                  </>
                                )}
                              </td>


                            </tr>
                          );
                        })}

                    </tbody>
                  </table>
                  <div className="paginationn">
                    <button
                      onClick={handlePrevPage11Event}
                      className="page-buttonn"
                      disabled={currentPage11Event === 1}  // Disable the Previous button if on the first page
                    >
                      Previous
                    </button>



                    <span className="current-page">
                      Page {currentPage11Event} of {totalPages11Event}
                    </span>

                    <button
                      onClick={handleNextPage11Event}
                      className="page-buttonn"
                      disabled={currentPage11Event === totalPages11Event}  // Disable the Next button if on the last page
                    >
                      Next
                    </button>
                  </div>
                  <button onClick={handleAdminResponseSubmitEvent}>Submit Admin Responseh</button>
                </div>
              )}




                  {selectedEvents && selectedEventDetails.length > 0 && (
                <>

                  <div style={{ marginTop: '30px' }}>
                    <h3>Event Visitor Invitations:</h3>

                    {/* <div style={{ marginTop: '20px', marginBottom: '10px' }}>
                    <input
                      type="text"
                      placeholder="Search by Sender, Name, Email, Mobile"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      style={{ padding: '8px', width: '300px', borderRadius: '4px', border: '1px solid gray' }}
                    />
                  </div> *
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      border: '1px solid #ccc',
                      borderRadius: '8px',
                      padding: '8px 12px',
                      maxWidth: '320px',
                      marginBottom: '20px',
                      backgroundColor: '#fff',
                      boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                    }}>
                      <FiSearch size={20} color="#666" style={{ marginRight: '8px' }} />
                      <input
                        type="text"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        placeholder="Search by Name, Email, Mobile..."
                        style={{
                          border: 'none',
                          outline: 'none',
                          fontSize: '16px',
                          width: '100%',
                          backgroundColor: 'transparent',
                          color: '#333'
                        }}
                      />
                    </div>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th style={{ border: '1px solid black', padding: '10px' }}>Visitor Invite Sender </th>
                          <th style={{ border: '1px solid black', padding: '10px' }}>Visitor Name</th>
                          <th style={{ border: '1px solid black', padding: '10px' }}>Email</th>
                          <th style={{ border: '1px solid black', padding: '10px' }}>Mobile</th>
                          <th style={{ border: '1px solid black', padding: '10px' }}>Response</th>
                          <th style={{ border: '1px solid black', padding: '10px' }}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentUsers12Event
                          // .filter(invite => invite.meeting_id === selectedMeetingDetails[0]?.meeting_id)
                          .map((invite, index) => (

                            <tr key={index}>
                              <td style={{ border: '1px solid black', padding: '8px' }}>{getUserNameById(invite.userId)}</td>

                              <td style={{ border: '1px solid black', padding: '8px' }}>{invite.visitor_name}</td>
                              <td style={{ border: '1px solid black', padding: '8px' }}>{invite.visitor_email}</td>
                              <td style={{ border: '1px solid black', padding: '8px' }}>{invite.visitor_mobile}</td>
                              <td style={{ border: '1px solid black', padding: '8px', color: invite.response === 'yes' ? 'green' : invite.response === 'no' ? 'red' : 'gray' }}>
                                {invite.response ? (invite.response === 'yes' ? 'Attending' : 'Not Attending') : 'Pending'}
                              </td>
                              <td style={{ border: '1px solid black', padding: '8px' }}>
                                <label>
                                  <input
                                    type="checkbox"
                                    checked={visitorEventResponses[invite.id] === 'yes'}
                                    onChange={() => handleVisitorResponseChangeEvent(invite.id, 'yes')}
                                    // disabled={invite.response === 'yes' || invite.response === 'no' || responsesSubmitted}
                                    disabled={invite.response === 'yes' || invite.response === 'no'}

                                  />
                                  Yes
                                </label>
                                <label>
                                  <input
                                    type="checkbox"
                                    checked={visitorEventResponses[invite.id] === 'no'}
                                    onChange={() => handleVisitorResponseChangeEvent(invite.id, 'no')}
                                    // disabled={invite.response === 'yes' || invite.response === 'no' || responsesSubmitted}
                                    disabled={invite.response === 'yes' || invite.response === 'no'}

                                  />
                                  No
                                </label>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                    <div className="paginationn">
                      <button
                        onClick={handlePrevPage12Event}
                        className="page-buttonn"
                        disabled={currentPage12Event === 1}  // Disable the Previous button if on the first page
                      >
                        Previous
                      </button>



                      <span className="current-page">
                        Page {currentPage12Event}
                       
                      </span>

                      <button
                        onClick={handleNextPage12Event}
                        className="page-buttonn"
                        disabled={currentPage12Event === totalPages12Event}  // Disable the Next button if on the last page
                      >
                        Next
                      </button>
                    </div>
                    <button onClick={handleUpdateVisitorEventResponses} >Submit Visitor Event Responses</button>
                  </div>
                </>
              )}

            </>

          </Modal>




          <Row className="my-4 my-4 m-3 p-3">
            <Col>
              <h3>Events</h3>

              {/* <Table striped bordered hover>
                <thead>
                  <tr>
                    {/* <th>Id</th> 
                    <th>User</th>
                    <th>Date</th>
                    <th>Time</th>
                    <th>Venue</th>
                    <th>Event</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentMeetingss.map((event, index) => (
                    <tr key={index}>
                      {/* <td>{event.id}</td> 
                      <td>
                        <FaUserCircle className="user-icon" style={{ fontSize: '20px' }} />
                      </td>
                      <td style={{
                        backgroundColor: isExpired(event.date) ? '#f2f2f2' : 'transparent',
                        color: isExpired(event.date) ? '#b0b0b0' : 'black',
                        cursor: isExpired(event.date) ? 'not-allowed' : 'default',
                      }}>
                        <FaRegCalendarAlt />{new Date(event.date).toLocaleDateString()}</td>

                      <td style={{
                        backgroundColor: isExpired(event.date) ? '#f2f2f2' : 'transparent',
                        color: isExpired(event.date) ? '#b0b0b0' : 'black',
                        cursor: isExpired(event.date) ? 'not-allowed' : 'default',
                      }}>
                        <FaRegClock />{event.time}</td>
                      <td style={{
                        backgroundColor: isExpired(event.date) ? '#f2f2f2' : 'transparent',
                        color: isExpired(event.date) ? '#b0b0b0' : 'black',
                        cursor: isExpired(event.date) ? 'not-allowed' : 'default',
                      }}>
                        <FaMapPin /> {event.venue}</td>
                      <td style={{
                        backgroundColor: isExpired(event.date) ? '#f2f2f2' : 'transparent',
                        color: isExpired(event.date) ? '#b0b0b0' : 'black',
                        cursor: isExpired(event.date) ? 'not-allowed' : 'default',
                      }}>
                        <FaRegBell /> {event.events}</td>
                      <Button variant="primary" onClick={() => handleEventShowModal(event.id)}>Check here</Button>
                    </tr>
                  ))}
                </tbody>
              </Table> *



              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>User</th>
                    <th>Date</th>
                    <th>Time</th>
                    <th>Venue</th>
                    <th>Event</th>
                    <th>Action</th>
                    <th>Remainder</th>
                  </tr>
                </thead>
                <tbody>
                  {currentMeetingss.map((event, index) => {
                    const expired = isExpired(event.date, event.time); // Check if event is expired
                    return (
                      <tr key={index}>
                        <td>
                          <FaUserCircle className="user-icon" style={{ fontSize: '20px' }} />
                        </td>
                        <td style={{
                          backgroundColor: expired ? '#f2f2f2' : 'transparent',
                          color: expired ? '#b0b0b0' : 'black',
                          cursor: expired ? 'not-allowed' : 'default',
                        }}>
                          <FaRegCalendarAlt /> {new Date(event.date).toLocaleDateString()}
                        </td>
                        <td style={{
                          backgroundColor: expired ? '#f2f2f2' : 'transparent',
                          color: expired ? '#b0b0b0' : 'black',
                          cursor: expired ? 'not-allowed' : 'default',
                        }}>
                          <FaRegClock /> {event.time}
                        </td>
                        <td style={{
                          backgroundColor: expired ? '#f2f2f2' : 'transparent',
                          color: expired ? '#b0b0b0' : 'black',
                          cursor: expired ? 'not-allowed' : 'default',
                        }}>
                          <FaMapPin /> {event.venue}
                        </td>
                        <td style={{
                          backgroundColor: expired ? '#f2f2f2' : 'transparent',
                          color: expired ? '#b0b0b0' : 'black',
                          cursor: expired ? 'not-allowed' : 'default',
                        }}>
                          <FaRegBell /> {event.events}
                        </td>
                        <td>
                          <Button
                            variant="primary"
                            onClick={() => handleEventShowModal(event.id)}
                            disabled={expired} // Disable button if event is expired
                          >
                            Check here
                          </Button>
                        </td>
                        <td style={{
                          cursor: expired ? 'not-allowed' : 'pointer',
                          display: 'inline-block',
                        }}>
                          <Button
                            variant="primary"
                            onClick={() => handleSendReminderEvent(event.id,event.chapter)}
                            disabled={expired}
                            style={{
                              backgroundColor: expired ? '#f2f2f2' : 'transparent',
                              color: expired ? '#b0b0b0' : 'black',
                              cursor: expired ? 'not-allowed' : 'pointer', // optional for better UX
                            }}
                          >
                            Send Reminder
                          </Button>

                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>

              <div className="pagination">
                <Button
                  variant="secondary"
                  disabled={currentPageee === 1}
                  onClick={() => handlePageChangeee(currentPageee - 1)}
                >
                  Prev
                </Button>

                {[...Array(totalPagesss)].map((_, index) => (
                  <Button
                    key={index}
                    variant={currentPageee === index + 1 ? 'primary' : 'secondary'}
                    onClick={() => handlePageChangeee(index + 1)}
                  >
                    {index + 1}
                  </Button>
                ))}

                <Button
                  variant="secondary"
                  disabled={isLastPageWithLessThann10}
                  onClick={() => handlePageChangeee(currentPageee + 1)}
                >
                  Next
                </Button>
              </div>

              <Modal
                isOpen={showEventModal}
                onRequestClose={handleEventCloseModal}
                contentLabel="Meeting Details"
                style={{
                  chapter: {
                    width: '80%',
                    maxWidth: '900px',
                    margin: 'auto',
                    padding: '20px',
                    height: '80%',
                    overflow: 'auto',
                  },
                }}
              >
                <h2>Event Meeting Details</h2>

                {selectedEvent && selectedEvent.length > 0 ? ( // Check if selectedEvent exists and has data
                  <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th>Meeting ID</th>
                          <th>User</th>
                          <th>Date</th>
                          <th>Time</th>
                          <th>Venue</th>
                          <th>Event Response</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedEvent.map((meeting) => (
                          <tr key={meeting.id}>
                            <td>{meeting.events_id}</td>
                            <td>{meeting.user_email}</td>
                            <td>{new Date(meeting.date).toLocaleDateString()}</td>
                            <td>{meeting.time}</td>
                            <td>{meeting.venue}</td>
                            <td>
                              <span style={{ color: meeting.response === "yes" ? "green" : "red" }}>
                                {meeting.response === "yes" ? "Attending the Meeting" : "Not Attending the Meeting"}
                              </span>
                            </td>

                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p>Loading meeting details...</p>
                )}

                <button onClick={handleEventCloseModal} style={{ marginTop: '20px' }}>Close</button>
              </Modal>
            </Col>
          </Row>
        </div>
      )} */}
{activeSection === "Events" && (
  <div
    style={{
      minHeight: "100vh",
      background: "#f4f7fb",
      padding: "20px",
    }}
  >
    {/* HEADER */}
    <div
      style={{
        background: "linear-gradient(135deg,#7c3aed,#2563eb)",
        padding: "30px",
        borderRadius: "20px",
        color: "#fff",
        marginBottom: "25px",
        boxShadow: "0 10px 30px rgba(124,58,237,0.25)",
      }}
    >
      <h2
        style={{
          margin: 0,
          fontSize: "32px",
          fontWeight: "700",
        }}
      >
        Events Management
      </h2>

      <p
        style={{
          marginTop: "8px",
          opacity: 0.9,
          fontSize: "15px",
        }}
      >
        Manage events, attendance, visitors & reminders
      </p>

      <div
        style={{
          display: "flex",
          gap: "15px",
          flexWrap: "wrap",
          marginTop: "25px",
        }}
      >
        <button
          style={{
            border: "none",
            background: "#10b981",
            color: "#fff",
            padding: "12px 22px",
            borderRadius: "12px",
            fontWeight: "600",
            cursor: "pointer",
            boxShadow: "0 4px 12px rgba(16,185,129,0.3)",
          }}
          onClick={openModalll}
        >
          + Events
        </button>

        <button
          style={{
            border: "none",
            background: "#fff",
            color: "#2563eb",
            padding: "12px 22px",
            borderRadius: "12px",
            fontWeight: "600",
            cursor: "pointer",
          }}
          onClick={openModallEventAtt}
        >
          + Events Attendance List
        </button>
      </div>
    </div>

    {/* KEEPING YOUR MODALS EXACTLY SAME */}
    <Modal isOpen={modalIsOpennn} onRequestClose={closeModalll}>
      <h2>Events Details</h2>
      <Form>

        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Chapter:</label>
          <select
            value={selectedChapter}
            onChange={(e) => setSelectedChapter(e.target.value)}
            style={{
              width: '30%',
              padding: '10px',
              borderRadius: '5px',
              border: '1px solid #ccc',
              fontSize: '16px',
              outline: 'none',
              boxSizing: 'border-box',
              backgroundColor: '#f9f9f9'
            }}
          >
            <option value="">Select a chapter</option>
            {chapters.map((chapter) => (
              <option key={chapter.chapter} value={chapter.chapter}>
                {chapter.chapter}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label>Date:</label>
          <DatePicker
            selected={date}
            onChange={(date) => setDate(date)}
            dateFormat="MM/dd/yyyy"
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
          />
        </div>

        <div>
          <label>Time:</label>
          <input
            type="time"
            value={time}
            onChange={(e) => setTime(e.target.value)}
          />
        </div>

        <div>
          <label>Venue:</label>
          <input
            type="text"
            value={venue}
            onChange={(e) => setVenue(e.target.value)}
          />
        </div>

        <div>
          <label>Events:</label>
          <input
            type="text"
            value={events}
            onChange={(e) => setEvent(e.target.value)}
          />
        </div>

        <div>
          <label>Image:</label>
          <input
            type="file"
            accept="image/*"
            onChange={onImageChange}
          />
        </div>

        <div>
          <button type="button " className='m-3' onClick={handleSubmitEvent}>Submit</button>
          <button type="button" className='m-3' onClick={closeModalll}>Cancel</button>
        </div>
      </Form>
    </Modal>

 <Modal isOpen={modalIsOpenEvent} onRequestClose={closeModallEventAtt}>
            <h2>Event Attendance List</h2>
            <button type="button" className='m-3' onClick={closeModallEventAtt}>Close</button>





            <>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ marginRight: '10px' }}>
                  <label htmlFor="dateDropdown">Select Date:</label>
                  <select
                    id="dateDropdown"
                    value={selectedEventDate}
                    onChange={handleDateEventChange}
                    style={{
                      width: '150px',
                      padding: '8px',
                      borderRadius: '8px',
                      fontSize: '14px',
                      overflowY: 'auto',
                      maxHeight: '200px',

                    }}
                  >
                    <option value="">Select Event date</option>
                    {uniqueEventDates.map((date) => (
                      <option key={date} value={date}>
                        {new Date(date).toLocaleDateString()}
                      </option>
                    ))}
                  </select>
                </div>

                {selectedEventDate && (
                  <div>
                    <label htmlFor="venueDropdown">Select Venue:</label>
                    <select
                      id="venueDropdown"
                      value={selectedEventVenue}
                      onChange={handleEventVenueChange}
                      style={{
                        width: '150px',
                        padding: '8px',
                        borderRadius: '8px',
                        fontSize: '14px',
                      }}
                    >
                      <option value="">Select a venue</option>
                      {venuesEventForSelectedDate.map((venue, index) => (
                        <option key={index} value={venue}>
                          {venue}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                {selectedEventVenue && (
                  <div>
                    <label htmlFor="venueDropdown">Select Event:</label>
                    <select
                      id="venueDropdown"
                      value={selectedEvents}
                      onChange={handleEventChange}
                      style={{
                        width: '150px',
                        padding: '8px',
                        borderRadius: '8px',
                        fontSize: '14px',
                      }}
                    >
                      <option value="">Select a evnte </option>
                      {EventForSelectedDate.map((venue, index) => (
                        <option key={index} value={venue}>
                          {venue}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
              </div>


              {selectedEvents && selectedEventDetails.length > 0 && (
                <div>
                  <h3>Event Details (Response Given Members):</h3>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr>
                        <th style={{ border: '1px solid black', padding: '10px' }}>USERID</th>

                        <th style={{ border: '1px solid black', padding: '10px' }}>User Email</th>

                        <th style={{ border: '1px solid black', padding: '10px' }}>Response</th>
                        <th style={{ border: '1px solid black', padding: '10px' }}>  Action</th>

                      </tr>
                    </thead>
                    <tbody>
                    

                      {currentUsers13Event.map((event, index) => {
                        const user = users.find(user => user.id === event.user_id);
                        const meetingDateTime = new Date(`${event.date}T${event.time}:00`);
                        const isMeetingExpired = meetingDateTime.getTime() + 24 * 60 * 60 * 1000 < Date.now();

                        let responseText = event.response === 'yes' ? 'Attending' : 'Not Attending';

                        // If meeting is expired, update response to Present or Absent
                        if (isMeetingExpired) {
                          responseText = event.response === 'yes' ? 'Present' : 'Absent';
                        }


                        return (
                          <tr key={index}>
                            <td style={{ border: '1px solid black', padding: '8px' }}>{user ? user.name : 'Unknown'}</td>
                            <td style={{ border: '1px solid black', padding: '8px' }}>{event.user_email}</td>

                            {/* <td style={{ border: '1px solid black', padding: '8px', color: event.response === 'yes' ? 'green' : 'red' }}>
                              {event.response === 'yes' ? 'Attending' : 'Not Attending'}
                            </td> */}
                            {/* <td style={{ border: '1px solid black', padding: '8px' }}>
                              {/* Yes Checkbox 
                              <label>
                                <input
                                  type="checkbox"
                                  checked={eventResponses[event.user_id] === 'yes'}
                                  onChange={() => handleEventResponseChange(event.user_id, 'yes')}
                                />
                                Yes
                              </label>

                      
                              <label>
                                <input
                                  type="checkbox"
                                  checked={eventResponses[event.user_id] === 'no'}
                                  onChange={() => handleEventResponseChange(event.user_id, 'no')}
                                />
                                No
                              </label>
                            </td> */}
                              <td style={{ border: '1px solid black', padding: '8px', color: event.response === 'yes' ? 'green' : 'red' }}>
                              {event.response === 'yes' ? 'Attending' : 'Not Attending'}
                             
                            </td>


                            <td style={{ border: '1px solid black', padding: '8px' }}>
                              {event.admin_response ? (
                                <span style={{ color: event.admin_response === 'yes' ? 'green' : 'red', fontWeight: 'bold' }}>
                                  {event.admin_response === 'yes' ? '✔ Attended' : '✘ Not Attended'}
                                </span>
                              ) : (
                                <>
                                  <label>
                                    <input
                                      type="checkbox"
                                      checked={eventResponses[event.user_id] === 'yes'}
                                      onChange={() => handleEventResponseChange(event.user_id, 'yes')}
                                      disabled={isMeetingExpired}
                                    />
                                    Yes
                                  </label>
                                  <label>
                                    <input
                                      type="checkbox"
                                      checked={eventResponses[event.user_id] === 'no'}
                                      onChange={() => handleEventResponseChange(event.user_id, 'no')}
                                      disabled={isMeetingExpired}
                                    />
                                    No
                                  </label>
                                </>
                              )}
                            </td>


                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                     <div className="paginationn">
                    <button
                      onClick={handlePrevPage13Event}
                      className="page-buttonn"
                      disabled={currentPage13Event === 1}  // Disable the Previous button if on the first page
                    >
                      Previous
                    </button>



                    <span className="current-page">
                      Page {currentPage13Event} of {totalPages13Event}
                    </span>

                    <button
                      onClick={handleNextPage13Event}
                      className="page-buttonn"
                      disabled={currentPage13Event === totalPages13Event}  // Disable the Next button if on the last page
                    >
                      Next
                    </button>
                  </div>
                  <button onClick={handleUpdateEventResponse}>Submit</button>
                </div>
              )}





               {selectedEvents && selectedEventDetails.length > 0 && (
                <div>
                  <h3>Event Details (Response not given Members)</h3>
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr>
                        <th style={{ border: '1px solid black', padding: '10px' }}>USERID</th>

                        <th style={{ border: '1px solid black', padding: '10px' }}>User Email</th>

                         <th style={{ border: '1px solid black', padding: '10px' }}>  Action</th>

                      </tr>
                    </thead>
                    <tbody> 
                       {currentUsers1Event
                        .map((event, index) => {

                          console.log('this is the currentUsers', currentUsers)
                          // console.log('this is ths users', users)
                          const user = users.find((user) => user.id === event.user_id);

                          //const isMeetingExpired = new Date(meeting.date) < new Date(); // Check if meeting is expired
                          const meetingDateTime = new Date(`${event.date}T${event.time}:00`);
                          console.log('this is the meetingDateTime', meetingDateTime)
                          const isMeetingExpired = meetingDateTime.getTime() + 24 * 60 * 60 * 1000 < Date.now();

                          let responseText = event.response === 'yes' ? 'Attending' : 'Not Attending';

                          // If meeting is expired, update response to Present or Absent
                          if (isMeetingExpired) {
                            responseText = event.response === 'yes' ? 'Present' : 'Absent';
                          }


                          return (
                            <tr key={index}>
                              <td style={{ border: '1px solid black', padding: '8px' }}>{event.name}</td>
                              <td style={{ border: '1px solid black', padding: '8px' }}>{event.email}</td>
                              <td style={{ border: '1px solid black', padding: '8px' }}>
                                {event.admin_response ? (
                                  <span style={{ color: event.admin_response === 'yes' ? 'green' : 'red', fontWeight: 'bold' }}>
                                    {event.admin_response === 'yes' ? '✔ Attended' : '✘ Not Attended'}
                                  </span>
                                ) : (
                                  <>
                                    <label>
                                      <input
                                        type="checkbox"
                                        checked={eventResponses[event.id] === 'yes'}
                                        onClick={() => handleAdminEventResponseClick(event.id, "yes")}
                                      // onChange={() => handleAdminResponseChange(meeting.id, 'yes')}
                                      // disabled={isMeetingExpired}
                                      />
                                      Yes
                                    </label>
                                    <label>
                                      <input
                                        type="checkbox"
                                        checked={eventResponses[event.id] === 'no'}
                                        // onChange={() => handleAdminResponseChange(meeting.id, 'no')}
                                        onClick={() => handleAdminEventResponseClick(event.id, "no")}
                                      // disabled={isMeetingExpired}
                                      />
                                      No
                                    </label>
                                  </>
                                )}
                              </td>


                            </tr>
                          );
                        })}

                    </tbody>
                  </table>
                  <div className="paginationn">
                    <button
                      onClick={handlePrevPage11Event}
                      className="page-buttonn"
                      disabled={currentPage11Event === 1}  // Disable the Previous button if on the first page
                    >
                      Previous
                    </button>



                    <span className="current-page">
                      Page {currentPage11Event} of {totalPages11Event}
                    </span>

                    <button
                      onClick={handleNextPage11Event}
                      className="page-buttonn"
                      disabled={currentPage11Event === totalPages11Event}  // Disable the Next button if on the last page
                    >
                      Next
                    </button>
                  </div>
                  <button onClick={handleAdminResponseSubmitEvent}>Submit Admin Responseh</button>
                </div>
              )}




                  {selectedEvents && selectedEventDetails.length > 0 && (
                <>

                  <div style={{ marginTop: '30px' }}>
                    <h3>Event Visitor Invitations:</h3>

                    {/* <div style={{ marginTop: '20px', marginBottom: '10px' }}>
                    <input
                      type="text"
                      placeholder="Search by Sender, Name, Email, Mobile"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      style={{ padding: '8px', width: '300px', borderRadius: '4px', border: '1px solid gray' }}
                    />
                  </div> */}
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      border: '1px solid #ccc',
                      borderRadius: '8px',
                      padding: '8px 12px',
                      maxWidth: '320px',
                      marginBottom: '20px',
                      backgroundColor: '#fff',
                      boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                    }}>
                      <FiSearch size={20} color="#666" style={{ marginRight: '8px' }} />
                      <input
                        type="text"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        placeholder="Search by Name, Email, Mobile..."
                        style={{
                          border: 'none',
                          outline: 'none',
                          fontSize: '16px',
                          width: '100%',
                          backgroundColor: 'transparent',
                          color: '#333'
                        }}
                      />
                    </div>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th style={{ border: '1px solid black', padding: '10px' }}>Visitor Invite Sender </th>
                          <th style={{ border: '1px solid black', padding: '10px' }}>Visitor Name</th>
                          <th style={{ border: '1px solid black', padding: '10px' }}>Email</th>
                          <th style={{ border: '1px solid black', padding: '10px' }}>Mobile</th>
                          <th style={{ border: '1px solid black', padding: '10px' }}>Response</th>
                          <th style={{ border: '1px solid black', padding: '10px' }}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentUsers12Event
                          // .filter(invite => invite.meeting_id === selectedMeetingDetails[0]?.meeting_id)
                          .map((invite, index) => (

                            <tr key={index}>
                              <td style={{ border: '1px solid black', padding: '8px' }}>{getUserNameById(invite.userId)}</td>

                              <td style={{ border: '1px solid black', padding: '8px' }}>{invite.visitor_name}</td>
                              <td style={{ border: '1px solid black', padding: '8px' }}>{invite.visitor_email}</td>
                              <td style={{ border: '1px solid black', padding: '8px' }}>{invite.visitor_mobile}</td>
                              <td style={{ border: '1px solid black', padding: '8px', color: invite.response === 'yes' ? 'green' : invite.response === 'no' ? 'red' : 'gray' }}>
                                {invite.response ? (invite.response === 'yes' ? 'Attending' : 'Not Attending') : 'Pending'}
                              </td>
                              <td style={{ border: '1px solid black', padding: '8px' }}>
                                <label>
                                  <input
                                    type="checkbox"
                                    checked={visitorEventResponses[invite.id] === 'yes'}
                                    onChange={() => handleVisitorResponseChangeEvent(invite.id, 'yes')}
                                    // disabled={invite.response === 'yes' || invite.response === 'no' || responsesSubmitted}
                                    disabled={invite.response === 'yes' || invite.response === 'no'}

                                  />
                                  Yes
                                </label>
                                <label>
                                  <input
                                    type="checkbox"
                                    checked={visitorEventResponses[invite.id] === 'no'}
                                    onChange={() => handleVisitorResponseChangeEvent(invite.id, 'no')}
                                    // disabled={invite.response === 'yes' || invite.response === 'no' || responsesSubmitted}
                                    disabled={invite.response === 'yes' || invite.response === 'no'}

                                  />
                                  No
                                </label>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                    <div className="paginationn">
                      <button
                        onClick={handlePrevPage12Event}
                        className="page-buttonn"
                        disabled={currentPage12Event === 1}  // Disable the Previous button if on the first page
                      >
                        Previous
                      </button>



                      <span className="current-page">
                        Page {currentPage12Event}
                       
                      </span>

                      <button
                        onClick={handleNextPage12Event}
                        className="page-buttonn"
                        disabled={currentPage12Event === totalPages12Event}  // Disable the Next button if on the last page
                      >
                        Next
                      </button>
                    </div>
                    <button onClick={handleUpdateVisitorEventResponses} >Submit Visitor Event Responses</button>
                  </div>
                </>
              )}

            </>

          </Modal>


    {/* EVENTS TABLE CARD */}
    <div
      style={{
        background: "#fff",
        borderRadius: "20px",
        overflow: "hidden",
        boxShadow: "0 8px 25px rgba(0,0,0,0.06)",
      }}
    >
      {/* TOP BAR */}
      <div
        style={{
          padding: "20px",
          borderBottom: "1px solid #e2e8f0",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "15px",
        }}
      >
        <h3
          style={{
            margin: 0,
            fontWeight: "700",
            color: "#1e293b",
          }}
        >
          Events List
        </h3>

        <div style={{ width: "300px" }}>
          <InputGroup>
            <FormControl
              placeholder="Search by Date or Venue"
              onChange={handleSearch}
              style={{
                borderRadius: "12px",
                padding: "12px",
                border: "1px solid #cbd5e1",
              }}
            />
          </InputGroup>
        </div>
      </div>

      {/* TABLE */}
      <div style={{ overflowX: "auto" }}>
        <Table
          striped
          bordered
          hover
          style={{
            marginBottom: 0,
            minWidth: "1000px",
          }}
        >
          <thead
            style={{
              background: "#eff6ff",
            }}
          >
            <tr>
              <th>User</th>
              <th>Date</th>
              <th>Time</th>
              <th>Venue</th>
              <th>Event</th>
              <th>Action</th>
              <th>Reminder</th>
            </tr>
          </thead>

          <tbody>
            {currentMeetingss.map((event, index) => {
              const expired = isExpired(event.date, event.time);

              return (
                <tr key={index}>
                  <td>
                    <FaUserCircle
                      className="user-icon"
                      style={{
                        fontSize: "24px",
                        color: "#7c3aed",
                      }}
                    />
                  </td>

                  <td
                    style={{
                      backgroundColor: expired ? "#f8fafc" : "transparent",
                      color: expired ? "#94a3b8" : "#111827",
                    }}
                  >
                    {new Date(event.date).toLocaleDateString()}
                  </td>

                  <td
                    style={{
                      backgroundColor: expired ? "#f8fafc" : "transparent",
                      color: expired ? "#94a3b8" : "#111827",
                    }}
                  >
                    {event.time}
                  </td>

                  <td
                    style={{
                      backgroundColor: expired ? "#f8fafc" : "transparent",
                      color: expired ? "#94a3b8" : "#111827",
                    }}
                  >
                    {event.venue}
                  </td>

                  <td
                    style={{
                      backgroundColor: expired ? "#f8fafc" : "transparent",
                      color: expired ? "#94a3b8" : "#111827",
                    }}
                  >
                    {event.events}
                  </td>

                  <td>
                    <Button
                      variant="primary"
                      onClick={() => handleEventShowModal(event.id)}
                      disabled={expired}
                      style={{
                        borderRadius: "10px",
                        fontWeight: "600",
                        opacity: expired ? 0.5 : 1,
                      }}
                    >
                      Check Here
                    </Button>
                  </td>

                  <td>
                    <Button
                      variant="primary"
                      onClick={() =>
                        handleSendReminderEvent(
                          event.id,
                          event.chapter
                        )
                      }
                      disabled={expired}
                      style={{
                        borderRadius: "10px",
                        fontWeight: "600",
                        opacity: expired ? 0.5 : 1,
                      }}
                    >
                      Send Reminder
                    </Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>

      {/* PAGINATION */}
      <div
        style={{
          padding: "20px",
          display: "flex",
          justifyContent: "center",
          gap: "10px",
          flexWrap: "wrap",
        }}
      >
        <Button
          variant="secondary"
          disabled={currentPageee === 1}
          onClick={() => handlePageChangeee(currentPageee - 1)}
        >
          Prev
        </Button>

        {[...Array(totalPagesss)].map((_, index) => (
          <Button
            key={index}
            variant={
              currentPageee === index + 1
                ? "primary"
                : "secondary"
            }
            onClick={() =>
              handlePageChangeee(index + 1)
            }
          >
            {index + 1}
          </Button>
        ))}

        <Button
          variant="secondary"
          disabled={isLastPageWithLessThann10}
          onClick={() =>
            handlePageChangeee(currentPageee + 1)
          }
        >
          Next
        </Button>
      </div>
    </div>

    {/* KEEPING YOUR EVENT DETAILS MODAL SAME */}
    <Modal
      isOpen={showEventModal}
      onRequestClose={handleEventCloseModal}
      contentLabel="Meeting Details"
      style={{
        chapter: {
          width: '80%',
          maxWidth: '900px',
          margin: 'auto',
          padding: '20px',
          height: '80%',
          overflow: 'auto',
        },
      }}
    >
      <h2>Event Meeting Details</h2>

      {selectedEvent && selectedEvent.length > 0 ? (
        <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th>Meeting ID</th>
                <th>User</th>
                <th>Date</th>
                <th>Time</th>
                <th>Venue</th>
                <th>Event Response</th>
              </tr>
            </thead>

            <tbody>
              {selectedEvent.map((meeting) => (
                <tr key={meeting.id}>
                  <td>{meeting.events_id}</td>
                  <td>{meeting.user_email}</td>
                  <td>{new Date(meeting.date).toLocaleDateString()}</td>
                  <td>{meeting.time}</td>
                  <td>{meeting.venue}</td>

                  <td>
                    <span style={{ color: meeting.response === "yes" ? "green" : "red" }}>
                      {meeting.response === "yes"
                        ? "Attending the Meeting"
                        : "Not Attending the Meeting"}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p>Loading meeting details...</p>
      )}

      <button
        onClick={handleEventCloseModal}
        style={{ marginTop: '20px' }}
      >
        Close
      </button>
    </Modal>
  </div>
)}


      {activeSection === "Images" && (
        <>
          <div style={{ display: 'flex', justifyContent: 'center', padding: '40px', background: '#f7f7f7', alignItems: 'center' }}>
            <div className="row" style={{ gap: '20px', display: 'flex', justifyContent: 'center' }}>
              <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                <div style={{ background: 'white', borderRadius: '12px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', padding: '30px', textAlign: 'center', transition: '0.3s ease' }}>
                  <h3 style={{ marginBottom: '20px', fontSize: '1.5rem', fontWeight: 'bold' }}>Main Image</h3>
                  <input type="file" accept="image/*" onChange={(e) => handleImageChange(e, 'main_add_1')} id="header-image" />
                  <div style={{ marginTop: '20px', border: '2px dashed #ccc', padding: '20px', borderRadius: '10px', minHeight: '150px', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#fafafa', color: '#aaa', textAlign: 'center' }}> <img src={image?.main_add_1} alt="Main Image 1" style={{ width: '100%' }} /></div>
                  {/* <button className='btn-sm btn mt-1 btn-danger me-2' onClick={() => handleDeleteImage(image.id, { main_add_1: selectedFile })}>Delete</button> */}
                </div>
              </div>
              <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                <div style={{ background: 'white', borderRadius: '12px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', padding: '30px', textAlign: 'center', transition: '0.3s ease' }}>
                  <h3 style={{ marginBottom: '20px', fontSize: '1.5rem', fontWeight: 'bold' }}>Main Image</h3>
                  <input type="file" accept="image/*" onChange={(e) => handleImageChange(e, 'main_add_2')} id="header-image" />
                  <div style={{ marginTop: '20px', border: '2px dashed #ccc', padding: '20px', borderRadius: '10px', minHeight: '150px', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#fafafa', color: '#aaa', textAlign: 'center' }}> <img src={image?.main_add_2} alt="Main Image 2" style={{ width: '100%' }} /></div>
                  {/* <button className='btn-sm btn mt-1 btn-danger me-2' onClick={() => handleDeleteImage(image.id, { main_add_2: selectedFile })}>Delete</button> */}
                </div>
              </div>
              <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                <div style={{ background: 'white', borderRadius: '12px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', padding: '30px', textAlign: 'center', transition: '0.3s ease' }}>
                  <h3 style={{ marginBottom: '20px', fontSize: '1.5rem', fontWeight: 'bold' }}>Main Image</h3>
                  <input type="file" accept="image/*" onChange={(e) => handleImageChange(e, 'main_add_3')} id="header-image" />
                  <div style={{ marginTop: '20px', border: '2px dashed #ccc', padding: '20px', borderRadius: '10px', minHeight: '150px', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#fafafa', color: '#aaa', textAlign: 'center' }}> <img src={image?.main_add_3} alt="Main Image 3" style={{ width: '100%' }} /></div>
                  {/* <button className='btn-sm btn mt-1 btn-danger me-2' onClick={() => handleDeleteImage(image.id, { main_add_3: selectedFile })}>Delete</button> */}
                </div>
              </div>
              <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                <div style={{ background: 'white', borderRadius: '12px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', padding: '30px', textAlign: 'center', transition: '0.3s ease' }}>
                  <h3 style={{ marginBottom: '20px', fontSize: '1.5rem', fontWeight: 'bold' }}>Side Image</h3>
                  <input type="file" accept="image/*" onChange={(e) => handleImageChange(e, 'side_add_1')} id="ad-image" />
                  <div style={{ marginTop: '20px', border: '2px dashed #ccc', padding: '20px', borderRadius: '10px', minHeight: '150px', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#fafafa', color: '#aaa', textAlign: 'center' }}> <img src={image?.side_add_1} alt="Side Image 1" style={{ width: '100%' }} /></div>
                  {/* <button className='btn-sm btn mt-1 btn-danger me-2' onClick={() => handleDeleteImage(image.id, { side_add_1: selectedFile })}>Delete</button> */}
                </div>
              </div>
              <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                <div style={{ background: 'white', borderRadius: '12px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', padding: '30px', textAlign: 'center', transition: '0.3s ease' }}>
                  <h3 style={{ marginBottom: '20px', fontSize: '1.5rem', fontWeight: 'bold' }}>Side Image</h3>
                  <input type="file" accept="image/*" onChange={(e) => handleImageChange(e, 'side_add_2')} id="ad-image" />
                  <div style={{ marginTop: '20px', border: '2px dashed #ccc', padding: '20px', borderRadius: '10px', minHeight: '150px', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#fafafa', color: '#aaa', textAlign: 'center' }}><img src={image?.side_add_2} alt="Side Image 2" style={{ width: '100%' }} /></div>
                  {/* <button className='btn-sm btn mt-1 btn-danger me-2' onClick={() => handleDeleteImage(image.id, { side_add_2: selectedFile })}>Delete</button> */}
                </div>
              </div>
              <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                <div style={{ background: 'white', borderRadius: '12px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', padding: '30px', textAlign: 'center', transition: '0.3s ease' }}>
                  <h3 style={{ marginBottom: '20px', fontSize: '1.5rem', fontWeight: 'bold' }}>Side Image</h3>
                  <input type="file" accept="image/*" onChange={(e) => handleImageChange(e, 'side_add_3')} id="ad-image" />
                  <div style={{ marginTop: '20px', border: '2px dashed #ccc', padding: '20px', borderRadius: '10px', minHeight: '150px', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#fafafa', color: '#aaa', textAlign: 'center' }}><img src={image?.side_add_3} alt="Side Image 3" style={{ width: '100%' }} /></div>
                  {/* <button className='btn-sm btn mt-1 btn-danger me-2' onClick={() => handleDeleteImage(image.id, { side_add_3: selectedFile })}>Delete</button> */}
                </div>
              </div>
              <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                <div style={{ background: 'white', borderRadius: '12px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', padding: '30px', textAlign: 'center', transition: '0.3s ease' }}>
                  <h3 style={{ marginBottom: '20px', fontSize: '1.5rem', fontWeight: 'bold' }}>Side Image</h3>
                  <input type="file" accept="image/*" onChange={(e) => handleImageChange(e, 'side_add_4')} id="ad-image" />
                  <div style={{ marginTop: '20px', border: '2px dashed #ccc', padding: '20px', borderRadius: '10px', minHeight: '150px', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#fafafa', color: '#aaa', textAlign: 'center' }}> <img src={image?.side_add_4} alt="Side Image 4" style={{ width: '100%' }} /></div>
                  {/* <button className='btn-sm btn mt-1 btn-danger me-2' onClick={() => handleDeleteImage(image.id, { side_add_4: selectedFile })}>Delete</button> */}
                </div>
              </div>
              <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                <div style={{ background: 'white', borderRadius: '12px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', padding: '30px', textAlign: 'center', transition: '0.3s ease' }}>
                  <h3 style={{ marginBottom: '20px', fontSize: '1.5rem', fontWeight: 'bold' }}>Side Image</h3>
                  <input type="file" accept="image/*" onChange={(e) => handleImageChange(e, 'side_add_5')} id="ad-image" />
                  <div style={{ marginTop: '20px', border: '2px dashed #ccc', padding: '20px', borderRadius: '10px', minHeight: '150px', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#fafafa', color: '#aaa', textAlign: 'center' }}> <img src={image?.side_add_5} alt="Side Image 4" style={{ width: '100%' }} /></div>
                  {/* <button className='btn-sm btn mt-1 btn-danger me-2' onClick={() => handleDeleteImage(image.id, { side_add_5: selectedFile })}>Delete</button> */}
                </div>
              </div>
              <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                <div style={{ background: 'white', borderRadius: '12px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', padding: '30px', textAlign: 'center', transition: '0.3s ease' }}>
                  <h3 style={{ marginBottom: '20px', fontSize: '1.5rem', fontWeight: 'bold' }}>Side Image</h3>
                  <input type="file" accept="image/*" onChange={(e) => handleImageChange(e, 'side_add_6')} id="ad-image" />
                  <div style={{ marginTop: '20px', border: '2px dashed #ccc', padding: '20px', borderRadius: '10px', minHeight: '150px', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#fafafa', color: '#aaa', textAlign: 'center' }}> <img src={image?.side_add_6} alt="Side Image 4" style={{ width: '100%' }} /></div>
                  {/* <button className='btn-sm btn mt-1 btn-danger me-2' onClick={() => handleDeleteImage(image.id, { side_add_6: selectedFile })}>Delete</button> */}
                </div>
              </div>
            </div>
          </div>
          <button className="container d-flex justify-chapter-center align-items-center btn btn-primary mt-2 mb-4 w-25" onClick={handleSubmitimage}>🚀 Upload All Images</button>
        </>
      )}


      {modalOpen && (
        <div className="modal">
          <div className="modal-chapter">
            <button onClick={closeModal} className='modal-close-btn'>Close</button>
            <div className="containerdashboard">
              <h1 className="section-title">Lions Business Network- Multiple District 320</h1>
              <div className="cardd-row">
                <div className="cardd">
                  <div className="cardd-chapter">
                    <p className="cardd-header">Basic Information</p>
                    <div className="profile-img">
                      <img
                        alt={`Profile picture of ${userss.name}`}
                        height="100"
                        src={userss.logo}
                        width="100"
                        style={{
                          borderRadius: "50%", // Make the image circular
                          border: "2px solid #007bff", // Add border color
                          objectFit: "cover", // Ensures the image fills the circle without distortion
                        }}
                      />
                    </div>
                    <div className="info-item">
                      <FaIdBadge />
                      <span>Membership No:</span> <span className="value">{userss.membershipNo}</span>
                    </div>
                    <div className="info-item">
                      <FaUser />
                      <span>Name:</span> <span className="value">{userss.name}</span>
                    </div>
                    <div className="info-item">
                      <FaPhone />
                      <span>Mobile:</span> <span className="value">{userss.mobile}</span>
                    </div>
                    <div className="info-item">
                      <FaEnvelope />
                      <span>Email:</span> <span className="value">{userss.email}</span>
                    </div>
                    <div className="social-icons">
                      <a href="#">
                        <FaInstagram />
                      </a>
                      <a href="#">
                        <FaTwitter />
                      </a>
                      <a href="#">
                        <FaFacebook />
                      </a>
                    </div>
                  </div>
                </div>
                {/*  <div className="cardd lions-card">
                  <div className="cardd-chapter lions-info">
                    <h4 className="cardd-header">Lions Information</h4>
                    <img
                      alt="Lions Club logo"
                      height="50"
                      src="https://storage.googleapis.com/a1aa/image/YwjE65g8qNJhNJQMAd051OqriYttZzb6ZPeytedxMaknar7TA.jpg"
                      width="50"
                    />
                    <p>
                      You are not a lions member so you have not added lion data.
                    </p>
                    <button className="add-button">
                      <FaPlus />
                      ADD
                    </button>
                  </div>
                </div>
                */}

                <div className="cardd">
                  <div className="cardd-chapter">
                    <p className="cardd-header">Business Information</p>
                    <div className="info-item">
                      <FaBuilding />
                      <span>Name Of Company:</span> <span className="value">{userss.name_of_company}</span>
                    </div>
                    <div className="info-item">
                      <FaBriefcase />
                      <span>Designation:</span> <span className="value">{userss.designation}</span>
                    </div>
                    <div className="info-item">
                      <FaGlobe />
                      <span>Website:</span>
                      <a href={userss.website} target="_blank" rel="noopener noreferrer">
                        {userss.website}
                      </a>
                    </div>
                    <div className="info-item">
                      <FaEnvelope />
                      <span>Email Id:</span> <span className="value">{userss.official_email_id}</span>
                    </div>
                    <div className="info-item">
                      <FaBox />
                      <span>Product:</span> <span className="value">{userss.product}</span>
                    </div>
                    <div className="info-item">
                      <FaIndustry />
                      <span> Business/Profession:</span> <span className="value">{userss.businessProfession}</span>
                    </div>
                    <div className="info-item">
                      <FaIndustry />
                      <span>Business Vertical:</span> <span className="value">{userss.businessVerticalData}</span>
                    </div>
                  </div>
                </div>

              </div>


              {/* <div className="products-section">
                <h2 className="section-title">All Products</h2>

                <div className="products">
                  {products.map((product) => (
                    <div className="product-card" key={product.id}>
                      <div className="product-image-container">
                        <img
                          src={product.productPhoto}
                          alt={product.productName}
                          className="product-image"
                          height="400"
                          width="300"
                        />
                        <div className="overlay">
                          <div className="overlay-chapter">
                            <h3>{product.productName}</h3>
                            <p>{product.productDesc}</p>
                            <p>Price: {product.productPrice}</p>
                            <p>Offer: {product.offer || 'Not Given'}</p>
                            <p>Validity: {product.validity || 'Not Given'}</p>
                          </div>
                        </div>
                        {product.isApprove !== '1' && <button className="edit-btn" onClick={() => handleApproveProduct({ productId: product.id })}>Approve</button>}
                        <button className="delete-btn">Delete</button>
                      </div>
                    </div>
                  ))}
                </div>

              </div> */}

            </div>
          </div>


        </div>
      )}


{
  activeSection === "referral-out" && (
    <>
      {/* HEADER */}
      <div
        style={{
          minHeight: "100vh",
          background: "#f4f7fb",
          padding: "20px",
        }}
      >
        <div
          style={{
            background: "linear-gradient(135deg,#0f172a,#2563eb)",
            padding: "30px",
            borderRadius: "20px",
            color: "#fff",
            marginBottom: "25px",
            boxShadow: "0 10px 30px rgba(37,99,235,0.2)",
          }}
        >
          <h2
            style={{
              margin: 0,
              fontSize: "32px",
              fontWeight: "700",
            }}
          >
            Referral Out Reports
          </h2>

          <p
            style={{
              marginTop: "8px",
              opacity: 0.9,
              fontSize: "15px",
            }}
          >
            Manage referral sender and received reports
          </p>

          <div
            style={{
              display: "flex",
              gap: "15px",
              flexWrap: "wrap",
              marginTop: "25px",
            }}
          >
            <button
              onClick={() => setShowReferralModal1(true)}
              style={{
                border: "none",
                background: "#10b981",
                color: "#fff",
                padding: "12px 22px",
                borderRadius: "12px",
                fontWeight: "600",
                cursor: "pointer",
                boxShadow: "0 4px 12px rgba(16,185,129,0.3)",
              }}
            >
              Highest Referrals
            </button>
          </div>
        </div>

        {/* KEEPING YOUR MODAL SAME */}
        <Modal
          isOpen={showReferralModal1}
          onRequestClose={() => setShowReferralModal1(false)}
          contentLabel="Referral Date Filter"
          style={{
            chapter: {
              top: "50%",
              left: "50%",
              right: "auto",
              bottom: "auto",
              marginRight: "-50%",
              transform: "translate(-50%, -50%)",
              width: "600px",
              maxHeight: "80vh",
              overflowY: "auto",
              padding: "20px",
              borderRadius: "12px",
            },
            overlay: {
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            },
          }}
        >
          <div className='text-end'>
            <button
              onClick={() => {
                setReferralFromDate('');
                setReferralToDate('');
                setReferralStats([]);
                setShowReferralModal1(false)
              }}
              className="px-4 py-2 border rounded"
            >
              Close
            </button>
          </div>

          <h2 className="text-lg font-bold mb-4">Select Date Range</h2>

          <div className="flex flex-col gap-3">
            <label>
              From Date:
              <input
                type="date"
                className="border rounded p-2 w-full"
                value={referralFromDate}
                onChange={(e) => setReferralFromDate(e.target.value)}
              />
            </label>

            <label>
              To Date:
              <input
                type="date"
                className="border rounded p-2 w-full"
                value={referralToDate}
                onChange={(e) => setReferralToDate(e.target.value)}
              />
            </label>
          </div>

          <div className="flex justify-end gap-3 mt-4">
            <button
              onClick={handleCheckHighestReferral}
              className="bg-green-600 text-white px-4 py-2 rounded"
            >
              Check
            </button>
          </div>

          <div className="mt-4 text-right">
            <PDFDownloadLink
              document={
                <ReferralStatsPDF
                  fromDate={referralFromDate}
                  toDate={referralToDate}
                  data={referralStats}
                />
              }
              fileName={`referral-stats-${referralFromDate}-to-${referralToDate}.pdf`}
              className="inline-block px-4 py-2 bg-blue-600 text-black rounded hover:bg-blue-700 text-sm"
            >
              {({ loading }) => (loading ? 'Preparing PDF...' : 'Download PDF')}
            </PDFDownloadLink>
          </div>

          {referralStats.length > 0 && (
            <div className="mt-6 bg-blue-50 p-4 rounded shadow-md">
              <h5 className="text-lg font-semibold mb-3">
                Highest Referral (From: {referralFromDate} To: {referralToDate})
              </h5>

              <table className="min-w-full text-sm border border-gray-300">
                <thead className="bg-gray-200">
                  <tr>
                    <th className="border p-2">#</th>
                    <th className="border p-2">Referral Email</th>
                    <th className="border p-2">Count</th>
                  </tr>
                </thead>

                <tbody>
                  {referralStats.map((item, index) => (
                    <tr key={item.email} className="hover:bg-gray-50">
                      <td className="border p-2 text-center">{index + 1}</td>
                      <td className="border p-2">{item.email}</td>
                      <td className="border p-2 text-center">{item.count}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Modal>

        {/* TABLE CARD */}
        <div
          style={{
            background: "#fff",
            borderRadius: "20px",
            overflow: "hidden",
            boxShadow: "0 8px 25px rgba(0,0,0,0.06)",
          }}
        >
          <div
            style={{
              padding: "20px",
              borderBottom: "1px solid #e2e8f0",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "15px",
            }}
          >
            <h3
              style={{
                margin: 0,
                fontWeight: "700",
                color: "#1e293b",
              }}
            >
              Referral Sender & Recived Report
            </h3>
          </div>

          <div style={{ overflowX: "auto" }}>
            <table
              className="min-w-full text-sm"
              style={{
                minWidth: "1100px",
              }}
            >
              <thead
                style={{
                  background: "#eff6ff",
                }}
              >
                <tr>
                  <th className="border p-3">Product</th>
                  <th className="border p-3">Product Name</th>
                  <th className="border p-3">Price</th>
                  <th className="border p-3">Referral Sender Email</th>
                  <th className="border p-3">Referral Recived Email</th>
                  <th className="border p-3">Saler Email</th>
                </tr>
              </thead>

              <tbody>
                {referralData.length > 0 ? (
                  referralData
                    .slice(
                      (currentPage1 - 1) * itemsPerPage1,
                      currentPage1 * itemsPerPage1
                    )
                    .map((item, idx) => (
                      <tr
                        key={idx}
                        style={{
                          transition: "0.3s",
                        }}
                        className="hover:bg-gray-50"
                      >
                        <td className="border p-3">
                          <img
                            src={item.product}
                            alt="product"
                            style={{
                              height: "90px",
                              width: "90px",
                              objectFit: "cover",
                              borderRadius: "12px",
                            }}
                          />
                        </td>

                        <td className="border p-3 font-semibold">
                          {item.productName}
                        </td>

                        <td className="border p-3">
                          ₹ {item.price}
                        </td>

                        <td className="border p-3">
                          {item.email}
                        </td>

                        <td className="border p-3">
                          {item.customerEmail}
                        </td>

                        <td className="border p-3">
                          {item.salerEmail}
                        </td>
                      </tr>
                    ))
                ) : (
                  <tr>
                    <td
                      colSpan="7"
                      className="text-center p-4 text-gray-500"
                    >
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* PAGINATION */}
          <div
            style={{
              padding: "20px",
              display: "flex",
              justifyContent: "center",
              gap: "10px",
              flexWrap: "wrap",
            }}
          >
            <Button
              variant="secondary"
              onClick={() =>
                setCurrentPage1((prev) => Math.max(prev - 1, 1))
              }
              disabled={currentPage1 === 1}
            >
              Prev
            </Button>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                fontWeight: "600",
              }}
            >
              Page {currentPage1} of {totalPages1}
            </div>

            <Button
              variant="secondary"
              onClick={() =>
                setCurrentPage1((prev) =>
                  Math.min(prev + 1, totalPages1)
                )
              }
              disabled={currentPage1 === totalPages1}
            >
              Next
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}

{
  activeSection === "referral-in" && (
    <>
      <div
        style={{
          minHeight: "100vh",
          background: "#f4f7fb",
          padding: "20px",
        }}
      >
        {/* HEADER */}
        <div
          style={{
            background: "linear-gradient(135deg,#1e293b,#0f766e)",
            padding: "30px",
            borderRadius: "20px",
            color: "#fff",
            marginBottom: "25px",
            boxShadow: "0 10px 30px rgba(15,118,110,0.25)",
          }}
        >
          <h2
            style={{
              margin: 0,
              fontSize: "32px",
              fontWeight: "700",
            }}
          >
            Referral In Reports
          </h2>

          <p
            style={{
              marginTop: "8px",
              opacity: 0.9,
              fontSize: "15px",
            }}
          >
            View referrals received reports
          </p>
        </div>

        {/* TABLE CARD */}
        <div
          style={{
            background: "#fff",
            borderRadius: "20px",
            overflow: "hidden",
            boxShadow: "0 8px 25px rgba(0,0,0,0.06)",
          }}
        >
          <div
            style={{
              padding: "20px",
              borderBottom: "1px solid #e2e8f0",
            }}
          >
            <h3
              style={{
                margin: 0,
                fontWeight: "700",
                color: "#1e293b",
              }}
            >
              Referrals Received Report
            </h3>
          </div>

          <div style={{ overflowX: "auto" }}>
            <table
              className="min-w-full text-sm"
              style={{
                minWidth: "1100px",
              }}
            >
              <thead
                style={{
                  background: "#ecfeff",
                }}
              >
                <tr>
                  <th className="border p-3">Product</th>
                  <th className="border p-3">Product Name</th>
                  <th className="border p-3">Price</th>
                  <th className="border p-3">Referral Recived Email</th>
                  <th className="border p-3">Referral Sender Email</th>
                  <th className="border p-3">Saler Email</th>
                </tr>
              </thead>

              <tbody>
                {referralOutData.length > 0 ? (
                  referralOutData
                    .slice(
                      (currentPageIn - 1) * itemsPerPageIn,
                      currentPageIn * itemsPerPageIn
                    )
                    .map((item, idx) => (
                      <tr
                        key={idx}
                        className="hover:bg-gray-50"
                      >
                        <td className="border p-3">
                          <img
                            src={item.product}
                            alt="product"
                            style={{
                              height: "90px",
                              width: "90px",
                              objectFit: "cover",
                              borderRadius: "12px",
                            }}
                          />
                        </td>

                        <td className="border p-3 font-semibold">
                          {item.productName}
                        </td>

                        <td className="border p-3">
                          ₹ {item.price}
                        </td>

                        <td className="border p-3">
                          {item.customerEmail}
                        </td>

                        <td className="border p-3">
                          {item.email}
                        </td>

                        <td className="border p-3">
                          {item.salerEmail}
                        </td>
                      </tr>
                    ))
                ) : (
                  <tr>
                    <td
                      colSpan="7"
                      className="text-center p-4 text-gray-500"
                    >
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* PAGINATION */}
          <div
            style={{
              padding: "20px",
              display: "flex",
              justifyContent: "center",
              gap: "10px",
              flexWrap: "wrap",
            }}
          >
            <Button
              variant="secondary"
              onClick={() =>
                setCurrentPageIn((prev) =>
                  Math.max(prev - 1, 1)
                )
              }
              disabled={currentPageIn === 1}
            >
              Prev
            </Button>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                fontWeight: "600",
              }}
            >
              Page {currentPageIn} of {totalPagesIn}
            </div>

            <Button
              variant="secondary"
              onClick={() =>
                setCurrentPageIn((prev) =>
                  Math.min(prev + 1, totalPagesIn)
                )
              }
              disabled={currentPageIn === totalPagesIn}
            >
              Next
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}




{/* ======================= THANKS NOTE ======================= */}

{activeSection === "thanks-note" && (
  <>

          <Modal
            isOpen={showThanksModal}
            onRequestClose={() => setShowThanksModal(false)}
            contentLabel="Thanks Note Count"
            // className="bg-white p-6 rounded shadow-lg w-[400px] mx-auto mt-40 relative"
            // overlayClassName="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-50"
            style={{
              chapter: {
                top: "50%",
                left: "50%",
                right: "auto",
                bottom: "auto",
                marginRight: "-50%",
                transform: "translate(-50%, -50%)",
                width: "600px",
                maxHeight: "80vh",
                overflowY: "auto",
                padding: "20px",
                borderRadius: "12px",
              },
              overlay: {
                backgroundColor: "rgba(0, 0, 0, 0.5)",
              },
            }}
          >
                 {/* <button
                onClick={() => {
                  
                  setShowThanksModal(false)
                }}
                className="px-4 py-2 border rounded"
              >
                Cancel
              </button> */}
               <div className='text-end'>
             <button
                onClick={() => {
                   setShowThanksModal(false)
                
                   setThanksFromDate('');
                setThanksToDate('');
                setThanksStats([]);
              
                  }

                }
                className="px-4 py-2 border rounded"
              >
                Close
              </button>
              </div>
            <h2 className="text-lg font-bold mb-4">Select Date Range</h2>

            <div className="flex flex-col gap-3">
              <label>
                From Date:
                <input
                  type="date"
                  className="border rounded p-2 w-full"
                  value={thanksFromDate}
                  onChange={(e) => setThanksFromDate(e.target.value)}
                />
              </label>
              <label>
                To Date:
                <input
                  type="date"
                  className="border rounded p-2 w-full"
                  value={thanksToDate}
                  onChange={(e) => setThanksToDate(e.target.value)}
                />
              </label>
            </div>

            <div className="flex justify
            -end gap-3 mt-4">
         

              <button
                onClick={handleCheckThanksStats}
                className="bg-green-600 text-white px-4 py-2 rounded"
              >
                Check
              </button>
              <div className="mt-4 text-right">
                <PDFDownloadLink
                  document={
                    <ThanksNoteStatsPDF
                      fromDate={thanksFromDate}
                      toDate={thanksToDate}
                      data={thanksStats}
                    />
                  }
                  fileName={`thanks-note-stats-${thanksFromDate}-to-${thanksToDate}.pdf`}
                  className="inline-block px-4 py-2 bg-blue-600 text-black rounded hover:bg-blue-700 text-sm"
                >
                  {({ loading }) => (loading ? 'Preparing PDF...' : 'Download PDF')}
                </PDFDownloadLink>
              </div>
            </div>

            {thanksStats.length > 0 && (
              <div className="mt-6 bg-blue-50 p-4 rounded shadow-md">
                <h5 className="text-lg font-semibold mb-3">
                 Highest Thanks Note Senders (From: {thanksFromDate} To: {thanksToDate})
                </h5>
                <table className="min-w-full text-sm border border-gray-300">
                  <thead className="bg-gray-200">
                    <tr>
                      <th className="border p-2">#</th>
                      <th className="border p-2">Sender Email</th>
                      <th className="border p-2">Count</th>
                    </tr>
                  </thead>
                  <tbody>
                    {thanksStats.map((item, index) => (
                      <tr key={item.salerEmail} className="hover:bg-gray-50">
                        <td className="border p-2 text-center">{index + 1}</td>
                        <td className="border p-2">{item.salerEmail}</td>
                        <td className="border p-2 text-center">{item.count}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </Modal>


    <div
      style={{
        minHeight: "100vh",
        background: "#f4f7fb",
        padding: "20px",
      }}
    >
      {/* HEADER */}
      <div
        style={{
          background: "linear-gradient(135deg,#7c3aed,#4f46e5)",
          padding: "30px",
          borderRadius: "20px",
          color: "#fff",
          marginBottom: "25px",
          boxShadow: "0 10px 30px rgba(79,70,229,0.2)",
        }}
      >
        <h2
          style={{
            margin: 0,
            fontSize: "32px",
            fontWeight: "700",
          }}
        >
          Thanks Note Reports
        </h2>

        <p
          style={{
            marginTop: "8px",
            opacity: 0.9,
            fontSize: "15px",
          }}
        >
          Manage and monitor all thanks note reports
        </p>

        <div className="text-end" style={{ marginTop: "20px" }}>
          <Button onClick={() => setShowThanksModal(true)}>
            Highest Thanks Note Senders
          </Button>
        </div>
      </div>

      {/* TABLE */}
      <div
        style={{
          background: "#fff",
          borderRadius: "20px",
          overflow: "hidden",
          boxShadow: "0 8px 25px rgba(0,0,0,0.06)",
        }}
      >
        <div
          style={{
            padding: "20px",
            borderBottom: "1px solid #e2e8f0",
          }}
        >
          <h3
            style={{
              margin: 0,
              fontWeight: "700",
              color: "#1e293b",
            }}
          >
            ThanksNote Sender & Recived Report
          </h3>
        </div>

        <div style={{ overflowX: "auto" }}>
          <table
            className="min-w-full border border-gray-300 text-sm"
            style={{
              marginBottom: 0,
              minWidth: "1000px",
            }}
          >
            <thead
              className="bg-gray-200"
              style={{
                background: "#eff6ff",
              }}
            >
              <tr>
                <th className="border p-2">Product</th>
                <th className="border p-2">Product Name</th>
                <th className="border p-2">Price</th>
                <th className="border p-2">
                  Thanks Note Sender Email
                </th>
                <th className="border p-2">
                  Thanks Note Reciver Mobile
                </th>
                <th className="border p-2">Fair Price</th>
              </tr>
            </thead>

            <tbody>
              {myThankNote.length > 0 ? (
                myThankNote.map((item, idx) => (
                  <tr key={idx} className="hover:bg-gray-50">
                    <td className="border p-2">
                      <img
                        src={item.product}
                        alt="product"
                        style={{
                          height: "80px",
                          width: "80px",
                          borderRadius: "12px",
                          objectFit: "cover",
                        }}
                      />
                    </td>

                    <td className="border p-2">
                      {item.productName}
                    </td>

                    <td className="border p-2">
                      {item.price}
                    </td>

                    <td className="border p-2">
                      {item.salerEmail}
                    </td>

                    <td className="border p-2">
                      {item.email}
                    </td>

                    <td className="border p-2">
                      {item.additionalInfo}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="7"
                    className="text-center p-4 text-gray-500"
                  >
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </>
)}



{/* ======================= ONE TO ONE ======================= */}

{activeSection === "one-to-one" && (
  <>
    <Modal
      isOpen={showInviteModal}
      onRequestClose={() => setShowInviteModal(false)}
      contentLabel="Invitation Count"
      style={{
        content: {
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          marginRight: "-50%",
          transform: "translate(-50%, -50%)",
          width: "600px",
          maxHeight: "80vh",
          overflowY: "auto",
          padding: "20px",
          borderRadius: "20px",
          border: "none",
          background: "#ffffff",
          boxShadow: "0 15px 40px rgba(0,0,0,0.2)",
        },
        overlay: {
          backgroundColor: "rgba(15,23,42,0.7)",
          zIndex: 9999,
        },
      }}
    >
      <div className="text-end">
        <button
          onClick={() => {
            setShowInviteModal(false);
            setInviteFromDate("");
            setInviteToDate("");
            setInviteStats([]);
          }}
          className="px-4 py-2 border rounded"
          style={{
            borderRadius: "10px",
            border: "1px solid #cbd5e1",
            background: "#fff",
            fontWeight: "600",
          }}
        >
          Close
        </button>
      </div>

      <h2
        className="text-lg font-bold mb-4"
        style={{
          fontSize: "28px",
          color: "#1e293b",
        }}
      >
        Select Date Range
      </h2>

      <div className="flex flex-col gap-3">
        <label style={{ fontWeight: "600" }}>
          From Date:
          <input
            type="date"
            className="border rounded p-2 w-full"
            value={inviteFromDate}
            onChange={(e) => setInviteFromDate(e.target.value)}
            style={{
              marginTop: "8px",
              borderRadius: "12px",
              padding: "12px",
            }}
          />
        </label>

        <label style={{ fontWeight: "600" }}>
          To Date:
          <input
            type="date"
            className="border rounded p-2 w-full"
            value={inviteToDate}
            onChange={(e) => setInviteToDate(e.target.value)}
            style={{
              marginTop: "8px",
              borderRadius: "12px",
              padding: "12px",
            }}
          />
        </label>
      </div>

      <div className="flex justify-end gap-3 mt-4">
        <button
          onClick={handleCheckInviteStats}
          className="bg-green-600 text-white px-4 py-2 rounded"
          style={{
            border: "none",
            borderRadius: "12px",
            background: "#10b981",
            padding: "12px 20px",
            color: "#fff",
            fontWeight: "600",
          }}
        >
          Check
        </button>

        <div className="mt-4 text-right">
          <PDFDownloadLink
            document={
              <InvitationStatsPDF
                fromDate={inviteFromDate}
                toDate={inviteToDate}
                data={inviteStats}
              />
            }
            fileName={`invitation-stats-${inviteFromDate}-to-${inviteToDate}.pdf`}
            className="inline-block px-4 py-2 bg-blue-600 text-black rounded hover:bg-blue-700 text-sm"
          >
            {({ loading }) =>
              loading ? "Preparing PDF..." : "Download PDF"
            }
          </PDFDownloadLink>
        </div>
      </div>

      {inviteStats.length > 0 && (
        <div
          className="mt-6 bg-blue-50 p-4 rounded shadow-md"
          style={{
            background: "#f8fafc",
            borderRadius: "16px",
            padding: "20px",
            marginTop: "25px",
          }}
        >
          <h3
            className="text-lg font-semibold mb-3"
            style={{
              color: "#1e3a8a",
              fontWeight: "700",
            }}
          >
            Invitation Counts (From: {inviteFromDate} To:{" "}
            {inviteToDate})
          </h3>

          <table
            className="min-w-full text-sm border border-gray-300"
            style={{
              overflow: "hidden",
              borderRadius: "12px",
            }}
          >
            <thead
              className="bg-gray-200"
              style={{
                background: "#dbeafe",
              }}
            >
              <tr>
                <th className="border p-2">#</th>
                <th className="border p-2">Sender</th>
                <th className="border p-2">Count</th>
              </tr>
            </thead>

            <tbody>
              {inviteStats.map((item, index) => (
                <tr key={item.name} className="hover:bg-gray-50">
                  <td className="border p-2 text-center">
                    {index + 1}
                  </td>
                  <td className="border p-2">{item.name}</td>
                  <td className="border p-2 text-center">
                    {item.count}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Modal>

    <div
      style={{
        minHeight: "100vh",
        background: "#f4f7fb",
        padding: "20px",
      }}
    >
      {/* HEADER */}
      <div
        style={{
          background: "linear-gradient(135deg,#0f172a,#2563eb)",
          padding: "30px",
          borderRadius: "20px",
          color: "#fff",
          marginBottom: "25px",
          boxShadow: "0 10px 30px rgba(37,99,235,0.2)",
        }}
      >
        <h2
          style={{
            margin: 0,
            fontSize: "32px",
            fontWeight: "700",
          }}
        >
          One To One Invitations
        </h2>

        <p
          style={{
            marginTop: "8px",
            opacity: 0.9,
            fontSize: "15px",
          }}
        >
          Manage and monitor invitation reports
        </p>

        <div className="text-end" style={{ marginTop: "20px" }}>
          <Button onClick={() => setShowInviteModal(true)}>
            Highest Invitations (By Date)
          </Button>
        </div>
      </div>

      {/* TABLE */}
      <div
        style={{
          background: "#fff",
          borderRadius: "20px",
          overflow: "hidden",
          boxShadow: "0 8px 25px rgba(0,0,0,0.06)",
        }}
      >
        <div
          style={{
            padding: "20px",
            borderBottom: "1px solid #e2e8f0",
          }}
        >
          <h3
            style={{
              margin: 0,
              fontWeight: "700",
              color: "#1e293b",
            }}
          >
            Invitations
          </h3>
        </div>

        <div style={{ overflowX: "auto" }}>
          <table
            className="min-w-full border border-gray-300 text-sm"
            style={{
              marginBottom: 0,
              minWidth: "1200px",
            }}
          >
            <thead
              className="bg-gray-200"
              style={{
                background: "#eff6ff",
              }}
            >
              <tr>
                <th className="border p-2">#</th>
                <th className="border p-2">
                  Sender <br />(One-to-One)
                </th>
                <th className="border p-2">Name</th>
                <th className="border p-2">Email</th>
                <th className="border p-2">Date/Time</th>
                <th className="border p-2">Message</th>
                <th className="border p-2">Created At</th>
                <th className="border p-2">Status</th>
              </tr>
            </thead>

            <tbody>
              {invitations.length > 0 ? (
                invitations
                  .slice(
                    (currentPageInv - 1) * itemsPerPageInv,
                    currentPageInv * itemsPerPageInv
                  )
                  .map((invite, index) => {
                    const invitedUser = user.find(
                      (u) =>
                        Number(u.id) === Number(invite.userId)
                    );

                    return (
                      <tr
                        key={invite.id}
                        className="hover:bg-gray-50"
                      >
                        <td className="border p-2">
                          {index +
                            1 +
                            (currentPageInv - 1) *
                              itemsPerPageInv}
                        </td>

                        <td className="border p-2">
                          {invitedUser
                            ? invitedUser.name
                            : "Unknown User"}
                        </td>

                        <td className="border p-2">
                          {invite.name}
                        </td>

                        <td className="border p-2">
                          {invite.email}
                        </td>

                        <td className="border p-2">
                          {new Date(
                            invite.dateTime
                          ).toLocaleString()}
                        </td>

                        <td className="border p-2">
                          {invite.message}
                        </td>

                        <td className="border p-2">
                          {new Date(
                            invite.createdAt
                          ).toLocaleString()}
                        </td>

                        <td className="border p-2">
                          {invite.status === 1 ? (
                            <span className="text-green-600 font-medium flex items-center gap-1">
                              ✅ Accepted
                            </span>
                          ) : invite.status === 0 ? (
                            <span className="text-yellow-600 font-medium flex items-center gap-1">
                              ⏳ Pending
                            </span>
                          ) : (
                            <span className="text-red-600 font-medium flex items-center gap-1">
                              ❌ Rejected
                            </span>
                          )}
                        </td>
                      </tr>
                    );
                  })
              ) : (
                <tr>
                  <td
                    colSpan="7"
                    className="text-center p-4 text-gray-500"
                  >
                    No invitations available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* PAGINATION */}
        <div
          className="flex justify-center items-center mt-4 gap-3 text-sm"
          style={{
            padding: "20px",
          }}
        >
          <button
            className="px-3 py-1 border rounded hover:bg-gray-100"
            onClick={() =>
              setCurrentPageInv((prev) =>
                Math.max(prev - 1, 1)
              )
            }
            disabled={currentPageInv === 1}
          >
            Prev
          </button>

          <span className="font-semibold">
            &lt; Page {currentPageInv} of{" "}
            {totalPagesInv} &gt;
          </span>

          <button
            className="px-3 py-1 border rounded hover:bg-gray-100"
            onClick={() =>
              setCurrentPageInv((prev) =>
                Math.min(prev + 1, totalPagesInv)
              )
            }
            disabled={currentPageInv === totalPagesInv}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  </>
)}

{activeSection === "meeting-attendance" && (
  <div
    style={{
      minHeight: "100vh",
      background: "#f4f7fb",
      padding: "20px",
    }}
  >
    {/* HIDE HEADER WHEN MODAL OPEN */}
    <style>
      {`
        body:has(.ReactModal__Overlay--after-open) .navbar,
        body:has(.ReactModal__Overlay--after-open) header {
          display:none !important;
        }
      `}
    </style>

    {/* HEADER */}
    <div
      style={{
        background: "linear-gradient(135deg,#1e3a8a,#2563eb)",
        padding: "30px",
        borderRadius: "24px",
        color: "#fff",
        marginBottom: "25px",
        boxShadow: "0 10px 30px rgba(37,99,235,0.25)",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "20px",
        }}
      >
        <div>
          <h2
            style={{
              margin: 0,
              fontSize: "32px",
              fontWeight: "700",
            }}
          >
            Meeting Attendance Report
          </h2>

          <p
            style={{
              marginTop: "8px",
              opacity: 0.9,
              fontSize: "15px",
            }}
          >
            Track attendance records & visitor responses
          </p>
        </div>

        <div
          style={{
            display: "flex",
            gap: "12px",
            flexWrap: "wrap",
          }}
        >
          <PDFDownloadLink
            document={
              <MeetingAttendancePDF
                selectedDate={selectedDate}
                selectedVenue={selectedVenue}
                selectedMeetingDetails={selectedMeetingDetails}
                invitationsget={invitationsget}
                getUserNameById={getUserNameById}
              />
            }
            fileName={`Meeting_Report_${new Date(selectedDate).toLocaleDateString()}.pdf`}
            style={{
              textDecoration: "none",
              padding: "12px 20px",
              color: "#fff",
              background: "#10b981",
              borderRadius: "12px",
              fontWeight: "600",
              boxShadow: "0 4px 12px rgba(16,185,129,0.3)",
            }}
          >
            {({ loading }) =>
              loading ? "Generating PDF..." : "Download PDF"
            }
          </PDFDownloadLink>

          <button
            type="button"
            onClick={closeModallAtt}
            style={{
              border: "none",
              background: "#fff",
              color: "#1e3a8a",
              padding: "12px 22px",
              borderRadius: "12px",
              fontWeight: "600",
              cursor: "pointer",
            }}
          >
            Reset
          </button>
        </div>
      </div>
    </div>

    {/* FILTERS */}
    <div
      style={{
        background: "#fff",
        padding: "25px",
        borderRadius: "20px",
        marginBottom: "25px",
        boxShadow: "0 8px 25px rgba(0,0,0,0.06)",
      }}
    >
      <div
        style={{
          display: "flex",
          gap: "20px",
          flexWrap: "wrap",
          alignItems: "end",
        }}
      >
        <div>
          <label
            htmlFor="dateDropdown"
            style={{
              display: "block",
              marginBottom: "8px",
              fontWeight: "600",
              color: "#1e293b",
            }}
          >
            Select Date
          </label>

          <select
            id="dateDropdown"
            value={selectedDate}
            onChange={handleDateChange}
            style={{
              width: "220px",
              padding: "12px",
              borderRadius: "12px",
              border: "1px solid #cbd5e1",
              fontSize: "15px",
              outline: "none",
              background: "#f8fafc",
            }}
          >
            <option value="">Select a date</option>

            {uniqueDates.map((date) => (
              <option key={date} value={date}>
                {new Date(date).toLocaleDateString()}
              </option>
            ))}
          </select>
        </div>

        {selectedDate && (
          <div>
            <label
              htmlFor="venueDropdown"
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: "600",
                color: "#1e293b",
              }}
            >
              Select Venue
            </label>

            <select
              id="venueDropdown"
              value={selectedVenue}
              onChange={handleVenueChange}
              style={{
                width: "220px",
                padding: "12px",
                borderRadius: "12px",
                border: "1px solid #cbd5e1",
                fontSize: "15px",
                outline: "none",
                background: "#f8fafc",
              }}
            >
              <option value="">Select a venue</option>

              {venuesForSelectedDate.map((venue, index) => (
                <option key={index} value={venue}>
                  {venue}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>
    </div>

    {/* MEETING DETAILS */}
    {selectedVenue && selectedMeetingDetails.length > 0 && (
      <div
        style={{
          background: "#fff",
          borderRadius: "20px",
          overflow: "hidden",
          marginBottom: "30px",
          boxShadow: "0 8px 25px rgba(0,0,0,0.06)",
        }}
      >
        <div
          style={{
            padding: "20px",
            borderBottom: "1px solid #e2e8f0",
          }}
        >
          <h3
            style={{
              margin: 0,
              fontWeight: "700",
              color: "#1e293b",
            }}
          >
            Meeting Details
          </h3>
        </div>

        <div style={{ overflowX: "auto" }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              minWidth: "700px",
            }}
          >
            <thead
              style={{
                background: "#eff6ff",
              }}
            >
              <tr>
                <th style={{ padding: "15px" }}>User</th>
                <th style={{ padding: "15px" }}>Email</th>
                <th style={{ padding: "15px" }}>Response</th>
              </tr>
            </thead>

            <tbody>
              {selectedMeetingDetails.map((meeting, index) => {
                const user = users.find(
                  (user) => user.id === meeting.user_id
                );

                const isMeetingExpired =
                  new Date(meeting.date) < new Date();

                let responseText =
                  meeting.response === "yes"
                    ? "Attended"
                    : "Not Attended";

                if (isMeetingExpired) {
                  responseText =
                    meeting.response === "yes"
                      ? "Present"
                      : "Absent";
                }

                return (
                  <tr
                    key={index}
                    style={{
                      borderBottom: "1px solid #e2e8f0",
                    }}
                  >
                    <td style={{ padding: "15px" }}>
                      {user ? user.name : "Unknown"}
                    </td>

                    <td style={{ padding: "15px" }}>
                      {meeting.user_email}
                    </td>

                    <td
                      style={{
                        padding: "15px",
                        color:
                          meeting.response === "yes"
                            ? "#16a34a"
                            : "#dc2626",
                        fontWeight: "600",
                      }}
                    >
                      {responseText}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    )}

    {/* VISITOR INVITATIONS */}
    {selectedMeetingDetails.length > 0 && (
      <div
        style={{
          background: "#fff",
          borderRadius: "20px",
          overflow: "hidden",
          boxShadow: "0 8px 25px rgba(0,0,0,0.06)",
        }}
      >
        <div
          style={{
            padding: "20px",
            borderBottom: "1px solid #e2e8f0",
          }}
        >
          <h3
            style={{
              margin: 0,
              fontWeight: "700",
              color: "#1e293b",
            }}
          >
            Visitor Invitations
          </h3>
        </div>

        <div style={{ overflowX: "auto" }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              minWidth: "900px",
            }}
          >
            <thead
              style={{
                background: "#eff6ff",
              }}
            >
              <tr>
                <th style={{ padding: "15px" }}>
                  Visitor Invite Sender
                </th>
                <th style={{ padding: "15px" }}>Visitor Name</th>
                <th style={{ padding: "15px" }}>Email</th>
                <th style={{ padding: "15px" }}>Mobile</th>
                <th style={{ padding: "15px" }}>Response</th>
              </tr>
            </thead>

            <tbody>
              {invitationsget
                .filter(
                  (invite) =>
                    invite.meeting_id ===
                    selectedMeetingDetails[0]?.meeting_id
                )
                .map((invite, index) => (
                  <tr
                    key={index}
                    style={{
                      borderBottom: "1px solid #e2e8f0",
                    }}
                  >
                    <td style={{ padding: "15px" }}>
                      {getUserNameById(invite.userId)}
                    </td>

                    <td style={{ padding: "15px" }}>
                      {invite.visitor_name}
                    </td>

                    <td style={{ padding: "15px" }}>
                      {invite.visitor_email}
                    </td>

                    <td style={{ padding: "15px" }}>
                      {invite.visitor_mobile}
                    </td>

                    <td
                      style={{
                        padding: "15px",
                        color:
                          invite.response === "yes"
                            ? "#16a34a"
                            : invite.response === "no"
                            ? "#dc2626"
                            : "#64748b",
                        fontWeight: "600",
                      }}
                    >
                      {invite.response
                        ? invite.response === "yes"
                          ? "Attended"
                          : "Not Attended"
                        : "Pending"}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    )}
  </div>
)}

{activeSection === "event-attendance" && (
  <div
    style={{
      minHeight: "100vh",
      background: "#f4f7fb",
      padding: "20px",
    }}
  >
    {/* HIDE HEADER WHEN MODAL OPEN */}
    <style>
      {`
        body:has(.ReactModal__Overlay--after-open) .navbar,
        body:has(.ReactModal__Overlay--after-open) header {
          display:none !important;
        }
      `}
    </style>

    {/* HEADER */}
    <div
      style={{
        background: "linear-gradient(135deg,#7c3aed,#2563eb)",
        padding: "30px",
        borderRadius: "24px",
        color: "#fff",
        marginBottom: "25px",
        boxShadow: "0 10px 30px rgba(99,102,241,0.25)",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "20px",
        }}
      >
        <div>
          <h2
            style={{
              margin: 0,
              fontSize: "32px",
              fontWeight: "700",
            }}
          >
            Event Attendance Report
          </h2>

          <p
            style={{
              marginTop: "8px",
              opacity: 0.9,
              fontSize: "15px",
            }}
          >
            Monitor event attendance & participation
          </p>
        </div>

        <button
          type="button"
          onClick={closeModallEventAtt}
          style={{
            border: "none",
            background: "#fff",
            color: "#2563eb",
            padding: "12px 22px",
            borderRadius: "12px",
            fontWeight: "600",
            cursor: "pointer",
          }}
        >
          Reset
        </button>
      </div>
    </div>

    {/* FILTERS */}
    <div
      style={{
        background: "#fff",
        padding: "25px",
        borderRadius: "20px",
        marginBottom: "25px",
        boxShadow: "0 8px 25px rgba(0,0,0,0.06)",
      }}
    >
      <div
        style={{
          display: "flex",
          gap: "20px",
          flexWrap: "wrap",
          alignItems: "end",
        }}
      >
        <div>
          <label
            htmlFor="dateDropdown"
            style={{
              display: "block",
              marginBottom: "8px",
              fontWeight: "600",
              color: "#1e293b",
            }}
          >
            Select Date
          </label>

          <select
            id="dateDropdown"
            value={selectedEventDate}
            onChange={handleDateEventChange}
            style={{
              width: "220px",
              padding: "12px",
              borderRadius: "12px",
              border: "1px solid #cbd5e1",
              fontSize: "15px",
              background: "#f8fafc",
              outline: "none",
            }}
          >
            <option value="">Select Event date</option>

            {uniqueEventDates.map((date) => (
              <option key={date} value={date}>
                {new Date(date).toLocaleDateString()}
              </option>
            ))}
          </select>
        </div>

        {selectedEventDate && (
          <div>
            <label
              htmlFor="venueDropdown"
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: "600",
                color: "#1e293b",
              }}
            >
              Select Venue
            </label>

            <select
              id="venueDropdown"
              value={selectedEventVenue}
              onChange={handleEventVenueChange}
              style={{
                width: "220px",
                padding: "12px",
                borderRadius: "12px",
                border: "1px solid #cbd5e1",
                fontSize: "15px",
                background: "#f8fafc",
                outline: "none",
              }}
            >
              <option value="">Select a venue</option>

              {venuesEventForSelectedDate.map(
                (venue, index) => (
                  <option key={index} value={venue}>
                    {venue}
                  </option>
                )
              )}
            </select>
          </div>
        )}

        {selectedEventVenue && (
          <div>
            <label
              htmlFor="venueDropdown"
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: "600",
                color: "#1e293b",
              }}
            >
              Select Event
            </label>

            <select
              id="venueDropdown"
              value={selectedEvents}
              onChange={handleEventChange}
              style={{
                width: "220px",
                padding: "12px",
                borderRadius: "12px",
                border: "1px solid #cbd5e1",
                fontSize: "15px",
                background: "#f8fafc",
                outline: "none",
              }}
            >
              <option value="">Select a event</option>

              {EventForSelectedDate.map((venue, index) => (
                <option key={index} value={venue}>
                  {venue}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>
    </div>

    {/* EVENT DETAILS */}
    {selectedEvents && selectedEventDetails.length > 0 && (
      <div
        style={{
          background: "#fff",
          borderRadius: "20px",
          overflow: "hidden",
          boxShadow: "0 8px 25px rgba(0,0,0,0.06)",
        }}
      >
        <div
          style={{
            padding: "20px",
            borderBottom: "1px solid #e2e8f0",
          }}
        >
          <h3
            style={{
              margin: 0,
              fontWeight: "700",
              color: "#1e293b",
            }}
          >
            Event Details
          </h3>
        </div>

        <div style={{ overflowX: "auto" }}>
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              minWidth: "700px",
            }}
          >
            <thead
              style={{
                background: "#eff6ff",
              }}
            >
              <tr>
                <th style={{ padding: "15px" }}>User</th>
                <th style={{ padding: "15px" }}>User Email</th>
                <th style={{ padding: "15px" }}>Response</th>
              </tr>
            </thead>

            <tbody>
              {selectedEventDetails.map((event, index) => {
                const user = users.find(
                  (user) => user.id === event.user_id
                );

                return (
                  <tr
                    key={index}
                    style={{
                      borderBottom: "1px solid #e2e8f0",
                    }}
                  >
                    <td style={{ padding: "15px" }}>
                      {user ? user.name : "Unknown"}
                    </td>

                    <td style={{ padding: "15px" }}>
                      {event.user_email}
                    </td>

                    <td
                      style={{
                        padding: "15px",
                        color:
                          event.response === "yes"
                            ? "#16a34a"
                            : "#dc2626",
                        fontWeight: "600",
                      }}
                    >
                      {event.response === "yes"
                        ? "Attended"
                        : "Not Attended"}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    )}
  </div>
)}


    </>

  );
};
const mobileBtnStyle = {
  width: "100%",
  border: "none",
  background: "#f8fafc",
  color: "#1e3a8a",
  padding: "14px 16px",
  borderRadius: "12px",
  fontWeight: "600",
  textAlign: "left",
  cursor: "pointer",
};

const mobileSubBtnStyle = {
  width: "100%",
  border: "none",
  background: "#eff6ff",
  color: "#1e3a8a",
  padding: "12px 14px",
  borderRadius: "10px",
  fontWeight: "500",
  textAlign: "left",
  cursor: "pointer",
};
/* ADD THIS STYLE OBJECT ABOVE RETURN */

const tableHead = {
  padding: "15px",
  textAlign: "left",
  fontWeight: "700",
  color: "#1e293b",
  fontSize: "14px",
};

const tableCell = {
  padding: "15px",
  fontSize: "14px",
  color: "#334155",
};
export default AdminDashboard;



      // {activeSection === "referral-out" && (
      //   <>
      

          // <Modal
          //   isOpen={showReferralModal1}
          //   onRequestClose={() => setShowReferralModal1(false)}
          //   contentLabel="Referral Date Filter"
          //   // className="bg-white p-6 rounded shadow-lg w-[400px] mx-auto mt-40 relative"
          //   // overlayClassName="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-50"
          //   style={{
          //     chapter: {
          //       top: "50%",
          //       left: "50%",
          //       right: "auto",
          //       bottom: "auto",
          //       marginRight: "-50%",
          //       transform: "translate(-50%, -50%)",
          //       width: "600px",
          //       maxHeight: "80vh",
          //       overflowY: "auto",
          //       padding: "20px",
          //       borderRadius: "12px",
          //     },
          //     overlay: {
          //       backgroundColor: "rgba(0, 0, 0, 0.5)",
          //     },
          //   }}
          // >
          //    <div className='text-end'>
          //   <button
          //     onClick={() => {
          //       // setReferralStats('');
          //       setReferralFromDate('');
          //       setReferralToDate('');
          //       setReferralStats([]);
          //       setShowReferralModal1(false)
          //     }}
          //     className="px-4 py-2 border rounded"
          //   >
          //     Close
          //   </button>
              
          //    {/* <button
          //       onClick={() =>setShowThanksModal(false)
                  
          //       }
          //       className="px-4 py-2 border rounded"
          //     >
          //       Close
          //     </button> */}
          //     </div>
          //   <h2 className="text-lg font-bold mb-4">Select Date Range</h2>

          //   <div className="flex flex-col gap-3">
          //     <label>
          //       From Date:
          //       <input
          //         type="date"
          //         className="border rounded p-2 w-full"
          //         value={referralFromDate}
          //         onChange={(e) => setReferralFromDate(e.target.value)}
          //       />
          //     </label>
          //     <label>
          //       To Date:
          //       <input
          //         type="date"
          //         className="border rounded p-2 w-full"
          //         value={referralToDate}
          //         onChange={(e) => setReferralToDate(e.target.value)}
          //       />
          //     </label>
          //   </div>

          //   <div className="flex justify-end gap-3 mt-4">

          //     <button
          //       onClick={handleCheckHighestReferral}
          //       className="bg-green-600 text-white px-4 py-2 rounded"
          //     >
          //       Check
          //     </button>
          //   </div>
          //   <div className="mt-4 text-right">
          //     <PDFDownloadLink
          //       document={
          //         <ReferralStatsPDF
          //           fromDate={referralFromDate}
          //           toDate={referralToDate}
          //           data={referralStats}
          //         />
          //       }
          //       fileName={`referral-stats-${referralFromDate}-to-${referralToDate}.pdf`}
          //       className="inline-block px-4 py-2 bg-blue-600 text-black rounded hover:bg-blue-700 text-sm"
          //     >
          //       {({ loading }) => (loading ? 'Preparing PDF...' : 'Download PDF')}
          //     </PDFDownloadLink>
          //   </div>

          //   {referralStats.length > 0 && (
          //     <div className="mt-6 bg-blue-50 p-4 rounded shadow-md">
          //       <h5 className="text-lg font-semibold mb-3">
          //         Highest Referral (From: {referralFromDate} To: {referralToDate})
          //       </h5>
          //       <table className="min-w-full text-sm border border-gray-300">
          //         <thead className="bg-gray-200">
          //           <tr>
          //             <th className="border p-2">#</th>
          //             <th className="border p-2">Referral Email</th>
          //             <th className="border p-2">Count</th>
          //           </tr>
          //         </thead>
          //         <tbody>
          //           {referralStats.map((item, index) => (
          //             <tr key={item.email} className="hover:bg-gray-50">
          //               <td className="border p-2 text-center">{index + 1}</td>
          //               <td className="border p-2">{item.email}</td>
          //               <td className="border p-2 text-center">{item.count}</td>
          //             </tr>
          //           ))}
          //         </tbody>
          //       </table>
          //     </div>
          //   )}
          // </Modal>


      //     <div>
            
      //       <div className="p-5 mb-10 overflow-x-auto">
      //           <div className='text-end' stle={{padding:'10px 5px'}}>
      //     <Button
      //       // className="bg-blue-600 text-white px-4 py-2 rounded mb-4"
      //       onClick={() => setShowReferralModal1(true)}
      //     >
      //       Highest Referrals
      //     </Button>
      //     </div>
      //         <h2 className="text-xl font-bold mb-3">Referral Sender & Recived Report</h2>

      //         <table className="min-w-full border border-gray-300 text-sm">
      //           <thead className="bg-gray-200">
      //             <tr>
      //               <th className="border p-2">Product</th>
      //               <th className="border p-2">Product Name</th>
      //               <th className="border p-2">Price</th>
      //               <th className="border p-2">Referral Sender Email</th>
      //               <th className="border p-2">Referral Recived Email</th>
      //               <th className="border p-2">Saler Email</th>
      //             </tr>
      //           </thead>
      //           <tbody>
      //             {referralData.length > 0 ? (
      //               referralData
      //                 .slice((currentPage1 - 1) * itemsPerPage1, currentPage1 * itemsPerPage1)
      //                 .map((item, idx) => (
      //                   <tr key={idx} className="hover:bg-gray-50">
      //                     <td className="border p-2">
      //                       <img
      //                         src={item.product}
      //                         alt="product"
      //                         style={{ height: "100px", width: "100px" }}
      //                         className="object-cover rounded"
      //                       />
      //                     </td>
      //                     <td className="border p-2">{item.productName}</td>
      //                     <td className="border p-2">{item.price}</td>
      //                     <td className="border p-2">{item.email}</td>
      //                     <td className="border p-2">{item.customerEmail}</td>
      //                     <td className="border p-2">{item.salerEmail}</td>
      //                   </tr>
      //                 ))
      //             ) : (
      //               <tr>
      //                 <td colSpan="7" className="text-center p-4 text-gray-500">
      //                   No data available
      //                 </td>
      //               </tr>
      //             )}
      //           </tbody>
      //         </table>

      //         {/* Pagination Controls */}
      //         <div className="flex justify-center items-center mt-4 gap-3 text-sm">
      //           <button
      //             className="px-3 py-1 border rounded hover:bg-gray-100"
      //             onClick={() => setCurrentPage1((prev) => Math.max(prev - 1, 1))}
      //             disabled={currentPage1 === 1}
      //           >
      //             Prev
      //           </button>

      //           <span className="font-semibold">
      //             &lt; Page {currentPage1} of {totalPages1} &gt;
      //           </span>

      //           <button
      //             className="px-3 py-1 border rounded hover:bg-gray-100"
      //             onClick={() =>
      //               setCurrentPage1((prev) => Math.min(prev + 1, totalPages1))
      //             }
      //             disabled={currentPage1 === totalPages1}
      //           >
      //             Next
      //           </button>
      //         </div>
      //       </div>
      //     </div>
      //   </>


      // )}
      // {activeSection === "referral-in" && (
      //   <>
      //     <div className="p-5 mb-10 overflow-x-auto">
      //       <h2 className="text-xl font-bold mb-3">Referrals Received Report</h2>

      //       <table className="min-w-full border border-gray-300 text-sm">
      //         <thead className="bg-gray-200">
      //           <tr>
      //             <th className="border p-2">Product</th>
      //             <th className="border p-2">Product Name</th>
      //             <th className="border p-2">Price</th>
      //             <th className="border p-2">Referral Recived Email</th>
      //             <th className="border p-2">Referral Sender Email</th>
      //             <th className="border p-2">Saler Email</th>
      //           </tr>
      //         </thead>
      //         <tbody>
      //           {referralOutData.length > 0 ? (
      //             referralOutData
      //               .slice(
      //                 (currentPageIn - 1) * itemsPerPageIn,
      //                 currentPageIn * itemsPerPageIn
      //               )
      //               .map((item, idx) => (
      //                 <tr key={idx} className="hover:bg-gray-50">
      //                   <td className="border p-2">
      //                     <img
      //                       src={item.product}
      //                       alt="product"
      //                       style={{ height: "100px", width: "100px" }}
      //                       className="w-16 h-16 object-contain rounded"
      //                     />
      //                   </td>
      //                   <td className="border p-2">{item.productName}</td>
      //                   <td className="border p-2">{item.price}</td>
      //                   <td className="border p-2">{item.customerEmail}</td>
      //                   <td className="border p-2">{item.email}</td>
      //                   <td className="border p-2">{item.salerEmail}</td>
      //                 </tr>
      //               ))
      //           ) : (
      //             <tr>
      //               <td colSpan="7" className="text-center p-4 text-gray-500">
      //                 No data available
      //               </td>
      //             </tr>
      //           )}
      //         </tbody>
      //       </table>

      //       {/* Pagination Controls */}
      //       <div className="flex justify-center items-center mt-4 gap-3 text-sm">
      //         <button
      //           className="px-3 py-1 border rounded hover:bg-gray-100"
      //           onClick={() => setCurrentPageIn((prev) => Math.max(prev - 1, 1))}
      //           disabled={currentPageIn === 1}
      //         >
      //           Prev
      //         </button>

      //         <span className="font-semibold">
      //           &lt; Page {currentPageIn} of {totalPagesIn} &gt;
      //         </span>

      //         <button
      //           className="px-3 py-1 border rounded hover:bg-gray-100"
      //           onClick={() =>
      //             setCurrentPageIn((prev) => Math.min(prev + 1, totalPagesIn))
      //           }
      //           disabled={currentPageIn === totalPagesIn}
      //         >
      //           Next
      //         </button>
      //       </div>
      //     </div>


      //   </>


      // )}

      //       {activeSection === "thanks-note" && (
      //   <>

      //     {/* <button
      //       className="mb-4 px-4 py-2 bg-blue-600 text-white rounded"
      //       onClick={() => setShowThanksModal(true)}
      //     >
      //       Count Thanks Note Senders
      //     </button> */}

          // <Modal
          //   isOpen={showThanksModal}
          //   onRequestClose={() => setShowThanksModal(false)}
          //   contentLabel="Thanks Note Count"
          //   // className="bg-white p-6 rounded shadow-lg w-[400px] mx-auto mt-40 relative"
          //   // overlayClassName="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-50"
          //   style={{
          //     chapter: {
          //       top: "50%",
          //       left: "50%",
          //       right: "auto",
          //       bottom: "auto",
          //       marginRight: "-50%",
          //       transform: "translate(-50%, -50%)",
          //       width: "600px",
          //       maxHeight: "80vh",
          //       overflowY: "auto",
          //       padding: "20px",
          //       borderRadius: "12px",
          //     },
          //     overlay: {
          //       backgroundColor: "rgba(0, 0, 0, 0.5)",
          //     },
          //   }}
          // >
          //        {/* <button
          //       onClick={() => {
                  
          //         setShowThanksModal(false)
          //       }}
          //       className="px-4 py-2 border rounded"
          //     >
          //       Cancel
          //     </button> */}
          //      <div className='text-end'>
          //    <button
          //       onClick={() => {
          //          setShowThanksModal(false)
                
          //          setThanksFromDate('');
          //       setThanksToDate('');
          //       setThanksStats([]);
              
          //         }

          //       }
          //       className="px-4 py-2 border rounded"
          //     >
          //       Close
          //     </button>
          //     </div>
          //   <h2 className="text-lg font-bold mb-4">Select Date Range</h2>

          //   <div className="flex flex-col gap-3">
          //     <label>
          //       From Date:
          //       <input
          //         type="date"
          //         className="border rounded p-2 w-full"
          //         value={thanksFromDate}
          //         onChange={(e) => setThanksFromDate(e.target.value)}
          //       />
          //     </label>
          //     <label>
          //       To Date:
          //       <input
          //         type="date"
          //         className="border rounded p-2 w-full"
          //         value={thanksToDate}
          //         onChange={(e) => setThanksToDate(e.target.value)}
          //       />
          //     </label>
          //   </div>

          //   <div className="flex justify
          //   -end gap-3 mt-4">
         

          //     <button
          //       onClick={handleCheckThanksStats}
          //       className="bg-green-600 text-white px-4 py-2 rounded"
          //     >
          //       Check
          //     </button>
          //     <div className="mt-4 text-right">
          //       <PDFDownloadLink
          //         document={
          //           <ThanksNoteStatsPDF
          //             fromDate={thanksFromDate}
          //             toDate={thanksToDate}
          //             data={thanksStats}
          //           />
          //         }
          //         fileName={`thanks-note-stats-${thanksFromDate}-to-${thanksToDate}.pdf`}
          //         className="inline-block px-4 py-2 bg-blue-600 text-black rounded hover:bg-blue-700 text-sm"
          //       >
          //         {({ loading }) => (loading ? 'Preparing PDF...' : 'Download PDF')}
          //       </PDFDownloadLink>
          //     </div>
          //   </div>

          //   {thanksStats.length > 0 && (
          //     <div className="mt-6 bg-blue-50 p-4 rounded shadow-md">
          //       <h5 className="text-lg font-semibold mb-3">
          //        Highest Thanks Note Senders (From: {thanksFromDate} To: {thanksToDate})
          //       </h5>
          //       <table className="min-w-full text-sm border border-gray-300">
          //         <thead className="bg-gray-200">
          //           <tr>
          //             <th className="border p-2">#</th>
          //             <th className="border p-2">Sender Email</th>
          //             <th className="border p-2">Count</th>
          //           </tr>
          //         </thead>
          //         <tbody>
          //           {thanksStats.map((item, index) => (
          //             <tr key={item.salerEmail} className="hover:bg-gray-50">
          //               <td className="border p-2 text-center">{index + 1}</td>
          //               <td className="border p-2">{item.salerEmail}</td>
          //               <td className="border p-2 text-center">{item.count}</td>
          //             </tr>
          //           ))}
          //         </tbody>
          //       </table>
          //     </div>
          //   )}
          // </Modal>


      //     <div className="p-5 mb-10 overflow-x-auto">

      //         <div className='text-end' stle={{padding:'10px 5px'}}>
      //     <Button
      //       // className="bg-blue-600 text-white px-4 py-2 rounded mb-4"
      //         onClick={() => setShowThanksModal(true)}
      //     >
      //      Highest Thanks Note Senders
      //     </Button>
      //     </div>
      //       <h2 className="text-xl font-bold mb-3">ThanksNote Sender & Recived Report </h2>
      //       <table className="min-w-full border border-gray-300 text-sm">
      //         <thead className="bg-gray-200">
      //           <tr>
      //             <th className="border p-2">Product</th>
      //             <th className="border p-2">Product Name</th>
      //             <th className="border p-2">Price</th>
      //             <th className="border p-2">Thanks Note Sender Email</th>
      //             <th className="border p-2">Thanks Note Reciver Mobile</th>
      //             <th className="border p-2">Fair Price</th>
      //             {/* <th className="border p-2">Saler Mobile</th> */}
      //           </tr>
      //         </thead>
      //         <tbody>
      //           {myThankNote.length > 0 ? (
      //             myThankNote.map((item, idx) => (
      //               <tr key={idx} className="hover:bg-gray-50">
      //                 <td className="border p-2">
      //                   <img src={item.product} alt="product" style={{ height: '100px', width: '100px' }} className="w-16 h-16 object-cover rounded" />
      //                 </td>
      //                 <td className="border p-2">{item.productName}</td>
      //                 <td className="border p-2">{item.price}</td>
      //                 <td className="border p-2">{item.salerEmail}</td>
      //                 <td className="border p-2">{item.email}</td>
      //                 <td className="border p-2">{item.additionalInfo}</td>
      //                 {/* <td className="border p-2">{item.salerMobile}</td> */}
      //               </tr>
      //             ))
      //           ) : (
      //             <tr>
      //               <td colSpan="7" className="text-center p-4 text-gray-500">
      //                 No data available
      //               </td>
      //             </tr>
      //           )}
      //         </tbody>
      //       </table>
      //     </div>


      //   </>


      // )}

      // {activeSection === "one-to-one" && (
      //   <>
      //     {/* <button
      //       className="mb-4 px-4 py-2 bg-indigo-600 text-white rounded"
      //       onClick={() => setShowInviteModal(true)}
      //     >
      //       Count Invitations (By Date)
      //     </button> */}

          // <Modal
          //   isOpen={showInviteModal}
          //   onRequestClose={() => setShowInviteModal(false)}
          //   contentLabel="Invitation Count"
          //   // className="bg-white p-6 rounded shadow-lg w-[400px] mx-auto mt-40 relative"
          //   // overlayClassName="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-50"
          //   style={{
          //     chapter: {
          //       top: "50%",
          //       left: "50%",
          //       right: "auto",
          //       bottom: "auto",
          //       marginRight: "-50%",
          //       transform: "translate(-50%, -50%)",
          //       width: "600px",
          //       maxHeight: "80vh",
          //       overflowY: "auto",
          //       padding: "20px",
          //       borderRadius: "12px",
          //     },
          //     overlay: {
          //       backgroundColor: "rgba(0, 0, 0, 0.5)",
          //     },
          //   }}
          // >
          //   <div className='text-end'>
          //    <button
          //       onClick={() => {
          //         setShowInviteModal(false)

          //          setInviteFromDate('');
          //       setInviteToDate('');
          //       setInviteStats([]);
          //       }}
          //       className="px-4 py-2 border rounded"
          //     >
          //       Close
          //     </button>
          //     </div>
          //   <h2 className="text-lg font-bold mb-4">Select Date Range</h2>

          //   <div className="flex flex-col gap-3">
          //     <label>
          //       From Date:
          //       <input
          //         type="date"
          //         className="border rounded p-2 w-full"
          //         value={inviteFromDate}
          //         onChange={(e) => setInviteFromDate(e.target.value)}
          //       />
          //     </label>
          //     <label>
          //       To Date:
          //       <input
          //         type="date"
          //         className="border rounded p-2 w-full"
          //         value={inviteToDate}
          //         onChange={(e) => setInviteToDate(e.target.value)}
          //       />
          //     </label>
          //   </div>

          //   <div className="flex justify-end gap-3 mt-4">
             
          //     <button
          //       onClick={handleCheckInviteStats}
          //       className="bg-green-600 text-white px-4 py-2 rounded"
          //     >
          //       Check
          //     </button>
          //     <div className="mt-4 text-right">
          //       <PDFDownloadLink
          //         document={
          //           <InvitationStatsPDF
          //             fromDate={inviteFromDate}
          //             toDate={inviteToDate}
          //             data={inviteStats}
          //           />
          //         }
          //         fileName={`invitation-stats-${inviteFromDate}-to-${inviteToDate}.pdf`}
          //         className="inline-block px-4 py-2 bg-blue-600 text-black rounded hover:bg-blue-700 text-sm"
          //       >
          //         {({ loading }) => (loading ? "Preparing PDF..." : "Download PDF")}
          //       </PDFDownloadLink>
          //     </div>
          //   </div>

          //   {inviteStats.length > 0 && (
          //     <div className="mt-6 bg-blue-50 p-4 rounded shadow-md">
          //       <h3 className="text-lg font-semibold mb-3">
          //         Invitation Counts (From: {inviteFromDate} To: {inviteToDate})
          //       </h3>
          //       <table className="min-w-full text-sm border border-gray-300">
          //         <thead className="bg-gray-200">
          //           <tr>
          //             <th className="border p-2">#</th>
          //             <th className="border p-2">Sender</th>
          //             <th className="border p-2">Count</th>
          //           </tr>
          //         </thead>
          //         <tbody>
          //           {inviteStats.map((item, index) => (
          //             <tr key={item.name} className="hover:bg-gray-50">
          //               <td className="border p-2 text-center">{index + 1}</td>
          //               <td className="border p-2">{item.name}</td>
          //               <td className="border p-2 text-center">{item.count}</td>
          //             </tr>
          //           ))}
          //         </tbody>
          //       </table>
          //     </div>
          //   )}
          // </Modal>


      //     <div>
      //       <div className="p-5 mb-10 overflow-x-auto">
      //            <div className='text-end' stle={{padding:'10px 5px'}}>
      //     <Button
      //       // className="bg-blue-600 text-white px-4 py-2 rounded mb-4"
      //           onClick={() => setShowInviteModal(true)}
      //     >
      //      Highest Invitations (By Date)
      //     </Button>
      //     </div>
      //         <h2 className="text-xl font-bold mb-3">Invitations</h2>
      //         <table className="min-w-full border border-gray-300 text-sm">
      //           <thead className="bg-gray-200">
      //             <tr>
      //               <th className="border p-2">#</th>
      //               <th className="border p-2">Sender <br />(One-to-One)</th>
      //               <th className="border p-2">Name</th>
      //               <th className="border p-2">Email</th>
      //               <th className="border p-2">Date/Time</th>
      //               <th className="border p-2">Message</th>
      //               <th className="border p-2">Created At</th>
      //               <th className="border p-2">Status</th>
      //             </tr>
      //           </thead>
      //           <tbody>
      //             {invitations.length > 0 ? (
      //               invitations
      //                 .slice(
      //                   (currentPageInv - 1) * itemsPerPageInv,
      //                   currentPageInv * itemsPerPageInv
      //                 )
      //                 .map((invite, index) => {
      //                   const invitedUser = user.find(u => Number(u.id) === Number(invite.userId));
      //                   return (
      //                     <tr key={invite.id} className="hover:bg-gray-50">
      //                       <td className="border p-2">{index + 1 + (currentPageInv - 1) * itemsPerPageInv}</td>
      //                       <td className="border p-2">  {invitedUser ? invitedUser.name : 'Unknown User'}</td>
      //                       <td className="border p-2">{invite.name}</td>
      //                       <td className="border p-2">{invite.email}</td>
      //                       <td className="border p-2">{new Date(invite.dateTime).toLocaleString()}</td>
      //                       <td className="border p-2">{invite.message}</td>
      //                       <td className="border p-2">{new Date(invite.createdAt).toLocaleString()}</td>
      //                       <td className="border p-2">
      //                         {invite.status === 1 ? (
      //                           <span className="text-green-600 font-medium flex items-center gap-1">
      //                             ✅ Accepted
      //                           </span>
      //                         ) : invite.status === 0 ? (
      //                           <span className="text-yellow-600 font-medium flex items-center gap-1">
      //                             ⏳ Pending
      //                           </span>
      //                         ) : (
      //                           <span className="text-red-600 font-medium flex items-center gap-1">
      //                             ❌ Rejected
      //                           </span>
      //                         )}
      //                       </td>

      //                     </tr>
      //                   )
      //                 })
      //             ) : (
      //               <tr>
      //                 <td colSpan="7" className="text-center p-4 text-gray-500">
      //                   No invitations available
      //                 </td>
      //               </tr>
      //             )}
      //           </tbody>
      //         </table>

      //         {/* Pagination */}
      //         <div className="flex justify-center items-center mt-4 gap-3 text-sm">
      //           <button
      //             className="px-3 py-1 border rounded hover:bg-gray-100"
      //             onClick={() => setCurrentPageInv((prev) => Math.max(prev - 1, 1))}
      //             disabled={currentPageInv === 1}
      //           >
      //             Prev
      //           </button>

      //           <span className="font-semibold">
      //             &lt; Page {currentPageInv} of {totalPagesInv} &gt;
      //           </span>

      //           <button
      //             className="px-3 py-1 border rounded hover:bg-gray-100"
      //             onClick={() =>
      //               setCurrentPageInv((prev) => Math.min(prev + 1, totalPagesInv))
      //             }
      //             disabled={currentPageInv === totalPagesInv}
      //           >
      //             Next
      //           </button>
      //         </div>
      //       </div>

      //     </div>
      //   </>
      // )}


      

  //     {activeSection === "meeting-attendance" && (
  //       <div className='p-5'>
  //         <h2>Meeting Attendance List Report</h2>
  //         {/* <div style={{ marginTop: '20px' }}>
  //   <PDFDownloadLink
  //     document={
  //       <MeetingAttendancePDF
  //         selectedDate={selectedDate}
  //         selectedVenue={selectedVenue}
  //         selectedMeetingDetails={selectedMeetingDetails}
  //         invitationsget={invitationsget}
  //         getUserNameById={getUserNameById}
  //       />
  //     }
  //     fileName={`Meeting_Report_${new Date(selectedDate).toLocaleDateString()}.pdf`}
  //     style={{
  //       textDecoration: 'none',
  //       padding: '10px 20px',
  //       color: '#fff',
  //       backgroundColor: '#007bff',
  //       borderRadius: 4,
  //     }}
  //   >
  //     {({ loading }) => (loading ? 'Generating PDF...' : 'Download PDF')}
  //   </PDFDownloadLink>
  // </div> */}
  //         <div style={{ marginTop: '20px' }}>
  //           <PDFDownloadLink
  //             document={
  //               <MeetingAttendancePDF
  //                 selectedDate={selectedDate}
  //                 selectedVenue={selectedVenue}
  //                 selectedMeetingDetails={selectedMeetingDetails}
  //                 invitationsget={invitationsget}
  //                 getUserNameById={getUserNameById}
  //               />
  //             }
  //             fileName={`Meeting_Report_${new Date(selectedDate).toLocaleDateString()}.pdf`}
  //             style={{
  //               textDecoration: 'none',
  //               padding: '10px 20px',
  //               color: '#fff',
  //               backgroundColor: '#007bff',
  //               borderRadius: 4,
  //             }}
  //           >
  //             {({ loading }) => (loading ? 'Generating PDF...' : 'Download PDF')}
  //           </PDFDownloadLink>
  //         </div>

  //         <button type="button" className='m-3' onClick={closeModallAtt}>Reset</button>





  //         <>
  //           <div style={{ display: 'flex', alignItems: 'center' }}>
  //             <div style={{ marginRight: '10px' }}>
  //               <label htmlFor="dateDropdown">Select Date:</label>
  //               <select
  //                 id="dateDropdown"
  //                 value={selectedDate}
  //                 onChange={handleDateChange}
  //                 style={{
  //                   width: '150px',
  //                   padding: '8px',
  //                   borderRadius: '8px',
  //                   fontSize: '14px',
  //                   overflowY: 'auto',
  //                   maxHeight: '200px',

  //                 }}
  //               >
  //                 <option value="">Select a date</option>
  //                 {uniqueDates.map((date) => (
  //                   <option key={date} value={date}>
  //                     {new Date(date).toLocaleDateString()}
  //                   </option>
  //                 ))}
  //               </select>
  //             </div>

  //             {selectedDate && (
  //               <div>
  //                 <label htmlFor="venueDropdown">Select Venue:</label>
  //                 <select
  //                   id="venueDropdown"
  //                   value={selectedVenue}
  //                   onChange={handleVenueChange}
  //                   style={{
  //                     width: '150px',
  //                     padding: '8px',
  //                     borderRadius: '8px',
  //                     fontSize: '14px',
  //                   }}
  //                 >
  //                   <option value="">Select a venue</option>
  //                   {venuesForSelectedDate.map((venue, index) => (
  //                     <option key={index} value={venue}>
  //                       {venue}
  //                     </option>
  //                   ))}
  //                 </select>
  //               </div>
  //             )}
  //           </div>

  //           {selectedVenue && selectedMeetingDetails.length > 0 && (
  //             <div>
  //               <h3>Meeting Details:</h3>
  //               <table style={{ width: '100%', borderCollapse: 'collapse' }}>
  //                 <thead>
  //                   <tr>
  //                     <th style={{ border: '1px solid black', padding: '10px' }}>USERID</th>

  //                     <th style={{ border: '1px solid black', padding: '10px' }}>User Email</th>

  //                     <th style={{ border: '1px solid black', padding: '10px' }}>Response</th>
  //                     {/* <th style={{ border: '1px solid black', padding: '10px' }}>  Action</th> */}

  //                   </tr>
  //                 </thead>
  //                 <tbody>
  //                   {selectedMeetingDetails.map((meeting, index) => {

  //                     const user = users.find((user) => user.id === meeting.user_id);
  //                     const isMeetingExpired = new Date(meeting.date) < new Date(); // Check if meeting is expired
  //                     let responseText = meeting.response === 'yes' ? 'Attended' : 'Not Attended';

  //                     // If meeting is expired, update response to Present or Absent
  //                     if (isMeetingExpired) {
  //                       responseText = meeting.response === 'yes' ? 'Present' : 'Absent';
  //                     }


  //                     return (
  //                       <tr key={index}>
  //                         <td style={{ border: '1px solid black', padding: '8px' }}>{user ? user.name : 'Unknown'}</td>
  //                         <td style={{ border: '1px solid black', padding: '8px' }}>{meeting.user_email}</td>

  //                         <td style={{ border: '1px solid black', padding: '8px', color: meeting.response === 'yes' ? 'green' : 'red' }}>
  //                           {/* {meeting.response === 'yes' ? 'Attending' : 'Not Attending'} */}
  //                           {responseText}
  //                         </td>
  //                         {/* <td style={{ border: '1px solid black', padding: '8px' }}>
                         
  //                             <label>
  //                               <input
  //                                 type="checkbox"
  //                                 checked={meetingResponses[meeting.user_id] === 'yes'}
  //                                 onChange={() => handleResponseChange(meeting.user_id, 'yes')}
  //                               />
  //                               Yes
  //                             </label>

                           
  //                             <label>
  //                               <input
  //                                 type="checkbox"
  //                                 checked={meetingResponses[meeting.user_id] === 'no'}
  //                                 onChange={() => handleResponseChange(meeting.user_id, 'no')}
  //                               />
  //                               No
  //                             </label>
  //                           </td> */}

  //                       </tr>
  //                     );
  //                   })}
  //                 </tbody>
  //               </table>
  //               {/* <button onClick={handleUpdateResponse}>Submit</button> */}
  //             </div>
  //           )}


  //           {selectedMeetingDetails.length > 0 && (
  //             <div style={{ marginTop: '30px' }}>
  //               <h3>Visitor Invitations:</h3>
  //               <table style={{ width: '100%', borderCollapse: 'collapse' }}>
  //                 <thead>
  //                   <tr>
  //                     <th style={{ border: '1px solid black', padding: '10px' }}>Visitor Invite Sender </th>
  //                     <th style={{ border: '1px solid black', padding: '10px' }}>Visitor Name</th>
  //                     <th style={{ border: '1px solid black', padding: '10px' }}>Email</th>
  //                     <th style={{ border: '1px solid black', padding: '10px' }}>Mobile</th>
  //                     <th style={{ border: '1px solid black', padding: '10px' }}>Response</th>

  //                   </tr>
  //                 </thead>
  //                 <tbody>
  //                   {invitationsget
  //                     .filter(invite => invite.meeting_id === selectedMeetingDetails[0]?.meeting_id)
  //                     .map((invite, index) => (

  //                       <tr key={index}>
  //                         <td style={{ border: '1px solid black', padding: '8px' }}>{getUserNameById(invite.userId)}</td>

  //                         <td style={{ border: '1px solid black', padding: '8px' }}>{invite.visitor_name}</td>
  //                         <td style={{ border: '1px solid black', padding: '8px' }}>{invite.visitor_email}</td>
  //                         <td style={{ border: '1px solid black', padding: '8px' }}>{invite.visitor_mobile}</td>
  //                         <td style={{ border: '1px solid black', padding: '8px', color: invite.response === 'yes' ? 'green' : invite.response === 'no' ? 'red' : 'gray' }}>
  //                           {invite.response ? (invite.response === 'yes' ? 'Attended' : 'Not Attended') : 'Pending'}
  //                         </td>

  //                       </tr>
  //                     ))}
  //                 </tbody>
  //               </table>

  //             </div>
  //           )}
  //         </>





  //       </div>
  //     )}

  //     {activeSection === "event-attendance" && (
  //       <div className='p-5'>
  //         <h2>Event Attendance List</h2>
  //         <button type="button" className='m-3' onClick={closeModallEventAtt}>Reset</button>





  //         <>
  //           <div style={{ display: 'flex', alignItems: 'center' }}>
  //             <div style={{ marginRight: '10px' }}>
  //               <label htmlFor="dateDropdown">Select Date:</label>
  //               <select
  //                 id="dateDropdown"
  //                 value={selectedEventDate}
  //                 onChange={handleDateEventChange}
  //                 style={{
  //                   width: '150px',
  //                   padding: '8px',
  //                   borderRadius: '8px',
  //                   fontSize: '14px',
  //                   overflowY: 'auto',
  //                   maxHeight: '200px',

  //                 }}
  //               >
  //                 <option value="">Select Event date</option>
  //                 {uniqueEventDates.map((date) => (
  //                   <option key={date} value={date}>
  //                     {new Date(date).toLocaleDateString()}
  //                   </option>
  //                 ))}
  //               </select>
  //             </div>

  //             {selectedEventDate && (
  //               <div>
  //                 <label htmlFor="venueDropdown">Select Venue:</label>
  //                 <select
  //                   id="venueDropdown"
  //                   value={selectedEventVenue}
  //                   onChange={handleEventVenueChange}
  //                   style={{
  //                     width: '150px',
  //                     padding: '8px',
  //                     borderRadius: '8px',
  //                     fontSize: '14px',
  //                   }}
  //                 >
  //                   <option value="">Select a venue</option>
  //                   {venuesEventForSelectedDate.map((venue, index) => (
  //                     <option key={index} value={venue}>
  //                       {venue}
  //                     </option>
  //                   ))}
  //                 </select>
  //               </div>
  //             )}

  //             {selectedEventVenue && (
  //               <div>
  //                 <label htmlFor="venueDropdown">Select Event:</label>
  //                 <select
  //                   id="venueDropdown"
  //                   value={selectedEvents}
  //                   onChange={handleEventChange}
  //                   style={{
  //                     width: '150px',
  //                     padding: '8px',
  //                     borderRadius: '8px',
  //                     fontSize: '14px',
  //                   }}
  //                 >
  //                   <option value="">Select a evnte </option>
  //                   {EventForSelectedDate.map((venue, index) => (
  //                     <option key={index} value={venue}>
  //                       {venue}
  //                     </option>
  //                   ))}
  //                 </select>
  //               </div>
  //             )}
  //           </div>


  //           {selectedEvents && selectedEventDetails.length > 0 && (
  //             <div>
  //               <h3>Event Details:</h3>
  //               <table style={{ width: '100%', borderCollapse: 'collapse' }}>
  //                 <thead>
  //                   <tr>
  //                     <th style={{ border: '1px solid black', padding: '10px' }}>USERID</th>

  //                     <th style={{ border: '1px solid black', padding: '10px' }}>User Email</th>

  //                     <th style={{ border: '1px solid black', padding: '10px' }}>Response</th>
  //                     {/* <th style={{ border: '1px solid black', padding: '10px' }}>  Action</th> */}

  //                   </tr>
  //                 </thead>
  //                 <tbody>
  //                   {selectedEventDetails.map((event, index) => {
  //                     const user = users.find(user => user.id === event.user_id);
  //                     return (
  //                       <tr key={index}>
  //                         <td style={{ border: '1px solid black', padding: '8px' }}>{user ? user.name : 'Unknown'}</td>
  //                         <td style={{ border: '1px solid black', padding: '8px' }}>{event.user_email}</td>

  //                         <td style={{ border: '1px solid black', padding: '8px', color: event.response === 'yes' ? 'green' : 'red' }}>
  //                           {event.response === 'yes' ? 'Attended' : 'Not Attended'}
  //                         </td>
  //                         {/* <td style={{ border: '1px solid black', padding: '8px' }}>
                             
  //                             <label>
  //                               <input
  //                                 type="checkbox"
  //                                 checked={eventResponses[event.user_id] === 'yes'}
  //                                 onChange={() => handleEventResponseChange(event.user_id, 'yes')}
  //                               />
  //                               Yes
  //                             </label>

                              
  //                             <label>
  //                               <input
  //                                 type="checkbox"
  //                                 checked={eventResponses[event.user_id] === 'no'}
  //                                 onChange={() => handleEventResponseChange(event.user_id, 'no')}
  //                               />
  //                               No
  //                             </label>
  //                           </td> */}

  //                       </tr>
  //                     );
  //                   })}
  //                 </tbody>
  //               </table>
  //               {/* <button onClick={handleUpdateEventResponse}>Submit</button> */}
  //             </div>
  //           )}

  //         </>
  //       </div>
  //     )}
